// ========================================
// COLLECTION PRODUCTS BLOCK JAVASCRIPT
// ========================================

// Get current product ID from URL or page context
function getCurrentProductId() {
  // Try to get product ID from URL path
  const pathMatch = window.location.pathname.match(/\/products\/([^\/\?]+)/);
  if (pathMatch) {
    const productHandle = pathMatch[1];
    // Find the product ID by matching the handle
    const productItem = document.querySelector(`[data-product-handle="${productHandle}"]`);
    if (productItem) {
      return productItem.dataset.productId;
    }
  }
  
  // Fallback to localStorage if no URL match
  return localStorage.getItem('bk-media-selected-product');
}

document.addEventListener('DOMContentLoaded', function() {
    
    // Check for current product and apply styling
    function applySelectedProductStyling() {
      const currentProductId = getCurrentProductId();
      if (currentProductId) {
        const selectedItem = document.querySelector(`[data-product-id="${currentProductId}"]`);
        if (selectedItem) {
          // Remove selected class from all products first
          document.querySelectorAll('.bk-media-collection-products__item').forEach(item => {
            item.classList.remove('selected');
          });
          // Add selected class to the current product
          selectedItem.classList.add('selected');
          
          // Update localStorage with current product
          localStorage.setItem('bk-media-selected-product', currentProductId);
        }
      }
    }
    
    // Apply selected product styling on page load
    applySelectedProductStyling();
    
    // Handle collection products block interactions
    const collectionProducts = document.querySelectorAll('.bk-media-collection-products__item');
    
    collectionProducts.forEach(item => {
      const link = item.querySelector('.bk-media-collection-products__link');
      
      if (link && link.dataset.action === 'select-product') {
        link.addEventListener('click', function(e) {
          e.preventDefault();
          
          const productItem = this.closest('.bk-media-collection-products__item');
          const productId = productItem.dataset.productId;
          const productHandle = productItem.dataset.productHandle;
          
          // Store selected product ID in localStorage
          if (productId) {
            localStorage.setItem('bk-media-selected-product', productId);
          }
          
          // Remove selected class from all products
          document.querySelectorAll('.bk-media-collection-products__item').forEach(item => {
            item.classList.remove('selected');
          });
          
          // Add selected class to clicked product
          productItem.classList.add('selected');
          
          // Add click feedback
          this.style.transform = 'scale(0.98)';
          setTimeout(() => {
            this.style.transform = '';
          }, 150);
          
          // Navigate to product PDP when selected with a small delay to show selection
          if (productHandle) {
            setTimeout(() => {
              window.location.href = `/products/${productHandle}`;
            }, 200);
          }
        });
      }
    });
    
    // Initialize collection products in collapsed state and handle toggle functionality
    const collectionBlocks = document.querySelectorAll('.bk-media-collection-products');
    
    collectionBlocks.forEach(block => {
      const grid = block.querySelector('.bk-media-collection-products__grid');
      const items = grid.querySelectorAll('.bk-media-collection-products__item');
      const toggleButton = block.querySelector('.bk-media-collection-products__toggle-btn');
      
      if (grid && items.length > 0 && toggleButton) {
        const rowsToShow = parseInt(grid.dataset.rowsToShow) || 2;
        const productsPerRow = parseInt(grid.dataset.productsPerRowDesktop) || 4;
        const totalToShow = rowsToShow * productsPerRow;
        
        // Initially hide items beyond the limit
        items.forEach((item, index) => {
          if (index >= totalToShow) {
            item.classList.add('hidden');
            item.style.display = 'none';
          }
        });
        
        // Set initial button state
        toggleButton.dataset.action = 'show-more';
        const toggleText = toggleButton.querySelector('.bk-media-collection-products__toggle-text').textContent;
        toggleButton.querySelector('.bk-media-collection-products__toggle-icon').style.transform = 'rotate(0deg)';
        
        // Add click event listener
        toggleButton.addEventListener('click', function() {
          const isExpanded = this.dataset.action === 'show-less';
          
          if (isExpanded) {
            // Collapse - hide items beyond the initial limit
            items.forEach((item, index) => {
              if (index >= totalToShow) {
                item.classList.add('hidden');
                item.style.display = 'none';
              }
            });
            
            // Update button to show-more
            this.dataset.action = 'show-more';
            this.querySelector('.bk-media-collection-products__toggle-text').textContent = toggleText;
            this.querySelector('.bk-media-collection-products__toggle-icon').style.transform = 'rotate(0deg)';
          } else {
            // Expand - show all items
            items.forEach(item => {
              item.classList.remove('hidden');
              item.style.display = '';
            });
            
            // Update button to show-less
            this.dataset.action = 'show-less';
            this.querySelector('.bk-media-collection-products__toggle-text').textContent = 'Weniger anzeigen';
            this.querySelector('.bk-media-collection-products__toggle-icon').style.transform = 'rotate(180deg)';
          }
        });
      }
    });
    
    // Re-initialize collection products when sections are loaded dynamically
    document.addEventListener('shopify:section:load', function(event) {
      if (event.target.classList.contains('shopify-section--product-information')) {
        // Re-initialize collection products in the newly loaded section
        const newCollectionBlocks = event.target.querySelectorAll('.bk-media-collection-products');
        
        newCollectionBlocks.forEach(block => {
          const grid = block.querySelector('.bk-media-collection-products__grid');
          const items = grid.querySelectorAll('.bk-media-collection-products__item');
          const toggleButton = block.querySelector('.bk-media-collection-products__toggle-btn');
          
          if (grid && items.length > 0 && toggleButton) {
            const rowsToShow = parseInt(grid.dataset.rowsToShow) || 2;
            const productsPerRow = parseInt(grid.dataset.productsPerRowDesktop) || 4;
            const totalToShow = rowsToShow * productsPerRow;
            
            // Initially hide items beyond the limit
            items.forEach((item, index) => {
              if (index >= totalToShow) {
                item.classList.add('hidden');
                item.style.display = 'none';
              }
            });
            
            // Set initial button state
            toggleButton.dataset.action = 'show-more';
            const toggleText = toggleButton.querySelector('.bk-media-collection-products__toggle-text').textContent;
            toggleButton.querySelector('.bk-media-collection-products__toggle-icon').style.transform = 'rotate(0deg)';
            
            // Add click event listener
            toggleButton.addEventListener('click', function() {
              const isExpanded = this.dataset.action === 'show-less';
              
              if (isExpanded) {
                // Collapse - hide items beyond the initial limit
                items.forEach((item, index) => {
                  if (index >= totalToShow) {
                    item.classList.add('hidden');
                    item.style.display = 'none';
                  }
                });
                
                // Update button to show-more
                this.dataset.action = 'show-more';
                this.querySelector('.bk-media-collection-products__toggle-text').textContent = toggleText;
                this.querySelector('.bk-media-collection-products__toggle-icon').style.transform = 'rotate(0deg)';
              } else {
                // Expand - show all items
                items.forEach(item => {
                  item.classList.remove('hidden');
                  item.style.display = '';
                });
                
                // Update button to show-less
                this.dataset.action = 'show-less';
                this.querySelector('.bk-media-collection-products__toggle-text').textContent = 'Weniger anzeigen';
                this.querySelector('.bk-media-collection-products__toggle-icon').style.transform = 'rotate(180deg)';
              }
            });
          }
      });
    }
  });
});

// ========================================
// COLLECTION DISCOUNT CODE FUNCTIONALITY
// ========================================

(function() {
  'use strict';

  let appliedDiscountCode = null;
  let discountType = null;
  let discountValue = null;

  function extractDiscountInfo(code) {
    const upperCode = code.toUpperCase();
    
    const percentMatch = upperCode.match(/(\d+)$/);
    if (percentMatch) {
      const value = parseInt(percentMatch[1]);
      return {
        type: 'percentage',
        value: value
      };
    }
    
    return null;
  }
  
  function detectDiscountFromCart(silent = false) {
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        const cartState = JSON.stringify({
          items: cart.item_count,
          discount: cart.cart_level_discount_applications?.[0]?.title || null
        });
        
        if (cartState === lastCartCheck && silent) {
          return;
        }
        
        lastCartCheck = cartState;
        
        if (cart.cart_level_discount_applications && cart.cart_level_discount_applications.length > 0) {
          const discount = cart.cart_level_discount_applications[0];
          
          appliedDiscountCode = discount.title;
          
          if (discount.value_type === 'percentage') {
            discountType = 'percentage';
            discountValue = parseFloat(discount.value);
            updateProductCardPrices();
            updateProductPagePrice();
          } else if (discount.value_type === 'fixed_amount') {
            discountType = 'fixed';
            discountValue = parseFloat(discount.value) / 100;
            updateProductCardPrices();
            updateProductPagePrice();
          }
        } else {
          if (appliedDiscountCode) {
            appliedDiscountCode = null;
            discountType = null;
            discountValue = null;
            resetProductCardPrices();
            resetProductPagePrice();
          }
        }
      })
      .catch(error => {
        console.error('Error fetching cart:', error);
      });
  }

  function formatMoney(cents) {
    const currency = window.Shopify?.currency?.active || 'EUR';
    const amount = (cents / 100).toFixed(2);
    
    if (window.Shopify?.currency?.rate && window.Shopify.currency.rate !== 1) {
      const convertedAmount = (amount * window.Shopify.currency.rate).toFixed(2);
      return `${convertedAmount} ${currency}`;
    }
    
    return `€${amount}`;
  }

  function calculateDiscountedPrice(originalPrice, discountType, discountValue) {
    if (discountType === 'percentage') {
      const discountedPrice = originalPrice * (1 - discountValue / 100);
      return Math.ceil(discountedPrice);
    } else if (discountType === 'fixed') {
      const fixedDiscountCents = Math.round(discountValue * 100);
      return Math.max(0, originalPrice - fixedDiscountCents);
    }
    return originalPrice;
  }

  function updateProductCardPrices() {
    if (!appliedDiscountCode || !discountType || !discountValue) {
      resetProductCardPrices();
      return;
    }

    const container = document.querySelector('[data-show-discount-code-badges]');
    if (container) {
      const showBadges = container.getAttribute('data-show-discount-code-badges');
      if (showBadges === 'false') {
        return;
      }
    }

    const productCards = document.querySelectorAll('product-card[data-product-price]');
    
    productCards.forEach(card => {
      const originalPrice = parseInt(card.getAttribute('data-product-price'));
      
      if (!originalPrice) return;

      const discountedPrice = calculateDiscountedPrice(originalPrice, discountType, discountValue);
      
      const priceList = card.querySelector('price-list');
      if (!priceList) return;

      const salePrice = priceList.querySelector('sale-price');
      const existingComparePrice = priceList.querySelector('compare-at-price');
      
      const isComparePriceHidden = existingComparePrice && existingComparePrice.hasAttribute('hidden');
      const isComparePriceVisible = existingComparePrice && !isComparePriceHidden;
      
      let displayedComparePrice = null;
      if (isComparePriceVisible && existingComparePrice) {
        const compareText = existingComparePrice.textContent.replace(/[^\d.,]/g, '').replace(',', '.');
        const compareCents = Math.round(parseFloat(compareText) * 100);
        if (!isNaN(compareCents) && compareCents > originalPrice) {
          displayedComparePrice = compareCents;
        }
      }
      
      card.setAttribute('data-had-original-compare', displayedComparePrice ? 'true' : 'false');
      if (displayedComparePrice) {
        card.setAttribute('data-original-compare-value', displayedComparePrice);
      }
      
      if (salePrice) {
        const srOnly = salePrice.querySelector('.sr-only');
        const srOnlyText = srOnly ? srOnly.outerHTML : '';
        
        const discountPercentage = discountType === 'percentage' ? discountValue : Math.round((originalPrice - discountedPrice) / originalPrice * 100);
        
        const existingBadge = salePrice.querySelector('.bk-media-discount-badge');
        if (existingBadge) {
          existingBadge.remove();
        }
        
        let wrapper = salePrice.querySelector('.bk-media-price-with-badge');
        if (!wrapper) {
          wrapper = document.createElement('span');
          wrapper.className = 'bk-media-price-with-badge';
        }
        
        wrapper.innerHTML = srOnlyText + formatMoney(discountedPrice) + 
          '<span class="bk-media-discount-badge">-' + Math.round(discountPercentage) + '%</span>';
        
        salePrice.innerHTML = '';
        salePrice.appendChild(wrapper);
        salePrice.classList.remove('text-subdued');
        salePrice.classList.add('text-on-sale');
      }
      
      if (!existingComparePrice) {
        const newComparePrice = document.createElement('compare-at-price');
        newComparePrice.className = 'text-subdued line-through';
        newComparePrice.innerHTML = '<span class="sr-only">Regular price</span>' + formatMoney(originalPrice);
        priceList.insertBefore(newComparePrice, salePrice.nextSibling);
      } else {
        existingComparePrice.innerHTML = '<span class="sr-only">Regular price</span>' + formatMoney(originalPrice);
        existingComparePrice.removeAttribute('hidden');
      }

      card.setAttribute('data-discount-applied', 'true');
    });
  }

  function resetProductCardPrices() {
    const productCards = document.querySelectorAll('product-card[data-discount-applied="true"]');
    
    productCards.forEach(card => {
      const originalPrice = parseInt(card.getAttribute('data-product-price'));
      const hadOriginalCompare = card.getAttribute('data-had-original-compare') === 'true';
      const storedCompareValue = parseInt(card.getAttribute('data-original-compare-value'));
      
      if (!originalPrice) return;

      const priceList = card.querySelector('price-list');
      if (!priceList) return;

      const salePrice = priceList.querySelector('sale-price');
      const comparePrice = priceList.querySelector('compare-at-price');
      
      if (salePrice) {
        const srOnly = salePrice.querySelector('.sr-only');
        const srOnlyText = srOnly ? srOnly.outerHTML : '';
        
        const badge = salePrice.querySelector('.bk-media-discount-badge');
        if (badge) {
          badge.remove();
        }
        
        const wrapper = salePrice.querySelector('.bk-media-price-with-badge');
        if (wrapper) {
          wrapper.remove();
        }
        
        salePrice.innerHTML = srOnlyText + formatMoney(originalPrice);
        
        if (hadOriginalCompare) {
          salePrice.classList.remove('text-subdued');
          salePrice.classList.add('text-on-sale');
        } else {
          salePrice.classList.remove('text-on-sale');
          salePrice.classList.add('text-subdued');
        }
      }
      
      if (comparePrice) {
        if (hadOriginalCompare && storedCompareValue) {
          comparePrice.innerHTML = '<span class="sr-only">Regular price</span>' + formatMoney(storedCompareValue);
          comparePrice.removeAttribute('hidden');
        } else {
          comparePrice.remove();
        }
      }

      card.removeAttribute('data-discount-applied');
      card.removeAttribute('data-had-original-compare');
      card.removeAttribute('data-original-compare-value');
    });
  }

  function updateProductPagePrice() {
    if (!appliedDiscountCode || !discountType || !discountValue) {
      resetProductPagePrice();
      return;
    }

    const productInfoPrice = document.querySelector('.product-info__price');
    if (productInfoPrice) {
      const showBadges = productInfoPrice.getAttribute('data-show-discount-code-badges');
      if (showBadges === 'false') {
        return;
      }
    }

    const productInfoPriceList = document.querySelector('.product-info__price price-list');
    if (!productInfoPriceList) {
      return;
    }

    const salePrice = productInfoPriceList.querySelector('sale-price');
    if (!salePrice) {
      return;
    }

    let originalPrice;
    if (productInfoPriceList.hasAttribute('data-original-price')) {
      originalPrice = parseInt(productInfoPriceList.getAttribute('data-original-price'));
    } else {
      const wrapper = salePrice.querySelector('.bk-media-price-with-badge');
      let priceText;
      if (wrapper) {
        const badge = wrapper.querySelector('.bk-media-discount-badge');
        const clone = wrapper.cloneNode(true);
        if (badge) {
          clone.querySelector('.bk-media-discount-badge')?.remove();
        }
        clone.querySelector('.sr-only')?.remove();
        priceText = clone.textContent;
      } else {
        priceText = salePrice.textContent;
        const srOnly = salePrice.querySelector('.sr-only');
        if (srOnly) {
          priceText = priceText.replace(srOnly.textContent, '');
        }
      }
      const salePriceText = priceText.replace(/[^\d.,]/g, '').replace(',', '.');
      originalPrice = Math.round(parseFloat(salePriceText) * 100);
    }
    
    if (!originalPrice || isNaN(originalPrice)) {
      return;
    }

    const discountedPrice = calculateDiscountedPrice(originalPrice, discountType, discountValue);
    const existingComparePrice = productInfoPriceList.querySelector('compare-at-price');
    
    const isComparePriceHidden = existingComparePrice && existingComparePrice.hasAttribute('hidden');
    const isComparePriceVisible = existingComparePrice && !isComparePriceHidden;
    
    let displayedComparePrice = null;
    if (isComparePriceVisible && existingComparePrice) {
      const compareText = existingComparePrice.textContent.replace(/[^\d.,]/g, '').replace(',', '.');
      const compareCents = Math.round(parseFloat(compareText) * 100);
      if (!isNaN(compareCents) && compareCents > originalPrice) {
        displayedComparePrice = compareCents;
      }
    }

    if (!productInfoPriceList.hasAttribute('data-original-price')) {
      productInfoPriceList.setAttribute('data-original-price', originalPrice);
    }
    productInfoPriceList.setAttribute('data-had-original-compare', displayedComparePrice ? 'true' : 'false');
    if (displayedComparePrice) {
      productInfoPriceList.setAttribute('data-original-compare-value', displayedComparePrice);
    }

    const srOnly = salePrice.querySelector('.sr-only');
    const srOnlyText = srOnly ? srOnly.outerHTML : '';
    
    const discountPercentage = discountType === 'percentage' ? discountValue : Math.round((originalPrice - discountedPrice) / originalPrice * 100);
    const savingsLayout = productInfoPriceList.getAttribute('data-layout') === 'savings';

    if (savingsLayout) {
      salePrice.innerHTML = srOnlyText + formatMoney(discountedPrice);
      const savings = productInfoPriceList.querySelector('bk-media-price-savings');
      if (savings) {
        savings.hidden = false;
        savings.textContent = '-' + Math.round(discountPercentage) + '%';
      }
    } else {
      const existingBadge = salePrice.querySelector('.bk-media-discount-badge');
      if (existingBadge) {
        existingBadge.remove();
      }

      let wrapper = salePrice.querySelector('.bk-media-price-with-badge');
      if (!wrapper) {
        wrapper = document.createElement('span');
        wrapper.className = 'bk-media-price-with-badge';
      }

      wrapper.innerHTML = srOnlyText + formatMoney(discountedPrice) +
        '<span class="bk-media-discount-badge">-' + Math.round(discountPercentage) + '%</span>';

      salePrice.innerHTML = '';
      salePrice.appendChild(wrapper);
      salePrice.classList.remove('text-subdued');
      salePrice.classList.add('text-on-sale');
    }

    if (!existingComparePrice) {
      const newComparePrice = document.createElement('compare-at-price');
      newComparePrice.className = 'text-subdued line-through';
      newComparePrice.innerHTML = '<span class="sr-only">Regular price</span>' + formatMoney(originalPrice);
      productInfoPriceList.insertBefore(newComparePrice, salePrice.nextSibling);
    } else {
      existingComparePrice.innerHTML = '<span class="sr-only">Regular price</span>' + formatMoney(originalPrice);
      existingComparePrice.removeAttribute('hidden');
    }

    productInfoPriceList.setAttribute('data-discount-applied', 'true');
  }

  function resetProductPagePrice() {
    const productInfoPriceList = document.querySelector('.product-info__price price-list[data-discount-applied="true"]');
    
    if (!productInfoPriceList) {
      return;
    }

    const originalPrice = parseInt(productInfoPriceList.getAttribute('data-original-price'));
    const hadOriginalCompare = productInfoPriceList.getAttribute('data-had-original-compare') === 'true';
    const storedCompareValue = parseInt(productInfoPriceList.getAttribute('data-original-compare-value'));
    
    if (!originalPrice) {
      return;
    }

    const salePrice = productInfoPriceList.querySelector('sale-price');
    const comparePrice = productInfoPriceList.querySelector('compare-at-price');
    
    if (salePrice) {
      const srOnly = salePrice.querySelector('.sr-only');
      const srOnlyText = srOnly ? srOnly.outerHTML : '';
      const savingsLayout = productInfoPriceList.getAttribute('data-layout') === 'savings';

      if (savingsLayout) {
        salePrice.innerHTML = srOnlyText + formatMoney(originalPrice);
        const savings = productInfoPriceList.querySelector('bk-media-price-savings');
        if (savings) {
          if (hadOriginalCompare && storedCompareValue > originalPrice) {
            const percent = Math.round((storedCompareValue - originalPrice) * 100 / storedCompareValue);
            savings.hidden = false;
            savings.textContent = '-' + percent + '%';
          } else {
            savings.hidden = true;
          }
        }
      } else {
        const badge = salePrice.querySelector('.bk-media-discount-badge');
        if (badge) {
          badge.remove();
        }

        const wrapper = salePrice.querySelector('.bk-media-price-with-badge');
        if (wrapper) {
          wrapper.remove();
        }

        salePrice.innerHTML = srOnlyText + formatMoney(originalPrice);

        if (hadOriginalCompare) {
          salePrice.classList.remove('text-subdued');
          salePrice.classList.add('text-on-sale');
        } else {
          salePrice.classList.remove('text-on-sale');
          salePrice.classList.add('text-subdued');
        }
      }
    }
    
    if (comparePrice) {
      if (hadOriginalCompare && storedCompareValue) {
        comparePrice.innerHTML = '<span class="sr-only">Regular price</span>' + formatMoney(storedCompareValue);
        comparePrice.removeAttribute('hidden');
      } else {
        comparePrice.setAttribute('hidden', '');
      }
    }

    productInfoPriceList.removeAttribute('data-discount-applied');
    productInfoPriceList.removeAttribute('data-original-price');
    productInfoPriceList.removeAttribute('data-had-original-compare');
    productInfoPriceList.removeAttribute('data-original-compare-value');
  }

  function attachDiscountListeners(input) {
    if (input.dataset.bkMediaListenerAttached) {
      return;
    }
    input.dataset.bkMediaListenerAttached = 'true';
    
    function handleDiscountInput() {
      const enteredCode = input.value.trim().toUpperCase();
      
      if (!enteredCode) {
        setTimeout(detectDiscountFromCart, 500);
        return;
      }
      
      setTimeout(detectDiscountFromCart, 1000);
      setTimeout(detectDiscountFromCart, 2000);
    }
    
    input.addEventListener('input', handleDiscountInput);
    input.addEventListener('change', handleDiscountInput);
    input.addEventListener('blur', handleDiscountInput);
    input.addEventListener('keyup', function(e) {
      if (e.key === 'Enter') {
        handleDiscountInput();
      }
    });
  }

  function watchDiscountInputs() {
    const selectors = [
      'input[name="discount"]',
      'input[name="coupon"]',
      'input[placeholder*="discount" i]',
      'input[placeholder*="coupon" i]',
      'input[placeholder*="rabatt" i]',
      'input[placeholder*="code" i]',
      'input[id*="discount"]',
      'input[id*="coupon"]'
    ];
    
    const findAndAttach = () => {
      const foundInputs = new Set();
      
      for (const selector of selectors) {
        const inputs = document.querySelectorAll(selector);
        inputs.forEach(input => {
          if (foundInputs.has(input)) {
            return;
          }
          foundInputs.add(input);
          
          if (!input.dataset.bkMediaListenerAttached) {
            attachDiscountListeners(input);
          }
        });
      }
    };
    
    findAndAttach();
    
    const checkInterval = setInterval(findAndAttach, 500);
    setTimeout(() => {
      clearInterval(checkInterval);
    }, 15000);
  }

  function observeCart() {
    const observer = new MutationObserver((mutations) => {
      let shouldCheck = false;
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === 1) {
            if (node.matches && (node.matches('cart-drawer') || node.matches('.cart-drawer'))) {
              shouldCheck = true;
            } else if (node.querySelector) {
              const hasCartDiscountInput = node.querySelector('input[name="discount"], input[id*="discount"], input[placeholder*="rabatt" i]');
              if (hasCartDiscountInput) {
                shouldCheck = true;
              }
            }
          }
        });
      });
      
      if (shouldCheck) {
        setTimeout(watchDiscountInputs, 100);
        setTimeout(watchDiscountInputs, 500);
        setTimeout(watchDiscountInputs, 1000);
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }
  
  function watchForCartOpen() {
    document.addEventListener('click', function(e) {
      const target = e.target;
      if (target.matches('[href*="cart"], [data-cart], .cart-button, [aria-controls*="cart"]') || 
          target.closest('[href*="cart"], [data-cart], .cart-button, [aria-controls*="cart"]')) {
        setTimeout(watchDiscountInputs, 300);
        setTimeout(watchDiscountInputs, 800);
        setTimeout(watchDiscountInputs, 1500);
        setTimeout(detectDiscountFromCart, 500);
      }
    });
    
    document.addEventListener('cart:updated', function() {
      setTimeout(detectDiscountFromCart, 500);
    });
    
    document.addEventListener('discount:applied', function() {
      setTimeout(detectDiscountFromCart, 500);
    });
    
    document.addEventListener('variant:change', function(event) {
      const productInfoPriceList = document.querySelector('.product-info__price price-list');
      if (productInfoPriceList) {
        productInfoPriceList.removeAttribute('data-original-price');
        productInfoPriceList.removeAttribute('data-discount-applied');
      }
      if (appliedDiscountCode && discountType && discountValue) {
        setTimeout(updateProductPagePrice, 300);
      }
    });
    
    const productForm = document.querySelector('form[id^="product-form"]');
    if (productForm) {
      productForm.addEventListener('change', function(event) {
        if (event.target.name === 'id' || event.target.closest('variant-picker')) {
          const productInfoPriceList = document.querySelector('.product-info__price price-list');
          if (productInfoPriceList) {
            productInfoPriceList.removeAttribute('data-original-price');
            productInfoPriceList.removeAttribute('data-discount-applied');
          }
          if (appliedDiscountCode && discountType && discountValue) {
            setTimeout(updateProductPagePrice, 400);
          }
        }
      });
    }
  }
  
  let lastCartCheck = null;
  
  function startCartPolling() {
    setInterval(() => {
      detectDiscountFromCart(true);
    }, 5000);
  }

  function init() {
    watchDiscountInputs();
    observeCart();
    watchForCartOpen();
    
    detectDiscountFromCart();
    
    startCartPolling();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
  
  // Handle section reloads for Shopify section editor
  document.addEventListener('shopify:section:load', function(event) {
    // Reinitialize collection products selection if it's a collection products block
    if (event.target.querySelector('.bk-media-collection-products')) {
      // Apply selected product styling for newly loaded sections using current product detection
      const currentProductId = getCurrentProductId();
      if (currentProductId) {
        const selectedItem = event.target.querySelector(`[data-product-id="${currentProductId}"]`);
        if (selectedItem) {
          // Remove selected class from all products in this section first
          event.target.querySelectorAll('.bk-media-collection-products__item').forEach(item => {
            item.classList.remove('selected');
          });
          // Add selected class to the current product
          selectedItem.classList.add('selected');
        }
      }
      const collectionProducts = event.target.querySelectorAll('.bk-media-collection-products__item');
      
      collectionProducts.forEach(item => {
        const link = item.querySelector('.bk-media-collection-products__link');
        
        if (link && link.dataset.action === 'select-product') {
          link.addEventListener('click', function(e) {
            e.preventDefault();
            
            const productItem = this.closest('.bk-media-collection-products__item');
            const productId = productItem.dataset.productId;
            const productHandle = productItem.dataset.productHandle;
            
            // Store selected product ID in localStorage
            if (productId) {
              localStorage.setItem('bk-media-selected-product', productId);
            }
            
            // Remove selected class from all products
            document.querySelectorAll('.bk-media-collection-products__item').forEach(item => {
              item.classList.remove('selected');
            });
            
            // Add selected class to clicked product
            productItem.classList.add('selected');
            
            // Add click feedback
            this.style.transform = 'scale(0.98)';
            setTimeout(() => {
              this.style.transform = '';
            }, 150);
            
            // Navigate to product PDP when selected with a small delay to show selection
            if (productHandle) {
              setTimeout(() => {
                window.location.href = `/products/${productHandle}`;
              }, 200);
            }
          });
        }
      });
    }

    // ========================================
    // BUTTON TIMER COUNTDOWN
    // ========================================
    
    function initButtonTimers() {
      const timerElements = document.querySelectorAll('.bk-media-button-timer-countdown');
      
      if (timerElements.length === 0) {
        return;
      }
      
      timerElements.forEach(timerElement => {
        // Skip if already initialized
        if (timerElement.dataset.initialized === 'true') {
          return;
        }
        
        const blockId = timerElement.dataset.blockId;
        const endDateString = timerElement.dataset.endDate;
        
        if (!endDateString || endDateString.trim() === '') {
          return;
        }
        
        // Parse the date string (format: YYYY-MM-DD HH:MM)
        let endTime;
        try {
          const trimmedDate = endDateString.trim();
          
          // Parse the date - explicitly handle local time
          const parts = trimmedDate.split(' ');
          if (parts.length !== 2) {
            return;
          }
          
          const datePart = parts[0].split('-');
          const timePart = parts[1].split(':');
          
          if (datePart.length !== 3 || timePart.length < 2) {
            return;
          }
          
          const year = parseInt(datePart[0], 10);
          const month = parseInt(datePart[1], 10) - 1; // Month is 0-indexed
          const day = parseInt(datePart[2], 10);
          const hour = parseInt(timePart[0], 10);
          const minute = parseInt(timePart[1], 10);
          const second = timePart[2] ? parseInt(timePart[2], 10) : 0;
          
          endTime = new Date(year, month, day, hour, minute, second).getTime();
          
          if (isNaN(endTime)) {
            return;
          }
        } catch (e) {
          return;
        }
        
        // Mark as initialized
        timerElement.dataset.initialized = 'true';
        
        function updateTimer() {
          const now = Date.now();
          const remaining = Math.max(0, endTime - now);
          
          if (remaining <= 0) {
            timerElement.textContent = '00:00:00';
            const wrapper = timerElement.closest('.bk-media-button-timer-wrapper');
            if (wrapper) {
              wrapper.style.display = 'none';
            }
            return;
          }
          
          const days = Math.floor(remaining / (1000 * 60 * 60 * 24));
          const hours = Math.floor((remaining % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
          const minutes = Math.floor((remaining % (1000 * 60 * 60)) / (1000 * 60));
          const seconds = Math.floor((remaining % (1000 * 60)) / 1000);
          
          const parts = [];
          if (days > 0) parts.push(`${days}T`);
          if (hours > 0 || days > 0) parts.push(`${hours}Std`);
          if (minutes > 0 || hours > 0 || days > 0) parts.push(`${minutes}Min`);
          parts.push(`${seconds}Sek`);
          
          timerElement.textContent = parts.join(' ');
        }
        
        updateTimer();
        const interval = setInterval(updateTimer, 1000);
        
        // Clean up interval if element is removed
        const observer = new MutationObserver(() => {
          if (!document.contains(timerElement)) {
            clearInterval(interval);
            observer.disconnect();
          }
        });
        observer.observe(document.body, { childList: true, subtree: true });
      });
    }
    
    initButtonTimers();
    
    document.addEventListener('shopify:section:load', function() {
      setTimeout(initButtonTimers, 100);
    });
    
    setTimeout(initButtonTimers, 500);
    setTimeout(initButtonTimers, 1000);
  });

// Initialize timer immediately if DOM is already loaded
(function() {
  function initButtonTimersStandalone() {
    const timerElements = document.querySelectorAll('.bk-media-button-timer-countdown:not([data-initialized="true"])');
    
    timerElements.forEach(timerElement => {
      const endDateString = timerElement.dataset.endDate;
      if (!endDateString || endDateString.trim() === '') return;
      
      try {
        const trimmedDate = endDateString.trim();
        const parts = trimmedDate.split(' ');
        if (parts.length !== 2) return;
        
        const datePart = parts[0].split('-');
        const timePart = parts[1].split(':');
        if (datePart.length !== 3 || timePart.length < 2) return;
        
        const year = parseInt(datePart[0], 10);
        const month = parseInt(datePart[1], 10) - 1;
        const day = parseInt(datePart[2], 10);
        const hour = parseInt(timePart[0], 10);
        const minute = parseInt(timePart[1], 10);
        const second = timePart[2] ? parseInt(timePart[2], 10) : 0;
        
        const endTime = new Date(year, month, day, hour, minute, second).getTime();
        if (isNaN(endTime)) return;
        
        timerElement.dataset.initialized = 'true';
        
        function updateTimer() {
          const now = Date.now();
          const remaining = Math.max(0, endTime - now);
          
          if (remaining <= 0) {
            timerElement.textContent = '00:00:00';
            const wrapper = timerElement.closest('.bk-media-button-timer-wrapper');
            if (wrapper) wrapper.style.display = 'none';
            return;
          }
          
                const days = Math.floor(remaining / (1000 * 60 * 60 * 24));
                const hours = Math.floor((remaining % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
                const minutes = Math.floor((remaining % (1000 * 60 * 60)) / (1000 * 60));
                const seconds = Math.floor((remaining % (1000 * 60)) / 1000);
                
                const parts = [];
                if (days > 0) parts.push(`${days}T`);
                if (hours > 0 || days > 0) parts.push(`${hours}Std`);
                if (minutes > 0 || hours > 0 || days > 0) parts.push(`${minutes}Min`);
                parts.push(`${seconds}Sek`);
                
                timerElement.textContent = parts.join(' ');
        }
        
        updateTimer();
        setInterval(updateTimer, 1000);
      } catch (e) {}
    });
  }
  
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initButtonTimersStandalone);
  } else {
    initButtonTimersStandalone();
  }
  
  setTimeout(initButtonTimersStandalone, 500);
  setTimeout(initButtonTimersStandalone, 1500);
  
  document.addEventListener('shopify:section:load', function() {
    setTimeout(initButtonTimersStandalone, 100);
  });
})();

// ========================================
// SNOW EFFECT
// ========================================

(function() {
  'use strict';

  function isChristmasSalePage() {
    return window.location.pathname.includes('/pages/christmas-sale') || 
           window.location.pathname.includes('/pages/christmas');
  }

  function createSnowflake() {
    const snowflake = document.createElement('div');
    snowflake.className = 'bk-media-snowflake';
    snowflake.textContent = '❄';
    
    const size = Math.random() * 0.8 + 0.4;
    snowflake.style.fontSize = size + 'em';
    snowflake.style.left = Math.random() * 100 + '%';
    snowflake.style.opacity = Math.random() * 0.5 + 0.5;
    snowflake.style.color = '#ffffff';
    snowflake.style.setProperty('color', '#ffffff', 'important');
    snowflake.style.setProperty('-webkit-text-fill-color', '#ffffff', 'important');
    
    const fallDuration = Math.random() * 10 + 10;
    const drift = (Math.random() - 0.5) * 100;
    snowflake.style.setProperty('--snow-drift', drift + 'px');
    snowflake.style.animationDuration = fallDuration + 's';
    snowflake.style.animationDelay = Math.random() * 5 + 's';
    
    return snowflake;
  }

  function initSnowEffect() {
    if (!isChristmasSalePage()) {
      return;
    }

    let container = document.querySelector('.bk-media-snow-container');
    if (!container) {
      container = document.createElement('div');
      container.className = 'bk-media-snow-container';
      document.body.appendChild(container);
    }

    function addSnowflake() {
      if (!container || !isChristmasSalePage()) {
        return;
      }
      const snowflake = createSnowflake();
      container.appendChild(snowflake);

      setTimeout(() => {
        if (snowflake.parentNode) {
          snowflake.remove();
        }
      }, 25000);
    }

    const snowInterval = setInterval(() => {
      if (!isChristmasSalePage()) {
        clearInterval(snowInterval);
        if (container) {
          container.remove();
        }
        return;
      }
      addSnowflake();
    }, 1000);

    for (let i = 0; i < 5; i++) {
      setTimeout(() => addSnowflake(), i * 500);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSnowEffect);
  } else {
    initSnowEffect();
  }

  document.addEventListener('shopify:section:load', function() {
    setTimeout(initSnowEffect, 100);
  });
})();

/* ========================================
 TIMER BLOCK FUNCTIONALITY
 ======================================== */

function initTimerBlock(timerElement) {
  const daysEl = timerElement.querySelector('.bk-media-timer-block__timer-days');
  const hoursEl = timerElement.querySelector('.bk-media-timer-block__timer-hours');
  const minutesEl = timerElement.querySelector('.bk-media-timer-block__timer-minutes');
  const secondsEl = timerElement.querySelector('.bk-media-timer-block__timer-seconds');
  const timerBlock = timerElement.closest('.bk-media-timer-block');
  const progressBarFill = timerBlock ? timerBlock.querySelector('.bk-media-timer-block__progress-bar-fill') : null;
  
  if (!daysEl || !hoursEl || !minutesEl || !secondsEl) {
    console.warn('Timer block elements not found', timerElement);
    return;
  }
  
  const metaobjectDate = timerElement.getAttribute('data-metaobject-date') || '';
  const metaobjectStartDate = timerElement.getAttribute('data-metaobject-start-date') || '';
  const blockId = timerElement.dataset.blockId;
  
  let endTime;
  
  function parseCustomDate(dateString) {
    if (!dateString || dateString.trim() === '') return null;
    
    const trimmed = dateString.trim();

    if (/Z$|[+-]\d{2}:\d{2}$|[+-]\d{4}$|\sUTC$/i.test(trimmed)) {
      const utcDate = new Date(trimmed);
      if (!isNaN(utcDate.getTime())) {
        return utcDate.getTime();
      }
    }
    
    const yyyyFormat = /^(\d{4})-(\d{2})-(\d{2})\s+(\d{2}):(\d{2})(?::(\d{2}))?$/;
    const isoLocalFormat = /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2})(?::(\d{2}))?$/;
    const ddFormat = /^(\d{2})\.(\d{2})\.(\d{4})\s+(\d{2}):(\d{2})(?::(\d{2}))?$/;
    
    let match;
    let year, month, day, hour, minute, second = 0;
    
    if ((match = trimmed.match(yyyyFormat))) {
      year = parseInt(match[1]);
      month = parseInt(match[2]) - 1;
      day = parseInt(match[3]);
      hour = parseInt(match[4]);
      minute = parseInt(match[5]);
      second = match[6] ? parseInt(match[6]) : 0;
      
      const date = new Date(year, month, day, hour, minute, second);
      if (!isNaN(date.getTime())) {
        return date.getTime();
      }
    } else if ((match = trimmed.match(isoLocalFormat))) {
      year = parseInt(match[1]);
      month = parseInt(match[2]) - 1;
      day = parseInt(match[3]);
      hour = parseInt(match[4]);
      minute = parseInt(match[5]);
      second = match[6] ? parseInt(match[6]) : 0;
      
      const date = new Date(year, month, day, hour, minute, second);
      if (!isNaN(date.getTime())) {
        return date.getTime();
      }
    } else if ((match = trimmed.match(ddFormat))) {
      day = parseInt(match[1]);
      month = parseInt(match[2]) - 1;
      year = parseInt(match[3]);
      hour = parseInt(match[4]);
      minute = parseInt(match[5]);
      second = match[6] ? parseInt(match[6]) : 0;
      
      const date = new Date(year, month, day, hour, minute, second);
      if (!isNaN(date.getTime())) {
        return date.getTime();
      }
    }
    
    const parsed = new Date(trimmed);
    if (!isNaN(parsed.getTime())) {
      return parsed.getTime();
    }
    
    return null;
  }
  
  if (metaobjectDate && metaobjectDate.trim() !== '') {
    const parsedDate = parseCustomDate(metaobjectDate);
    if (parsedDate !== null) {
      endTime = parsedDate;
    } else {
      console.warn('Failed to parse metaobject date:', metaobjectDate);
      return;
    }
  } else {
    return;
  }
  
  function updateTimer() {
    const now = Date.now();
    let remaining = Math.max(0, Math.floor((endTime - now) / 1000));
    
    const days = Math.floor(remaining / 86400);
    remaining = remaining % 86400;
    const hours = Math.floor(remaining / 3600);
    remaining = remaining % 3600;
    const mins = Math.floor(remaining / 60);
    const secs = remaining % 60;
    
    daysEl.textContent = days;
    hoursEl.textContent = hours;
    minutesEl.textContent = mins;
    secondsEl.textContent = secs;
    
    if (progressBarFill) {
      if (metaobjectStartDate && metaobjectStartDate.trim() !== '') {
        const parsedStartDate = parseCustomDate(metaobjectStartDate);
        if (parsedStartDate !== null && endTime) {
          const calculatedStartTime = parsedStartDate;
          const totalDurationSeconds = Math.floor((endTime - parsedStartDate) / 1000);
          
          if (totalDurationSeconds > 0) {
            const elapsedSeconds = Math.max(0, Math.floor((now - calculatedStartTime) / 1000));
            const remainingSeconds = Math.max(0, totalDurationSeconds - elapsedSeconds);
            let progress = 0;
            
            if (elapsedSeconds <= totalDurationSeconds) {
              progress = (remainingSeconds / totalDurationSeconds) * 100;
            } else {
              progress = 0;
            }
            
            progressBarFill.style.width = Math.min(100, Math.max(0, progress)) + '%';
          }
        }
      }
    }
  }
  
  updateTimer();
  const interval = setInterval(updateTimer, 1000);
  
  timerElement.dataset.intervalId = interval;
}

function initTimerBlocks() {
  const timerBlocks = document.querySelectorAll('.bk-media-timer-block__timer');
  timerBlocks.forEach(timer => {
    const existingIntervalId = timer.dataset.intervalId;
    if (existingIntervalId) {
      clearInterval(parseInt(existingIntervalId));
      delete timer.dataset.intervalId;
    }
    
    timer.dataset.initialized = 'true';
    try {
      initTimerBlock(timer);
    } catch (error) {
      console.error('Error initializing timer block:', error, timer);
      timer.dataset.initialized = 'false';
    }
  });
}

function initTimerCopyButtons() {
  const copyButtons = document.querySelectorAll('.bk-media-timer-block__code-badge');
  
  copyButtons.forEach(button => {
    if (button.dataset.copyInitialized) return;
    button.dataset.copyInitialized = 'true';
    
    button.addEventListener('click', function() {
      const code = this.dataset.code;
      if (!code) return;
      
      const textEl = this.querySelector('.bk-media-timer-block__code-text');
      const originalText = textEl ? textEl.textContent : '';
      const originalBadgeText = this.textContent;
      
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(code).then(() => {
          if (textEl) {
            textEl.textContent = 'Kopiert!';
          } else {
            this.textContent = 'CODE: Kopiert!';
          }
          
          setTimeout(() => {
            if (textEl) {
              textEl.textContent = originalText;
            } else {
              this.textContent = originalBadgeText;
            }
          }, 2000);
        }).catch(err => {
          console.error('Failed to copy code:', err);
        });
      } else {
        const textArea = document.createElement('textarea');
        textArea.value = code;
        textArea.style.position = 'fixed';
        textArea.style.opacity = '0';
        document.body.appendChild(textArea);
        textArea.select();
        
        try {
          document.execCommand('copy');
          if (textEl) {
            textEl.textContent = 'Kopiert!';
          } else {
            this.textContent = 'CODE: Kopiert!';
          }
          
          setTimeout(() => {
            if (textEl) {
              textEl.textContent = originalText;
            } else {
              this.textContent = originalBadgeText;
            }
          }, 2000);
        } catch (err) {
          console.error('Failed to copy code:', err);
        } finally {
          document.body.removeChild(textArea);
        }
      }
    });
  });
}

function initializeTimerBlocks() {
  initTimerBlocks();
  initTimerCopyButtons();
  initTimerCelebration();
}

/* bk-media-timer-celebration start */

var timerCelebrationPlayed = false;
var timerCelebrationColors = ['#F9D354', '#DC5B5B', '#57FFFF', '#EC4899', '#124B3A', '#FFFFFF', '#FF6B35'];

function isTimerCelebrationEnabled() {
  return !!(window.themeVariables && window.themeVariables.settings && window.themeVariables.settings.enableSaleCelebration);
}

function isTimerCelebrationTestOnLoad() {
  return !!(window.themeVariables && window.themeVariables.settings && window.themeVariables.settings.saleCelebrationTestOnLoad);
}

function timerCelebrationRandom(min, max) {
  return min + Math.random() * (max - min);
}

function timerCelebrationPickColor() {
  return timerCelebrationColors[Math.floor(Math.random() * timerCelebrationColors.length)];
}

function timerCelebrationCreateConfetti(overlay) {
  var i;

  for (i = 0; i < 90; i++) {
    var piece = document.createElement('div');
    piece.className = 'bk-media-timer-celebration__confetti';
    piece.style.setProperty('--bk-confetti-left', timerCelebrationRandom(0, 100) + '%');
    piece.style.setProperty('--bk-confetti-color', timerCelebrationPickColor());
    piece.style.setProperty('--bk-confetti-w', timerCelebrationRandom(6, 12) + 'px');
    piece.style.setProperty('--bk-confetti-h', timerCelebrationRandom(8, 16) + 'px');
    piece.style.setProperty('--bk-confetti-drift', timerCelebrationRandom(-80, 80) + 'px');
    piece.style.setProperty('--bk-confetti-rot', timerCelebrationRandom(360, 1080) + 'deg');
    piece.style.setProperty('--bk-confetti-dur', timerCelebrationRandom(2.5, 4) + 's');
    piece.style.setProperty('--bk-confetti-delay', timerCelebrationRandom(0, 0.6) + 's');
    overlay.appendChild(piece);
  }

  for (i = 0; i < 30; i++) {
    var sway = document.createElement('div');
    sway.className = 'bk-media-timer-celebration__confetti bk-media-timer-celebration__confetti--sway';
    sway.style.setProperty('--bk-confetti-left', timerCelebrationRandom(0, 100) + '%');
    sway.style.setProperty('--bk-confetti-color', timerCelebrationPickColor());
    sway.style.setProperty('--bk-confetti-w', timerCelebrationRandom(6, 10) + 'px');
    sway.style.setProperty('--bk-confetti-h', timerCelebrationRandom(10, 18) + 'px');
    sway.style.setProperty('--bk-confetti-drift', timerCelebrationRandom(-60, 60) + 'px');
    sway.style.setProperty('--bk-confetti-sway', timerCelebrationRandom(30, 70) + 'px');
    sway.style.setProperty('--bk-confetti-rot', timerCelebrationRandom(360, 900) + 'deg');
    sway.style.setProperty('--bk-confetti-dur', timerCelebrationRandom(2.8, 4.2) + 's');
    sway.style.setProperty('--bk-confetti-delay', timerCelebrationRandom(0, 0.5) + 's');
    overlay.appendChild(sway);
  }

  for (i = 0; i < 35; i++) {
    var streamer = document.createElement('div');
    streamer.className = 'bk-media-timer-celebration__confetti bk-media-timer-celebration__confetti--streamer';
    streamer.style.setProperty('--bk-confetti-left', timerCelebrationRandom(0, 100) + '%');
    streamer.style.setProperty('--bk-confetti-color', timerCelebrationPickColor());
    streamer.style.setProperty('--bk-confetti-h', timerCelebrationRandom(20, 36) + 'px');
    streamer.style.setProperty('--bk-confetti-drift', timerCelebrationRandom(-50, 50) + 'px');
    streamer.style.setProperty('--bk-confetti-rot', timerCelebrationRandom(180, 540) + 'deg');
    streamer.style.setProperty('--bk-confetti-dur', timerCelebrationRandom(3, 4.5) + 's');
    streamer.style.setProperty('--bk-confetti-delay', timerCelebrationRandom(0, 0.4) + 's');
    overlay.appendChild(streamer);
  }
}

function timerCelebrationCreateFirework(overlay, leftPct, index) {
  var burst = document.createElement('div');
  burst.className = 'bk-media-timer-celebration__burst';
  burst.style.setProperty('--bk-burst-left', leftPct + '%');

  var apexVh = timerCelebrationRandom(25, 75);
  var rocketDelay = index * 0.08 + timerCelebrationRandom(0, 0.2);
  var rocketDur = timerCelebrationRandom(0.9, 1.4);
  var burstDelay = rocketDelay + rocketDur * 0.85;

  burst.style.setProperty('--bk-apex-vh', apexVh + 'vh');
  burst.style.setProperty('--bk-rocket-delay', rocketDelay + 's');
  burst.style.setProperty('--bk-rocket-dur', rocketDur + 's');
  burst.style.setProperty('--bk-burst-delay', burstDelay + 's');
  burst.style.setProperty('--bk-wobble', timerCelebrationRandom(4, 12) + 'px');

  var shell = document.createElement('div');
  shell.className = 'bk-media-timer-celebration__rocket-shell';
  burst.appendChild(shell);

  var flame = document.createElement('div');
  flame.className = 'bk-media-timer-celebration__rocket-flame';
  shell.appendChild(flame);

  var glow = document.createElement('div');
  glow.className = 'bk-media-timer-celebration__rocket-glow';
  shell.appendChild(glow);

  var tail = document.createElement('div');
  tail.className = 'bk-media-timer-celebration__rocket-tail';
  shell.appendChild(tail);

  var e;
  for (e = 0; e < 16; e++) {
    var ember = document.createElement('div');
    ember.className = 'bk-media-timer-celebration__ember';
    ember.style.setProperty('--bk-ember-delay', (rocketDelay + e * 0.04) + 's');
    ember.style.setProperty('--bk-ember-x', timerCelebrationRandom(-24, 24) + 'px');
    ember.style.setProperty('--bk-ember-y', timerCelebrationRandom(20, 50) + 'px');
    ember.style.setProperty('--bk-ember-color', timerCelebrationPickColor());
    shell.appendChild(ember);
  }

  var flash = document.createElement('div');
  flash.className = 'bk-media-timer-celebration__flash';
  burst.appendChild(flash);

  var ring = document.createElement('div');
  ring.className = 'bk-media-timer-celebration__burst-ring';
  burst.appendChild(ring);

  var s;
  for (s = 0; s < 32; s++) {
    var spark = document.createElement('div');
    spark.className = 'bk-media-timer-celebration__spark';
    if (s % 5 === 0) {
      spark.classList.add('bk-media-timer-celebration__spark--star');
    }
    var angle = (360 / 32) * s + timerCelebrationRandom(-8, 8);
    spark.style.setProperty('--bk-spark-angle', angle + 'deg');
    spark.style.setProperty('--bk-spark-dist', timerCelebrationRandom(40, 120) + 'px');
    spark.style.setProperty('--bk-spark-color', timerCelebrationPickColor());
    spark.style.setProperty('--bk-spark-delay', burstDelay + 's');
    spark.style.setProperty('--bk-spark-gravity', timerCelebrationRandom(-30, 30) + 'px');
    burst.appendChild(spark);
  }

  overlay.appendChild(burst);
}

function playTimerCelebration(force) {
  if (timerCelebrationPlayed && !force) return;
  if (!force && !isTimerCelebrationEnabled()) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  timerCelebrationPlayed = true;

  var overlay = document.createElement('div');
  overlay.className = 'bk-media-timer-celebration';
  overlay.setAttribute('aria-hidden', 'true');

  var screenFlash = document.createElement('div');
  screenFlash.className = 'bk-media-timer-celebration__screen-flash';
  overlay.appendChild(screenFlash);

  timerCelebrationCreateConfetti(overlay);

  [8, 18, 30, 42, 52, 64, 76, 86, 94, 50].forEach(function(leftPct, index) {
    timerCelebrationCreateFirework(overlay, leftPct, index);
  });

  document.body.appendChild(overlay);

  window.setTimeout(function() {
    if (overlay.parentNode) overlay.remove();
  }, 4500);
}

function initTimerCelebration() {
  if (!isTimerCelebrationEnabled()) return;

  if (isTimerCelebrationTestOnLoad()) {
    timerCelebrationPlayed = false;
    playTimerCelebration(true);
    return;
  }

  var wrappers = document.querySelectorAll('.bk-media-timer-wrapper:not([data-celebration-bound])');
  if (!wrappers.length || timerCelebrationPlayed) return;

  if (!('IntersectionObserver' in window)) {
    playTimerCelebration(false);
    return;
  }

  var observer = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (entry.isIntersecting) {
        playTimerCelebration(false);
        observer.disconnect();
      }
    });
  }, { threshold: 0.2 });

  wrappers.forEach(function(wrapper) {
    wrapper.setAttribute('data-celebration-bound', 'true');
    observer.observe(wrapper);
  });
}

window.playTimerCelebration = function() {
  playTimerCelebration(true);
};

/* bk-media-timer-celebration end */

/* bk-media-collection-featured-set-accordion begin */
(function () {
  var mq = window.matchMedia('(min-width: 700px)');
  var mqListenerBound = false;

  function syncFeaturedSetAccordions() {
    document.querySelectorAll('.bk-media-collection-featured-set__accordion[data-bk-media-featured-accordion-default-desktop]').forEach(function (root) {
      var desktop = root.getAttribute('data-bk-media-featured-accordion-default-desktop') === 'true';
      var mobile = root.getAttribute('data-bk-media-featured-accordion-default-mobile') === 'true';
      var want = (mq.matches && desktop) || (!mq.matches && mobile);
      if (root.open !== want) root.open = want;
    });
  }

  function initFeaturedSetAccordionDefaults() {
    var apply = function () {
      syncFeaturedSetAccordions();
    };
    if (window.customElements && customElements.whenDefined) {
      customElements.whenDefined('accordion-disclosure').then(apply);
    } else {
      apply();
    }
    if (!mqListenerBound) {
      mq.addEventListener('change', syncFeaturedSetAccordions);
      mqListenerBound = true;
    }
  }

  document.addEventListener('DOMContentLoaded', initFeaturedSetAccordionDefaults);
  document.addEventListener('shopify:section:load', function () {
    setTimeout(initFeaturedSetAccordionDefaults, 0);
  });
})();
/* bk-media-collection-featured-set-accordion end */

document.addEventListener('DOMContentLoaded', function() {
  initializeTimerBlocks();
});

document.addEventListener('shopify:section:load', function() {
  setTimeout(function() {
    initializeTimerBlocks();
  }, 100);
});

document.addEventListener('product:rerender', function() {
  setTimeout(function() {
    initializeTimerBlocks();
  }, 100);
});

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initializeTimerBlocks);
} else {
  setTimeout(initializeTimerBlocks, 100);
}

/* bk-media-video-popup begin */
function initBkMediaVideoAutoThumbs() {
  document.querySelectorAll('[data-bk-media-auto-thumb]').forEach(function (preview) {
    if (preview.dataset.bkMediaAutoThumbBound === 'true') return;
    preview.dataset.bkMediaAutoThumbBound = 'true';

    function showFrame() {
      try {
        var target = 0.1;
        if (preview.duration && isFinite(preview.duration)) {
          target = Math.min(0.1, Math.max(0, preview.duration / 2));
        }
        if (preview.currentTime !== target) {
          preview.currentTime = target;
        }
      } catch (e) {}
    }

    function freezeFrame() {
      preview.pause();
    }

    preview.addEventListener('loadedmetadata', showFrame);
    preview.addEventListener('seeked', freezeFrame);
    preview.addEventListener('loadeddata', function () {
      if (preview.readyState >= 2 && preview.currentTime === 0) {
        showFrame();
      }
    });

    if (preview.readyState >= 1) {
      showFrame();
    } else {
      preview.preload = 'metadata';
      preview.load();
    }
  });
}

function initBkMediaVideoPopup() {
  initBkMediaVideoAutoThumbs();

  document.querySelectorAll('.bk-media-video-popup').forEach(function (popup) {
    if (popup.dataset.bkMediaVideoBound === 'true') return;
    popup.dataset.bkMediaVideoBound = 'true';

    var popupId = popup.id;
    var triggers = Array.prototype.slice.call(document.querySelectorAll('.bk-media-video-popup-bubble[data-bk-media-video-popup="' + popupId + '"]'));
    if (!triggers.length) {
      var gallery = popup.closest('product-gallery');
      var fallbackTrigger = gallery && gallery.querySelector('.bk-media-video-popup-trigger .bk-media-video-popup-bubble');
      if (fallbackTrigger) triggers.push(fallbackTrigger);
    }
    var video = popup.querySelector('.bk-media-video-popup__video');
    var closeBtn = popup.querySelector('.bk-media-video-popup__close');
    var overlay = popup.querySelector('.bk-media-video-popup__overlay');
    if (!triggers.length || !video) return;

    if (popup.parentElement !== document.body) {
      document.body.appendChild(popup);
    }

    function closePopup() {
      popup.setAttribute('hidden', '');
      document.body.style.overflow = '';
      video.pause();
      video.currentTime = 0;
      var focusTarget = popup.__bkMediaLastFocus || triggers[0];
      if (focusTarget && typeof focusTarget.focus === 'function') {
        focusTarget.focus();
      }
    }

    function openPopup(event) {
      popup.__bkMediaLastFocus = event && event.currentTarget ? event.currentTarget : triggers[0];
      if (popup.parentElement !== document.body) {
        document.body.appendChild(popup);
      }
      popup.removeAttribute('hidden');
      document.body.style.overflow = 'hidden';
      var prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (!prefersReduced) {
        var playPromise = video.play();
        if (playPromise && typeof playPromise.catch === 'function') {
          playPromise.catch(function () {});
        }
      }
      if (closeBtn && typeof closeBtn.focus === 'function') {
        closeBtn.focus();
      }
    }

    triggers.forEach(function (trigger) {
      trigger.addEventListener('click', openPopup);
    });
    if (closeBtn) closeBtn.addEventListener('click', closePopup);
    if (overlay) overlay.addEventListener('click', closePopup);
  });
}

if (!window.__bkMediaVideoPopupEscapeInit) {
  window.__bkMediaVideoPopupEscapeInit = true;
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    document.querySelectorAll('.bk-media-video-popup:not([hidden])').forEach(function (popup) {
      var trigger = popup.__bkMediaLastFocus || document.querySelector('.bk-media-video-popup-bubble[data-bk-media-video-popup="' + popup.id + '"]');
      var video = popup.querySelector('.bk-media-video-popup__video');
      popup.setAttribute('hidden', '');
      document.body.style.overflow = '';
      if (video) {
        video.pause();
        video.currentTime = 0;
      }
      if (trigger && typeof trigger.focus === 'function') {
        trigger.focus();
      }
    });
  });
}

document.addEventListener('DOMContentLoaded', initBkMediaVideoPopup);
document.addEventListener('shopify:section:load', function () {
  setTimeout(initBkMediaVideoPopup, 0);
});
/* bk-media-video-popup end */

/* bk-media-sticky-quick-atc start */
(function () {
  function bkMediaQuantityInputs(formId) {
    var inputs = [];
    if (formId) {
      var byId = document.getElementById(formId + '-quantity');
      if (byId) inputs.push(byId);
      document.querySelectorAll('input[name="quantity"][form="' + formId + '"]').forEach(function (el) {
        if (inputs.indexOf(el) === -1) inputs.push(el);
      });
      var form = document.getElementById(formId);
      if (form) {
        form.querySelectorAll('[name="quantity"]').forEach(function (el) {
          if (inputs.indexOf(el) === -1) inputs.push(el);
        });
      }
    }
    return inputs;
  }

  function bkMediaSetQuantity(formId, qty) {
    bkMediaQuantityInputs(formId).forEach(function (input) {
      if (input.quantity !== undefined) input.quantity = qty;
      else input.value = qty;
      input.dispatchEvent(new Event('input', { bubbles: true }));
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  function bkMediaSyncQtyDisplay(quantity) {
    var qty = parseInt(quantity, 10) || 1;
    document.querySelectorAll('[data-bk-media-quick-atc-qty-value]').forEach(function (el) {
      el.textContent = String(qty);
    });
  }

  function bkMediaUpdateSwitcherLabel() {
    var checked = document.querySelector('.bk-media-pack-cards__input:checked, variant-picker input[type="radio"]:checked');
    var title = checked ? checked.value : '';
    if (!title || title === 'Default Title') return;
    document.querySelectorAll('[data-bk-media-quick-atc-switcher-label]').forEach(function (el) {
      el.textContent = title;
    });
  }

  function bkMediaSetQuickAtcOpen(host, open) {
    if (!host) return;
    host.classList.toggle('is-variant-open', open);
    var btn = host.querySelector('[data-bk-media-quick-atc-switcher]');
    if (btn) btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    var picker = host.querySelector('[data-bk-media-quick-atc-picker]');
    if (picker) picker.setAttribute('aria-hidden', open ? 'false' : 'true');
  }

  function bkMediaSyncStickyMirrorPickers(scope) {
    var root = scope || document;
    root.querySelectorAll('.variant-picker--static-fields [data-mirror-control-id]').forEach(function (el) {
      var controlId = el.getAttribute('data-mirror-control-id');
      if (!controlId) return;
      var input = document.getElementById(controlId);
      if (!input || input.type !== 'radio') return;
      var visual = input.nextElementSibling;
      var hasMainVisual = !!(visual && visual.getAttribute && visual.getAttribute('data-option-value') != null);
      el.classList.toggle('is-selected', input.checked);
      if (hasMainVisual && el.tagName.toLowerCase() !== 'button') {
        el.toggleAttribute('hidden', visual.hasAttribute('hidden'));
        el.classList.toggle('is-disabled', visual.classList.contains('is-disabled'));
      }
      if (input.disabled) el.setAttribute('disabled', 'disabled');
      else el.removeAttribute('disabled');
    });

    root.querySelectorAll('variant-picker input[data-option-position][type="radio"]').forEach(function (input) {
      var card = input.nextElementSibling;
      if (!card || !card.classList || !card.classList.contains('bk-media-variant-card')) return;
      if (card.tagName.toLowerCase() !== 'label') return;
      card.classList.toggle('is-selected', input.checked);
    });
    bkMediaUpdateSwitcherLabel();
  }

  document.addEventListener(
    'change',
    function (e) {
      var t = e.target;
      if (!t.matches) return;
      if (t.matches('input[data-option-position][type="radio"], .bk-media-pack-cards__input')) {
        bkMediaSyncStickyMirrorPickers(document);
      }
      if (t.classList && t.classList.contains('quantity-selector__input') && t.tagName === 'INPUT') {
        bkMediaUpdateSwitcherLabel();
      }
    },
    true
  );

  document.addEventListener(
    'click',
    function (e) {
      var btn = e.target.closest('.variant-picker--static-fields [data-mirror-control-id]');
      if (btn && !btn.disabled && !btn.classList.contains('is-disabled')) {
        var controlId = btn.getAttribute('data-mirror-control-id');
        var input = controlId ? document.getElementById(controlId) : null;
        if (input && input.type === 'radio' && !input.disabled && !input.checked) {
          input.checked = true;
          input.dispatchEvent(new Event('change', { bubbles: true }));
          bkMediaSyncStickyMirrorPickers(document);
        }
        return;
      }

      var stepBtn = e.target.closest('[data-bk-media-quick-atc-qty] [data-qty-step]');
      if (stepBtn) {
        e.preventDefault();
        var formId = stepBtn.closest('[data-form-id]').getAttribute('data-form-id');
        var currentInput = bkMediaQuantityInputs(formId)[0];
        var current = currentInput ? parseInt(currentInput.value, 10) || 1 : 1;
        var next = current + (parseInt(stepBtn.getAttribute('data-qty-step'), 10) || 0);
        if (next < 1) next = 1;
        bkMediaSetQuantity(formId, next);
        bkMediaUpdateSwitcherLabel();
        return;
      }

      if (e.target.closest('[data-bk-media-quick-atc-switcher]')) return;

      document.querySelectorAll('product-quick-add.is-variant-open').forEach(function (openHost) {
        if (openHost.contains(e.target) && e.target.closest('[data-bk-media-quick-atc-picker]')) return;
        if (openHost.contains(e.target) && e.target.closest('buy-buttons')) return;
        bkMediaSetQuickAtcOpen(openHost, false);
      });
    },
    true
  );

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    document.querySelectorAll('product-quick-add.is-variant-open').forEach(function (host) {
      bkMediaSetQuickAtcOpen(host, false);
    });
  });

  document.addEventListener('variant:change', function () {
    requestAnimationFrame(function () {
      bkMediaSyncStickyMirrorPickers(document);
    });
  });

  document.addEventListener('DOMContentLoaded', function () {
    bkMediaSyncStickyMirrorPickers(document);
  });
  document.addEventListener('shopify:section:load', function () {
    setTimeout(function () {
      bkMediaSyncStickyMirrorPickers(document);
    }, 0);
  });
})();
/* bk-media-sticky-quick-atc end */

/* bk-media-search-drawer start */
function initBkMediaSearchDrawer() {
  document.querySelectorAll('.bk-media-search-drawer__chip:not([data-initialized])').forEach(function (chip) {
    chip.setAttribute('data-initialized', 'true');
    chip.addEventListener('click', function () {
      var drawer = chip.closest('search-drawer');
      if (!drawer) return;

      var input = drawer.querySelector('input[name="q"]');
      var term = chip.dataset.searchTerm;
      if (!input || !term) return;

      input.value = term;
      input.dispatchEvent(new Event('input', { bubbles: true }));
      input.focus();
    });
  });
}

document.addEventListener('DOMContentLoaded', function () {
  initBkMediaSearchDrawer();
});
document.addEventListener('shopify:section:load', function () {
  setTimeout(initBkMediaSearchDrawer, 100);
});

function initBkMediaPredictiveSearchFilter() {
  var PredictiveSearch = customElements.get('predictive-search');
  if (!PredictiveSearch || PredictiveSearch.prototype._bkMediaResourceFilterPatched) return;

  PredictiveSearch.prototype._bkMediaResourceFilterPatched = true;

  var originalPredictive = PredictiveSearch.prototype._doPredictiveSearch;
  var originalFallback = PredictiveSearch.prototype._doFallbackSearch;

  function getResourceTypeParam(element) {
    return element.getAttribute('data-limit-to-products') === 'true' ? '&resources[type]=product' : '';
  }

  PredictiveSearch.prototype._doPredictiveSearch = async function () {
    var resourceParam = getResourceTypeParam(this);

    if (!resourceParam) {
      return originalPredictive.call(this);
    }

    await this._transitionToSlot('loading');
    var queryParams = 'q=' + encodeURIComponent(this._queryInput.value) + '&section_id=' + this.getAttribute('section-id') + '&resources[limit]=10&resources[limit_scope]=each' + resourceParam;
    var response = await fetch(window.Shopify.routes.root + 'search/suggest?' + queryParams, { signal: this._abortController.signal });
    var nodeElement = new DOMParser().parseFromString(await response.text(), 'text/html');
    this.querySelector('[slot="results"]').replaceWith(document.importNode(nodeElement.querySelector('[slot="results"]'), true));
    return this._transitionToSlot('results');
  };

  PredictiveSearch.prototype._doFallbackSearch = async function () {
    var resourceParam = getResourceTypeParam(this);

    if (!resourceParam) {
      return originalFallback.call(this);
    }

    await this._transitionToSlot('loading');
    var queryParams = 'q=' + encodeURIComponent(this._queryInput.value) + '&section_id=' + this.getAttribute('section-id') + '&resources[limit]=10&resources[limit_scope]=each' + resourceParam;
    var response = await fetch(window.Shopify.routes.root + 'search?' + queryParams, { signal: this._abortController.signal });
    var nodeElement = new DOMParser().parseFromString(await response.text(), 'text/html');
    this.querySelector('[slot="results"]').replaceWith(document.importNode(nodeElement.querySelector('[slot="results"]'), true));
    return this._transitionToSlot('results');
  };
}

document.addEventListener('DOMContentLoaded', initBkMediaPredictiveSearchFilter);
document.addEventListener('shopify:section:load', function () {
  setTimeout(initBkMediaPredictiveSearchFilter, 100);
});
/* bk-media-search-drawer end */

/* bk-media search keywords start */
var bkMediaSearchKeywordsIndex = null;

function bkMediaParseSearchKeywordsIndex() {
  if (bkMediaSearchKeywordsIndex) return bkMediaSearchKeywordsIndex;
  var script = document.querySelector('[data-bk-media-search-keywords]');
  if (!script) return [];
  try {
    bkMediaSearchKeywordsIndex = JSON.parse(script.textContent);
  } catch (error) {
    console.error('Failed to parse search keywords index:', error);
    bkMediaSearchKeywordsIndex = [];
  }
  return bkMediaSearchKeywordsIndex;
}

function bkMediaNormalizeSearchText(value) {
  return (value || '').toLowerCase().trim();
}

function bkMediaSearchKeywordMatches(item, query) {
  var q = bkMediaNormalizeSearchText(query);
  if (!q || !item) return false;
  if (item.handle === 'gratis-dosierdeckel' || item.handle === 'gratisshotglas' || item.handle === 'gratis-shotflesje') return false;
  if (bkMediaNormalizeSearchText(item.title).indexOf(q) !== -1) return true;
  if (!item.keywords || !item.keywords.length) return false;
  return item.keywords.some(function (keyword) {
    return keyword === q || keyword.indexOf(q) !== -1 || q.indexOf(keyword) !== -1;
  });
}

function bkMediaEscapeHtml(value) {
  return String(value)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;');
}

function bkMediaNormalizeProductUrl(url) {
  try {
    return new URL(url, window.location.origin).pathname.replace(/\/$/, '');
  } catch (error) {
    return String(url || '')
      .split('?')[0]
      .split('#')[0]
      .replace(/\/$/, '');
  }
}

function bkMediaGetProductHandleFromUrl(url) {
  var path = bkMediaNormalizeProductUrl(url);
  var match = path.match(/\/products\/([^/]+)/);
  return match ? decodeURIComponent(match[1]) : null;
}

function bkMediaCollectProductKeysFromPanel(panel) {
  var urls = new Set();
  var handles = new Set();
  var ids = new Set();
  panel.querySelectorAll('a[href*="/products/"]').forEach(function (anchor) {
    var href = anchor.getAttribute('href');
    if (!href) return;
    urls.add(bkMediaNormalizeProductUrl(href));
    var handle = bkMediaGetProductHandleFromUrl(href);
    if (handle) handles.add(handle);
    var productId = anchor.getAttribute('data-product-id');
    if (productId) ids.add(String(productId));
  });
  return { urls: urls, handles: handles, ids: ids };
}

function bkMediaIsProductInPanel(keys, item) {
  if (!item) return false;
  if (item.id && keys.ids.has(String(item.id))) return true;
  if (item.handle && keys.handles.has(item.handle)) return true;
  if (item.url && keys.urls.has(bkMediaNormalizeProductUrl(item.url))) return true;
  return false;
}

function bkMediaRemoveKeywordSearchResults(panel) {
  panel.querySelectorAll('.bk-media-search-keyword-result').forEach(function (node) {
    node.remove();
  });
}

function bkMediaBuildPredictiveSearchResult(item) {
  var imageHtml = item.image
    ? '<img src="' + bkMediaEscapeHtml(item.image) + '" alt="" width="96" height="96" loading="lazy">'
    : '';
  var titleHtml =
    '<div class="v-stack justify-items-start gap-0.5"><span class="bold"><span class="reversed-link">' +
    bkMediaEscapeHtml(item.title) +
    '</span></span>';
  if (item.price_html) {
    titleHtml += item.price_html;
  } else if (item.price) {
    titleHtml += '<span class="text-subdued">' + bkMediaEscapeHtml(item.price) + '</span>';
  }
  titleHtml += '</div>';
  return (
    '<a href="' +
    bkMediaEscapeHtml(item.url) +
    '" data-instant class="predictive-search-result group bk-media-search-keyword-result"' +
    (item.id ? ' data-product-id="' + bkMediaEscapeHtml(String(item.id)) + '"' : '') +
    (item.handle ? ' data-product-handle="' + bkMediaEscapeHtml(item.handle) + '"' : '') +
    '>' +
    imageHtml +
    '<div class="v-stack gap-1 sm:gap-1.5">' +
    titleHtml +
    '</div></a>'
  );
}

function bkMediaGetPredictiveProductPanel(predictiveSearch) {
  var tabs = predictiveSearch.querySelector('x-tabs.predictive-search__tabs');
  if (!tabs) return null;
  var panels = tabs.querySelectorAll('[slot="content"]');
  if (!panels.length) return null;
  return panels[0];
}

function bkMediaEnsurePredictiveProductPanel(predictiveSearch) {
  var existingPanel = bkMediaGetPredictiveProductPanel(predictiveSearch);
  if (existingPanel) return existingPanel;
  var resultsSlot = predictiveSearch.querySelector('[slot="results"]');
  if (!resultsSlot) return null;
  var emptyState = resultsSlot.querySelector('.empty-state');
  if (!emptyState) return null;
  resultsSlot.innerHTML =
    '<x-tabs class="predictive-search__tabs">' +
    '<template>' +
    '<style>[role="tablist"]::-webkit-scrollbar {display: none;}</style>' +
    '<slot role="tablist" part="tab-list" name="title"></slot>' +
    '<slot part="tab-panels" name="content"></slot>' +
    '</template>' +
    '<div class="predictive-search__tab-item" slot="title">' +
    '<button type="button" class="h5">Produkte</button>' +
    '</div>' +
    '<div class="predictive-search__tab-content v-stack gap-4 sm:gap-6" slot="content"></div>' +
    '</x-tabs>';
  return bkMediaGetPredictiveProductPanel(predictiveSearch);
}

function bkMediaMergePredictiveSearchKeywords(predictiveSearch, query) {
  if (predictiveSearch._bkMediaKeywordMerging) return;
  var index = bkMediaParseSearchKeywordsIndex();
  if (!index.length) return;
  var normalizedQuery = bkMediaNormalizeSearchText(query);
  if (!normalizedQuery) return;
  var matches = index.filter(function (item) {
    return bkMediaSearchKeywordMatches(item, normalizedQuery);
  });
  var panel = bkMediaEnsurePredictiveProductPanel(predictiveSearch);
  if (!panel) return;
  predictiveSearch._bkMediaKeywordMerging = true;
  try {
    bkMediaRemoveKeywordSearchResults(panel);
    if (!matches.length) return;
    var existingKeys = bkMediaCollectProductKeysFromPanel(panel);
    matches.forEach(function (item) {
      if (bkMediaIsProductInPanel(existingKeys, item)) return;
      panel.insertAdjacentHTML('afterbegin', bkMediaBuildPredictiveSearchResult(item));
      if (item.id) existingKeys.ids.add(String(item.id));
      if (item.handle) existingKeys.handles.add(item.handle);
      if (item.url) existingKeys.urls.add(bkMediaNormalizeProductUrl(item.url));
    });
  } finally {
    predictiveSearch._bkMediaKeywordMerging = false;
  }
}

function bkMediaInitPredictiveSearchKeywords() {
  document.querySelectorAll('predictive-search').forEach(function (predictiveSearch) {
    if (predictiveSearch.hasAttribute('data-bk-media-search-keywords-init')) return;
    predictiveSearch.setAttribute('data-bk-media-search-keywords-init', 'true');
    var form = predictiveSearch.closest('form');
    var input = form && form.elements['q'];
    if (!input) return;
    var merge = function () {
      if (!input.value.trim()) return;
      bkMediaMergePredictiveSearchKeywords(predictiveSearch, input.value);
    };
    if (predictiveSearch._bkMediaKeywordObserver) {
      predictiveSearch._bkMediaKeywordObserver.disconnect();
    }
    var observer = new MutationObserver(function () {
      if (predictiveSearch._bkMediaKeywordMerging) return;
      window.clearTimeout(predictiveSearch._bkMediaKeywordMergeTimer);
      predictiveSearch._bkMediaKeywordMergeTimer = window.setTimeout(merge, 150);
    });
    observer.observe(predictiveSearch, { childList: true, subtree: true });
    predictiveSearch._bkMediaKeywordObserver = observer;
  });
}

function bkMediaLoadMainSearchKeywordResults(container) {
  var query = container.getAttribute('data-search-query');
  var nativeIds = container.getAttribute('data-native-ids') || '';
  if (!query) return;
  var sectionUrl =
    (window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') +
    'search?type=product&q=' +
    encodeURIComponent(query) +
    '&native_ids=' +
    encodeURIComponent(nativeIds) +
    '&section_id=bk-media-search-keyword-results';
  fetch(sectionUrl)
    .then(function (response) {
      return response.text();
    })
    .then(function (html) {
      var parser = new DOMParser();
      var doc = parser.parseFromString(html, 'text/html');
      var section = doc.querySelector('.bk-media-search-keyword-results');
      if (!section || !section.innerHTML.trim()) return;
      var productList = container.querySelector('[data-bk-media-search-product-list]');
      var emptyState = container.querySelector('[data-bk-media-search-empty]');
      if (productList) {
        productList.insertAdjacentHTML('afterbegin', section.innerHTML);
        return;
      }
      if (emptyState) {
        emptyState.outerHTML =
          '<div class="v-stack gap-6"><reveal-items selector=".product-list > *"><product-list class="product-list" role="region" aria-live="polite">' +
          section.innerHTML +
          '</product-list></reveal-items></div>';
      }
    })
    .catch(function (error) {
      console.error('Failed to load search keyword results:', error);
    });
}

function bkMediaInitMainSearchKeywords() {
  document.querySelectorAll('[data-bk-media-search-keyword-results]').forEach(function (container) {
    if (container.hasAttribute('data-bk-media-search-keywords-init')) return;
    container.setAttribute('data-bk-media-search-keywords-init', 'true');
    bkMediaLoadMainSearchKeywordResults(container);
  });
}

function bkMediaInitSearchKeywords() {
  bkMediaInitPredictiveSearchKeywords();
  bkMediaInitMainSearchKeywords();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', bkMediaInitSearchKeywords, { once: true });
} else {
  bkMediaInitSearchKeywords();
}

document.addEventListener('shopify:section:load', function () {
  window.setTimeout(bkMediaInitSearchKeywords, 100);
});
/* bk-media search keywords end */

/* bk-media-celebration start */

var bkMediaCelebrationColors = ['#F9D354', '#DC5B5B', '#57FFFF', '#EC4899', '#124B3A', '#FFFFFF', '#FF6B35'];

function bkMediaGetCelebrationRoot() {
  var root = document.getElementById('bk-media-celebration-root');

  if (!root) {
    root = document.createElement('div');
    root.id = 'bk-media-celebration-root';
    root.setAttribute('aria-hidden', 'true');
    document.body.appendChild(root);
  }

  document.body.appendChild(root);
  return root;
}

function bkMediaKeepCelebrationOnTop() {
  var root = document.getElementById('bk-media-celebration-root');
  if (!root) return;
  document.body.appendChild(root);
}

function bkMediaScheduleCelebrationOnTop() {
  bkMediaKeepCelebrationOnTop();
  requestAnimationFrame(function () {
    bkMediaKeepCelebrationOnTop();
    requestAnimationFrame(bkMediaKeepCelebrationOnTop);
  });
  window.setTimeout(bkMediaKeepCelebrationOnTop, 0);
  window.setTimeout(bkMediaKeepCelebrationOnTop, 120);
  window.setTimeout(bkMediaKeepCelebrationOnTop, 320);
}

function bkMediaRandomRange(min, max) {
  return min + Math.random() * (max - min);
}

function playBkMediaCelebration(options) {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return null;

  options = options || {};
  var subtle = options.subtle === true;
  var duration = options.duration || (subtle ? 3200 : 5800);
  var confettiCount = options.confettiCount || (subtle ? 42 : 155);
  var rocketPositions = options.rocketPositions || (subtle ? [18, 38, 50, 62, 82] : [8, 18, 30, 42, 52, 64, 76, 86, 94, 50]);
  var sparksPerRocket = options.sparksPerRocket || (subtle ? 16 : 32);
  var embersPerRocket = options.embersPerRocket || (subtle ? 6 : 16);
  var colors = options.colors || bkMediaCelebrationColors;
  var viewportHeight = window.innerHeight || document.documentElement.clientHeight || 800;

  var root = bkMediaGetCelebrationRoot();
  var overlay = document.createElement('div');
  overlay.className = 'bk-media-celebration' + (subtle ? ' bk-media-celebration--subtle' : '');
  overlay.setAttribute('aria-hidden', 'true');

  var flash = document.createElement('div');
  flash.className = 'bk-media-celebration__screen-flash';
  overlay.appendChild(flash);

  for (var i = 0; i < confettiCount; i += 1) {
    var piece = document.createElement('div');
    var variant = i % 5;
    piece.className = 'bk-media-celebration__confetti';
    if (variant === 1) piece.classList.add('bk-media-celebration__confetti--sway');
    if (variant === 2) piece.classList.add('bk-media-celebration__confetti--streamer');
    piece.style.setProperty('--bk-left', String(Math.random() * 100));
    piece.style.setProperty('--bk-color', colors[i % colors.length]);
    piece.style.setProperty('--bk-delay', bkMediaRandomRange(0, subtle ? 0.35 : 0.55).toFixed(2) + 's');
    piece.style.setProperty('--bk-duration', bkMediaRandomRange(subtle ? 2.1 : 2.8, subtle ? 3.1 : 4.2).toFixed(2) + 's');
    piece.style.setProperty('--bk-drift', String(Math.round(bkMediaRandomRange(-90, 90))));
    piece.style.setProperty('--bk-rotate', String(Math.round(bkMediaRandomRange(360, 1080))));
    piece.style.setProperty('--bk-size', String(Math.round(bkMediaRandomRange(5, subtle ? 8 : 12))));
    piece.style.setProperty('--bk-size-y', String(Math.round(bkMediaRandomRange(4, subtle ? 7 : 11))));
    overlay.appendChild(piece);
  }

  rocketPositions.forEach(function (left, index) {
    var burst = document.createElement('div');
    burst.className = 'bk-media-celebration__burst';
    burst.style.setProperty('--bk-left', String(left));
    var apex = subtle
      ? Math.round(bkMediaRandomRange(140, 220))
      : Math.round(viewportHeight * bkMediaRandomRange(0.42, 0.78));
    burst.style.setProperty('--bk-apex-px', '-' + apex + 'px');
    var delay = 0.04 + index * (subtle ? 0.07 : 0.11) + Math.random() * 0.12;
    burst.style.setProperty('--bk-delay', delay.toFixed(2) + 's');
    var rocketDuration = subtle ? bkMediaRandomRange(0.75, 1) : bkMediaRandomRange(1.05, 1.45);
    burst.style.setProperty('--bk-rocket-duration', rocketDuration.toFixed(2) + 's');
    burst.style.setProperty('--bk-wobble', String(Math.round(bkMediaRandomRange(subtle ? -18 : -28, subtle ? 18 : 28))));
    var burstDelay = delay + rocketDuration * 0.94;
    burst.style.setProperty('--bk-burst-delay', burstDelay.toFixed(2) + 's');

    var shell = document.createElement('div');
    shell.className = 'bk-media-celebration__rocket-shell';
    burst.appendChild(shell);

    var glow = document.createElement('div');
    glow.className = 'bk-media-celebration__rocket-glow';
    burst.appendChild(glow);

    var tail = document.createElement('div');
    tail.className = 'bk-media-celebration__rocket-tail';
    burst.appendChild(tail);

    for (var e = 0; e < embersPerRocket; e += 1) {
      var ember = document.createElement('div');
      ember.className = 'bk-media-celebration__ember';
      ember.style.setProperty('--bk-ember-delay', (delay + e * 0.025).toFixed(2) + 's');
      ember.style.setProperty('--bk-ember-drift', String(Math.round(bkMediaRandomRange(-14, 14))));
      burst.appendChild(ember);
    }

    var burstFlash = document.createElement('div');
    burstFlash.className = 'bk-media-celebration__flash';
    burst.appendChild(burstFlash);

    var ring = document.createElement('div');
    ring.className = 'bk-media-celebration__burst-ring';
    burst.appendChild(ring);

    for (var s = 0; s < sparksPerRocket; s += 1) {
      var spark = document.createElement('div');
      spark.className = 'bk-media-celebration__spark';
      if (s % 5 === 0) spark.classList.add('bk-media-celebration__spark--star');
      var angle = (360 / sparksPerRocket) * s + bkMediaRandomRange(-8, 8);
      var dist = bkMediaRandomRange(subtle ? 28 : 52, subtle ? 62 : 120);
      var rad = angle * Math.PI / 180;
      spark.style.setProperty('--bk-spark-x', (Math.cos(rad) * dist).toFixed(1) + 'px');
      spark.style.setProperty('--bk-spark-y', (Math.sin(rad) * dist * -0.75).toFixed(1) + 'px');
      spark.style.setProperty('--bk-color', colors[s % colors.length]);
      spark.style.setProperty('--bk-burst-delay', burstDelay.toFixed(2) + 's');
      burst.appendChild(spark);
    }

    overlay.appendChild(burst);
  });

  root.appendChild(overlay);
  bkMediaKeepCelebrationOnTop();

  window.setTimeout(function () {
    overlay.remove();
    if (!root.childElementCount) root.remove();
  }, duration);

  return overlay;
}

function bkMediaCelebrateSparsetAdd(originElement) {
  var builder = originElement && originElement.closest ? originElement.closest('bk-media-sparset-builder') : null;
  var section = builder ? builder.closest('[id^="shopify-section-"]') : null;
  var accent = section ? getComputedStyle(section).getPropertyValue('--bk-sparset-accent').trim() : '';
  var colors = [accent || '#F9CA4F', '#F9D354', '#124B3A', '#FFFFFF', '#DC5B5B'].filter(Boolean);

  playBkMediaCelebration({
    subtle: true,
    colors: colors,
    duration: 3200,
    confettiCount: 40,
    rocketPositions: [20, 40, 55, 72],
    sparksPerRocket: 14,
    embersPerRocket: 5
  });
}

/* bk-media-celebration end */

/* bk-media-sparset-builder start */

function initBkMediaSparsetBuilder(root) {
  if (!root || root._bkMediaSparsetInitialized) return;

  const configScript = root.querySelector('[data-sparset-config]');
  if (!configScript) return;

  let config = {};
  try {
    config = JSON.parse(configScript.textContent);
  } catch (error) {
    console.error('Failed to parse sparset config:', error);
    return;
  }

  const productsById = {};
  const productsByVariantId = {};
  (config.products || []).forEach((product) => {
    productsById[String(product.id)] = product;
    productsByVariantId[String(product.variantId)] = product;
  });

  const goals = (config.goals || []).slice().sort((a, b) => a.quantity - b.quantity);
  const selectedVariantIds = [];
  const referralInput = root.querySelector('[data-sparset-referral-input]');
  const searchInput = root.querySelector('[data-sparset-search]');
  const searchWrap = root.querySelector('[data-sparset-search-wrap]');
  const searchToggle = root.querySelector('[data-sparset-search-toggle]');
  const searchEmptyEl = root.querySelector('[data-sparset-search-empty]');
  let referralCodeValue = '';
  let resolvedPreviewDiscount = {
    type: null,
    value: 0,
    code: null,
    loaded: false
  };
  let previewDiscountRetried = false;
  const panel = root.querySelector('.bk-media-sparset-builder__panel');
  const countEls = root.querySelectorAll('[data-sparset-count]');
  const goalsFill = root.querySelector('[data-goals-fill]');
  const goalNodes = root.querySelectorAll('.bk-media-sparset-builder__goal-node');
  const slots = root.querySelectorAll('.bk-media-sparset-builder__slot');
  const atcButton = root.querySelector('[data-action="add-to-cart"]');
  const savingsRow = root.querySelector('[data-sparset-savings]');
  const savingsAmountEl = root.querySelector('[data-sparset-savings-amount]');
  const discountAppliedRow = root.querySelector('[data-sparset-discount-applied]');
  const discountLabelEl = root.querySelector('[data-sparset-discount-label]');
  const discountAmountEl = root.querySelector('[data-sparset-discount-amount]');
  const atcPricesEl = root.querySelector('[data-atc-prices]');
  const atcSalePriceEl = root.querySelector('[data-atc-sale-price]');
  const atcComparePriceEl = root.querySelector('[data-atc-compare-price]');
  const minProducts = parseInt(root.getAttribute('data-min-products') || config.minProducts || 2, 10);
  const maxProducts = parseInt(root.getAttribute('data-max-products') || config.maxProducts || 12, 10);

  function hasFreeProductSlot() {
    return Boolean(config.freeProduct?.title);
  }

  function getSelectableMaxProducts() {
    return hasFreeProductSlot() ? Math.max(0, maxProducts - 1) : maxProducts;
  }

  function getSelectedIndexForSlot(slotIndex) {
    return hasFreeProductSlot() ? slotIndex - 1 : slotIndex;
  }

  function renderFreeProductSlot(slot) {
    const freeProduct = config.freeProduct;
    const titleEl = slot.querySelector('[data-slot-title]');
    const subtitleEl = slot.querySelector('[data-slot-subtitle]');
    const iconEl = slot.querySelector('.bk-media-sparset-builder__slot-icon');
    const removeBtn = slot.querySelector('[data-action="remove-slot"]');
    const badgeText = freeProduct.badge || 'GRATIS';

    slot.classList.add('is-filled', 'is-free-product');
    if (titleEl) titleEl.textContent = freeProduct.title;
    if (subtitleEl) {
      subtitleEl.innerHTML = `<span class="badge bk-media-sparset-builder__slot-gratis-badge">${badgeText}</span>`;
    }
    if (iconEl) {
      iconEl.innerHTML = freeProduct.image
        ? `<img src="${freeProduct.image}" alt="${freeProduct.title.replace(/"/g, '&quot;')}" width="48" height="48" loading="lazy">`
        : '';
    }
    if (removeBtn) removeBtn.hidden = true;
  }

  function formatSparsetMoney(cents) {
    if (typeof window.formatMoney === 'function') {
      return window.formatMoney(cents);
    }

    const amount = (cents / 100).toFixed(2).replace('.', ',');
    return `€${amount}`;
  }

  function getCurrentDiscount(count) {
    let current = null;
    goals.forEach((goal) => {
      if (count >= goal.quantity) {
        current = goal;
      }
    });
    return current;
  }

  function getReachedGoalQuantities(count) {
    return goals
      .filter((goal) => count >= goal.quantity)
      .map((goal) => goal.quantity);
  }

  let previouslyReachedGoals = new Set();
  let suppressGoalCelebration = true;

  function maybeCelebrateNewlyReachedGoals(count) {
    const currentlyReached = getReachedGoalQuantities(count);

    if (suppressGoalCelebration || !config.confettiOnGoal) {
      previouslyReachedGoals = new Set(currentlyReached);
      suppressGoalCelebration = false;
      return;
    }

    const newlyReached = currentlyReached.filter((quantity) => !previouslyReachedGoals.has(quantity));
    previouslyReachedGoals = new Set(currentlyReached);

    if (newlyReached.length === 0) return;

    bkMediaCelebrateSparsetAdd(root);
    bkMediaScheduleCelebrationOnTop();
  }

  function getDiscountPercent(count) {
    const currentDiscount = getCurrentDiscount(count);
    return currentDiscount ? currentDiscount.discount : 0;
  }

  function getPreviewDiscountFallbackPercent() {
    return parseInt(config.previewDiscountPercent, 10) || 0;
  }

  function getPreviewDiscountPercent() {
    if (!resolvedPreviewDiscount.loaded) {
      return getPreviewDiscountFallbackPercent();
    }

    if (resolvedPreviewDiscount.type === 'percentage') {
      return resolvedPreviewDiscount.value || 0;
    }

    return getPreviewDiscountFallbackPercent();
  }

  function getPreviewDiscountBadgeText() {
    const previewPercent = getPreviewDiscountPercent();

    if (resolvedPreviewDiscount.code && resolvedPreviewDiscount.type === 'fixed') {
      return `-${formatSparsetMoney(Math.round(resolvedPreviewDiscount.value * 100))}`;
    }

    if (previewPercent > 0) {
      return `-${previewPercent}%`;
    }

    return '';
  }

  function combineDiscountPercents(goalPercent, previewPercent) {
    const goal = parseFloat(goalPercent) || 0;
    const preview = parseFloat(previewPercent) || 0;

    if (goal <= 0 && preview <= 0) return 0;
    if (goal <= 0) return Math.round(preview);
    if (preview <= 0) return Math.round(goal);

    return Math.round(100 - ((100 - goal) * (100 - preview) / 100));
  }

  function getCombinedDiscountPercent(goalPercent) {
    return combineDiscountPercents(goalPercent, getPreviewDiscountPercent());
  }

  function getDisplayDiscountPercent(count) {
    return getCombinedDiscountPercent(getDiscountPercent(count));
  }

  function getTierPercentForNextPlaceholder() {
    const count = selectedVariantIds.length;
    const atMax = count >= getSelectableMaxProducts();

    if (atMax) {
      return getDiscountPercent(count);
    }

    for (let slotIndex = 0; slotIndex < slots.length; slotIndex += 1) {
      const slot = slots[slotIndex];
      if (slot.hasAttribute('data-free-product-slot')) continue;

      const selectedIndex = getSelectedIndexForSlot(slotIndex);
      const hasProduct = selectedIndex >= 0 && selectedVariantIds[selectedIndex];

      if (!hasProduct) {
        const productCountAfterFill = Math.max(1, selectedIndex + 1);
        return getDiscountPercent(productCountAfterFill);
      }
    }

    const nextCount = Math.min(count + 1, getSelectableMaxProducts());
    return getDiscountPercent(nextCount);
  }

  function getReferenceUnitPrice(basePriceCents, compareAtCents) {
    const basePrice = parseInt(basePriceCents, 10) || 0;
    const compareAt = parseInt(compareAtCents, 10) || 0;

    if (config.showVariantCompareAt && compareAt > basePrice) {
      return compareAt;
    }

    return basePrice;
  }

  function floorDiscountCents(priceCents, percent) {
    const price = Math.round(Number(priceCents) || 0);
    const rate = Number(percent) || 0;
    if (price <= 0 || rate <= 0) return 0;
    const scaled = Math.round(rate * 100);
    return Math.floor((price * scaled) / 10000);
  }

  function applyUnitDiscountTruncated(basePriceCents, discountPercent) {
    const basePrice = parseInt(basePriceCents, 10) || 0;
    const discount = parseFloat(discountPercent) || 0;

    if (!discount || discount <= 0 || basePrice <= 0) {
      return basePrice;
    }

    const discountAmount = Math.round(basePrice * discount / 100);
    return basePrice - discountAmount;
  }

  function getDiscountedUnitPriceStacked(basePriceCents, goalPercent, previewPercent) {
    const afterGoal = applyUnitDiscountTruncated(basePriceCents, goalPercent);
    return applyUnitDiscountTruncated(afterGoal, previewPercent);
  }

  function getProductBadgePercent(basePriceCents, compareAtCents, tierGoalPercent) {
    const tierGoal = parseFloat(tierGoalPercent) || 0;
    const previewPercent = getPreviewDiscountPercent();

    if (tierGoal <= 0 && previewPercent <= 0) {
      return 0;
    }

    const referencePrice = getReferenceUnitPrice(basePriceCents, compareAtCents);
    const salePrice = getDiscountedUnitPriceStacked(basePriceCents, tierGoal, previewPercent);

    if (referencePrice <= 0 || salePrice >= referencePrice) {
      return getCombinedDiscountPercent(tierGoal);
    }

    return Math.round((referencePrice - salePrice) / referencePrice * 100);
  }

  async function resolvePreviewDiscountCode() {
    const code = (config.previewDiscountCode || '').trim();
    const fallbackPercent = getPreviewDiscountFallbackPercent();

    if (!code) {
      resolvedPreviewDiscount = {
        type: fallbackPercent > 0 ? 'percentage' : null,
        value: fallbackPercent,
        code: null,
        loaded: true
      };
      return;
    }

    try {
      const cartBefore = await fetch(`${window.Shopify.routes.root}cart.js`).then((response) => response.json());
      const existingApps = cartBefore.cart_level_discount_applications || [];
      const existingCode = existingApps[0]?.title || '';
      const hadDiscount = existingApps.length > 0;
      const alreadyApplied = hadDiscount && existingCode.toLowerCase() === code.toLowerCase();

      if (alreadyApplied) {
        const app = existingApps[0];
        if (app.value_type === 'percentage') {
          resolvedPreviewDiscount = { type: 'percentage', value: parseFloat(app.value), code, loaded: true };
        } else if (app.value_type === 'fixed_amount') {
          resolvedPreviewDiscount = { type: 'fixed', value: parseFloat(app.value) / 100, code, loaded: true };
        } else {
          resolvedPreviewDiscount = { type: fallbackPercent > 0 ? 'percentage' : null, value: fallbackPercent, code: null, loaded: true };
        }
        return;
      }

      const cartAfter = await fetch(`${window.Shopify.routes.root}cart/update.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ discount: code })
      }).then((response) => response.json());

      const codeEntry = (cartAfter.discount_codes || []).find((entry) =>
        String(entry.code || '').toLowerCase() === code.toLowerCase()
      );

      const needsRestore = !hadDiscount || existingCode.toLowerCase() !== code.toLowerCase();

      if (!codeEntry?.applicable) {
        if (needsRestore) {
          await fetch(`${window.Shopify.routes.root}cart/update.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ discount: hadDiscount ? existingCode : '' })
          });
        }

        resolvedPreviewDiscount = {
          type: fallbackPercent > 0 ? 'percentage' : null,
          value: fallbackPercent,
          code: null,
          loaded: true
        };
        return;
      }

      const app = (cartAfter.cart_level_discount_applications || []).find((entry) =>
        String(entry.title || '').toLowerCase() === code.toLowerCase()
      ) || cartAfter.cart_level_discount_applications?.[0];

      if (app?.value_type === 'percentage') {
        resolvedPreviewDiscount = { type: 'percentage', value: parseFloat(app.value), code, loaded: true };
      } else if (app?.value_type === 'fixed_amount') {
        resolvedPreviewDiscount = { type: 'fixed', value: parseFloat(app.value) / 100, code, loaded: true };
      } else {
        resolvedPreviewDiscount = {
          type: fallbackPercent > 0 ? 'percentage' : null,
          value: fallbackPercent,
          code: null,
          loaded: true
        };
      }

      if (needsRestore) {
        const restoredCart = await fetch(`${window.Shopify.routes.root}cart/update.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ discount: hadDiscount ? existingCode : '' })
        }).then((response) => response.json());

        document.documentElement.dispatchEvent(new CustomEvent('cart:change', {
          bubbles: true,
          detail: {
            baseEvent: 'sparset:discount-preview',
            cart: restoredCart
          }
        }));
      }
    } catch (error) {
      console.error('Failed to resolve preview discount code:', error);
      resolvedPreviewDiscount = {
        type: fallbackPercent > 0 ? 'percentage' : null,
        value: fallbackPercent,
        code: null,
        loaded: true
      };
    }
  }

  function maybeRetryPreviewDiscount(count) {
    const code = (config.previewDiscountCode || '').trim();
    if (!code || previewDiscountRetried || count < minProducts) return;
    if (resolvedPreviewDiscount.code) return;

    previewDiscountRetried = true;
    resolvePreviewDiscountCode().then(() => updateUI());
  }

  function getPreviewDiscountSavings(count) {
    if (!count || selectedVariantIds.length === 0) return 0;

    const goalPercent = getDiscountPercent(count);
    let afterGoalTotal = 0;
    let afterPreviewTotal = 0;

    selectedVariantIds.forEach((variantId) => {
      const product = Object.values(productsById).find((item) => String(item.variantId) === String(variantId));
      if (!product) return;

      const afterGoal = getDiscountedUnitPriceStacked(product.price, goalPercent, 0);
      const afterPreview = getDiscountedUnitPriceStacked(product.price, goalPercent, getPreviewDiscountPercent());
      afterGoalTotal += afterGoal;
      afterPreviewTotal += afterPreview;
    });

    if (!afterGoalTotal) return 0;

    if (resolvedPreviewDiscount.type === 'fixed' && resolvedPreviewDiscount.value > 0) {
      return Math.min(afterGoalTotal, Math.round(resolvedPreviewDiscount.value * 100));
    }

    const previewPercent = getPreviewDiscountPercent();
    if (previewPercent > 0) {
      return afterGoalTotal - afterPreviewTotal;
    }

    return 0;
  }

  function getPreviewDiscountLabel() {
    if (resolvedPreviewDiscount.code) {
      return resolvedPreviewDiscount.code;
    }

    const previewPercent = getPreviewDiscountPercent();
    if (previewPercent > 0) {
      return `-${previewPercent}%`;
    }

    return '';
  }

  function hasActivePreviewDiscount() {
    if (!resolvedPreviewDiscount.loaded) return false;
    if (resolvedPreviewDiscount.code) return true;
    return getPreviewDiscountPercent() > 0;
  }

  function updatePreviewDiscountRow(count, totals) {
    if (!discountAppliedRow || !discountLabelEl || !discountAmountEl) return;

    if (!hasActivePreviewDiscount()) {
      discountAppliedRow.hidden = true;
      return;
    }

    const label = getPreviewDiscountLabel();
    if (!label) {
      discountAppliedRow.hidden = true;
      return;
    }

    discountAppliedRow.hidden = false;
    discountLabelEl.textContent = label;

    if (count > 0 && totals.originalTotal > 0) {
      const savings = getPreviewDiscountSavings(count);
      if (savings > 0) {
        discountAmountEl.textContent = `-${formatSparsetMoney(savings)}`;
        discountAmountEl.hidden = false;
        return;
      }
    }

    discountAmountEl.textContent = '';
    discountAmountEl.hidden = true;
  }

  function renderPriceMarkup(basePriceCents, goalPercent, compareAtCents, includePreview) {
    const basePrice = parseInt(basePriceCents, 10) || 0;
    const compareAt = parseInt(compareAtCents, 10) || 0;
    const showCompareAt = config.showVariantCompareAt && compareAt > basePrice;
    const previewPercent = includePreview === false ? 0 : getPreviewDiscountPercent();
    const salePrice = getDiscountedUnitPriceStacked(basePrice, goalPercent, previewPercent);
    const referencePrice = getReferenceUnitPrice(basePrice, compareAt);

    if (showCompareAt) {
      if (salePrice >= referencePrice) {
        return `<sale-price>${formatSparsetMoney(basePrice)}</sale-price>`;
      }

      return `<sale-price class="text-on-sale">${formatSparsetMoney(salePrice)}</sale-price><compare-at-price class="text-subdued line-through">${formatSparsetMoney(referencePrice)}</compare-at-price>`;
    }

    if ((!goalPercent && !previewPercent) || salePrice >= basePrice) {
      return `<sale-price>${formatSparsetMoney(basePrice)}</sale-price>`;
    }

    return `<sale-price class="text-on-sale">${formatSparsetMoney(salePrice)}</sale-price><compare-at-price class="text-subdued line-through">${formatSparsetMoney(basePrice)}</compare-at-price>`;
  }

  function getSelectionTotals(count) {
    const goalPercent = getDiscountPercent(count);
    let priceSubtotal = 0;
    let compareSubtotal = 0;

    selectedVariantIds.forEach((variantId) => {
      const product = Object.values(productsById).find((item) => String(item.variantId) === String(variantId));
      if (!product) return;

      priceSubtotal += product.price;
      compareSubtotal += getReferenceUnitPrice(product.price, product.compareAtPrice);
    });

    const discountAmount = floorDiscountCents(priceSubtotal, goalPercent);
    const discountedTotal = priceSubtotal - discountAmount;
    const originalTotal = priceSubtotal;
    const savings = (config.showVariantCompareAt && compareSubtotal > priceSubtotal)
      ? compareSubtotal - discountedTotal
      : priceSubtotal - discountedTotal;

    return {
      priceSubtotal,
      compareSubtotal,
      originalTotal,
      discountedTotal,
      savings
    };
  }

  function getGoalSubtitleForSlot(slotIndex) {
    const goalIndex = hasFreeProductSlot() ? Math.max(0, slotIndex - 1) : slotIndex;
    if (goalIndex < goals.length) {
      return goals[goalIndex].subtitle || '';
    }
    return '';
  }

  function getProductCount(productId) {
    return selectedVariantIds.filter((variantId) => {
      const product = Object.values(productsById).find((item) => String(item.variantId) === String(variantId));
      return product && String(product.id) === String(productId);
    }).length;
  }

  function setProductQuantity(variantId, productId, quantity) {
    const remaining = selectedVariantIds.filter((id) => {
      const product = Object.values(productsById).find((item) => String(item.variantId) === String(id));
      return !product || String(product.id) !== String(productId);
    });

    const maxQty = getSelectableMaxProducts() - remaining.length;
    const clampedQty = Math.max(0, Math.min(quantity, maxQty));

    selectedVariantIds.length = 0;
    selectedVariantIds.push(...remaining);

    for (let i = 0; i < clampedQty; i += 1) {
      selectedVariantIds.push(String(variantId));
    }

    updateUI();
  }

  function bindQuantitySelector(card) {
    const selector = card.querySelector('quantity-selector');
    if (!selector || selector.dataset.sparsetBound === 'true') return;

    const productId = String(card.getAttribute('data-product-id'));
    const variantId = card.getAttribute('data-variant-id');
    const input = card.querySelector('[data-sparset-quantity-input]');
    const minusBtn = selector.querySelector('button:first-of-type');
    const plusBtn = selector.querySelector('button:last-of-type');

    const applyQuantity = (quantity) => {
      setProductQuantity(variantId, productId, quantity);
    };

    const onMinus = (event) => {
      event.preventDefault();
      event.stopImmediatePropagation();
      applyQuantity(getProductCount(productId) - 1);
    };

    const onPlus = (event) => {
      event.preventDefault();
      event.stopImmediatePropagation();
      applyQuantity(getProductCount(productId) + 1);
    };

    const onInputChange = () => {
      applyQuantity(parseInt(input.value, 10) || 0);
    };

    minusBtn?.addEventListener('click', onMinus, true);
    plusBtn?.addEventListener('click', onPlus, true);
    input?.addEventListener('change', onInputChange);

    selector.dataset.sparsetBound = 'true';
  }

  function updateProductCards() {
    const count = selectedVariantIds.length;
    const atMax = count >= getSelectableMaxProducts();
    const cardTierPercent = getTierPercentForNextPlaceholder();

    root.querySelectorAll('.bk-media-sparset-builder__card').forEach((card) => {
      const productId = String(card.getAttribute('data-product-id'));
      const addButton = card.querySelector('[data-action="add-product"]');
      const quantityWrap = card.querySelector('[data-sparset-quantity-wrap]');
      const quantityInput = card.querySelector('[data-sparset-quantity-input]');
      const priceEl = card.querySelector('[data-card-price]');
      const discountBadge = card.querySelector('[data-card-discount-badge]');
      const productCount = getProductCount(productId);
      const basePrice = parseInt(card.getAttribute('data-base-price') || priceEl?.getAttribute('data-base-price') || '0', 10);
      const compareAtPrice = parseInt(card.getAttribute('data-compare-at-price') || '0', 10);
      const badgePercent = getProductBadgePercent(basePrice, compareAtPrice, cardTierPercent);

      card.classList.toggle('is-selected', productCount > 0);
      card.classList.toggle('is-addable', card.getAttribute('data-available') === 'true' && !atMax);

      if (priceEl && basePrice > 0) {
        priceEl.innerHTML = renderPriceMarkup(basePrice, cardTierPercent, compareAtPrice);
      }

      if (discountBadge) {
        if (badgePercent > 0) {
          discountBadge.textContent = `-${badgePercent}%`;
          discountBadge.hidden = false;
        } else {
          discountBadge.textContent = '';
          discountBadge.hidden = true;
        }
      }

      if (productCount > 0) {
        if (addButton) addButton.hidden = true;
        if (quantityWrap) quantityWrap.hidden = false;
        if (quantityInput) {
          quantityInput.value = String(productCount);
          quantityInput.size = Math.max(String(productCount).length + 1, 2);
        }
        bindQuantitySelector(card);
      } else {
        if (addButton) {
          addButton.hidden = false;
          addButton.disabled = atMax || card.getAttribute('data-available') !== 'true';
        }
        if (quantityWrap) quantityWrap.hidden = true;
      }
    });

    applyProductFilter();
  }

  function normalizeSearchValue(value) {
    return String(value || '')
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .trim();
  }

  function setSearchOpen(open) {
    if (!searchWrap || !searchToggle) return;
    searchWrap.classList.toggle('is-open', open);
    searchToggle.setAttribute('aria-expanded', String(open));
    const searchIcon = searchToggle.querySelector('[data-search-icon]');
    const closeIcon = searchToggle.querySelector('[data-close-icon]');
    if (searchIcon) searchIcon.hidden = open;
    if (closeIcon) closeIcon.hidden = !open;
    if (searchInput) {
      searchInput.setAttribute('tabindex', open ? '0' : '-1');
      if (open) searchInput.focus();
    }
  }

  function applyProductFilter() {
    const active = root.querySelector('[data-sparset-filter][aria-pressed="true"]');
    const rawIds = active ? active.getAttribute('data-product-ids') || '' : '';
    const allowedIds = rawIds ? rawIds.split(',').filter(Boolean) : null;
    const query = searchInput ? normalizeSearchValue(searchInput.value) : '';
    const hasActiveFilter = Boolean(allowedIds);
    let visibleCount = 0;

    root.querySelectorAll('.bk-media-sparset-builder__card').forEach((card) => {
      const productId = String(card.getAttribute('data-product-id'));
      const title = normalizeSearchValue(
        card.getAttribute('data-search-title')
          || card.querySelector('.bk-media-sparset-builder__card-title')?.textContent
          || card.querySelector('.product-card__title')?.textContent
          || ''
      );
      const matchesFilter = !(allowedIds && !allowedIds.includes(productId));
      const matchesSearch = !query || title.includes(query);
      const matches = matchesFilter && matchesSearch;
      card.hidden = !matches;
      if (matches) visibleCount += 1;
    });

    if (searchEmptyEl) {
      searchEmptyEl.hidden = visibleCount > 0 || (!query && !hasActiveFilter);
    }

    if (searchToggle && searchInput) {
      searchToggle.classList.toggle('has-query', Boolean(searchInput.value.trim()));
    }
  }

  function adjustGoalNodePositions() {
    const track = root.querySelector('.bk-media-sparset-builder__goals-track');
    if (!track || !goalNodes.length) return;

    const inset = 8;
    const minBound = inset;
    const maxBound = 100 - inset;
    const trackWidth = track.offsetWidth || 1;

    const items = Array.from(goalNodes).map((node) => ({
      node,
      ideal: parseFloat(node.getAttribute('data-goal-ideal-position') || node.getAttribute('data-goal-position') || '0'),
      quantity: parseInt(node.getAttribute('data-goal-quantity'), 10)
    })).sort((a, b) => a.ideal - b.ideal);

    const count = items.length;
    if (!count) return;

    let maxNodeWidth = 44;
    items.forEach((item) => {
      maxNodeWidth = Math.max(maxNodeWidth, item.node.offsetWidth || 0);
    });

    const minGapPercent = Math.min(16, Math.max(7, (maxNodeWidth / trackWidth) * 100 * 0.95));
    let positions = [];

    if (count === 1) {
      positions = [Math.max(minBound, Math.min(maxBound, items[0].ideal))];
    } else {
      const ideals = items.map((item) => item.ideal);
      const available = maxBound - minBound;
      const required = (count - 1) * minGapPercent;
      const extra = available - required;

      if (extra <= 0) {
        for (let i = 0; i < count; i += 1) {
          positions[i] = minBound + (i / (count - 1)) * available;
        }
      } else {
        const idealGaps = [];
        let totalIdealGap = 0;

        for (let i = 0; i < count - 1; i += 1) {
          const gap = Math.max(0, ideals[i + 1] - ideals[i]);
          idealGaps.push(gap);
          totalIdealGap += gap;
        }

        positions[0] = minBound;
        for (let i = 0; i < count - 1; i += 1) {
          const extraGap = totalIdealGap > 0 ? (idealGaps[i] / totalIdealGap) * extra : extra / (count - 1);
          positions[i + 1] = positions[i] + minGapPercent + extraGap;
        }
      }
    }

    items.forEach((item, index) => {
      const position = Math.round(positions[index] * 10) / 10;
      item.node.style.setProperty('--goal-position', `${position}%`);
      item.node.setAttribute('data-goal-position', String(position));
    });
  }

  function getGoalNodesData() {
    return Array.from(goalNodes).map((node) => ({
      quantity: parseInt(node.getAttribute('data-goal-quantity'), 10),
      position: parseFloat(node.getAttribute('data-goal-position') || node.style.getPropertyValue('--goal-position') || '0')
    })).sort((a, b) => a.quantity - b.quantity);
  }

  function getProgressPercent(count) {
    const nodes = getGoalNodesData();

    if (!nodes.length) {
      return Math.min((count / maxProducts) * 100, 100);
    }

    if (count <= 0) return 0;

    const lastNode = nodes[nodes.length - 1];
    if (count >= lastNode.quantity) {
      return lastNode.position;
    }

    let prev = { quantity: 0, position: 0 };

    for (let i = 0; i < nodes.length; i += 1) {
      const node = nodes[i];

      if (count === node.quantity) {
        return node.position;
      }

      if (count < node.quantity) {
        const range = node.quantity - prev.quantity;
        const ratio = range > 0 ? (count - prev.quantity) / range : 0;
        return prev.position + ratio * (node.position - prev.position);
      }

      prev = node;
    }

    return lastNode.position;
  }

  function updateUI() {
    const count = selectedVariantIds.length;
    const progress = getProgressPercent(count);
    const goalPercent = getDiscountPercent(count);
    const totals = getSelectionTotals(count);

    countEls.forEach((el) => {
      el.textContent = `${count} / ${maxProducts}`;
    });

    if (goalsFill) {
      goalsFill.style.width = `${progress}%`;
    }

    goalNodes.forEach((node) => {
      const quantity = parseInt(node.getAttribute('data-goal-quantity'), 10);
      const goalDiscount = parseInt(node.getAttribute('data-goal-discount'), 10);
      const discountEl = node.querySelector('.bk-media-sparset-builder__goal-discount');

      node.classList.toggle('is-reached', count >= quantity);

      if (discountEl && !Number.isNaN(goalDiscount)) {
        discountEl.textContent = `${getCombinedDiscountPercent(goalDiscount)}%`;
      }
    });

    slots.forEach((slot, index) => {
      if (slot.hasAttribute('data-free-product-slot')) {
        renderFreeProductSlot(slot);
        return;
      }

      const titleEl = slot.querySelector('[data-slot-title]');
      const subtitleEl = slot.querySelector('[data-slot-subtitle]');
      const iconEl = slot.querySelector('.bk-media-sparset-builder__slot-icon');
      const removeBtn = slot.querySelector('[data-action="remove-slot"]');
      const selectedIndex = getSelectedIndexForSlot(index);
      const variantId = selectedIndex >= 0 ? selectedVariantIds[selectedIndex] : null;
      const product = variantId ? Object.values(productsById).find((item) => String(item.variantId) === String(variantId)) : null;

      slot.classList.remove('is-free-product');

      if (product) {
        slot.classList.add('is-filled');
        if (titleEl) titleEl.textContent = product.title;
        if (subtitleEl) {
          subtitleEl.innerHTML = renderPriceMarkup(product.price, goalPercent, product.compareAtPrice, false);
        }
        if (iconEl) {
          iconEl.innerHTML = product.image
            ? `<img src="${product.image}" alt="${product.title.replace(/"/g, '&quot;')}" width="48" height="48" loading="lazy">`
            : '';
        }
        if (removeBtn) removeBtn.hidden = false;
      } else {
        slot.classList.remove('is-filled');
        if (titleEl) titleEl.textContent = config.emptySlotText || 'Wähle ein Produkt';
        if (subtitleEl) {
          const subtitle = getGoalSubtitleForSlot(index);
          subtitleEl.textContent = subtitle;
        }
        if (iconEl) {
          iconEl.innerHTML = '<svg role="presentation" focusable="false" width="14" height="14" viewBox="0 0 10 10"><path d="M5 1V9M1 5H9" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg>';
        }
        if (removeBtn) removeBtn.hidden = true;
      }
    });

    if (savingsRow && savingsAmountEl) {
      const showSavings = count > 0 && totals.savings > 0;
      savingsRow.hidden = !showSavings;
      if (showSavings) {
        savingsAmountEl.textContent = `-${formatSparsetMoney(totals.savings)}`;
      }
    }

    updatePreviewDiscountRow(count, totals);

    if (atcPricesEl && atcSalePriceEl && atcComparePriceEl) {
      const showAtcPrices = count > 0;

      atcPricesEl.hidden = !showAtcPrices;

      if (showAtcPrices) {
        atcSalePriceEl.textContent = formatSparsetMoney(totals.discountedTotal);

        if (goalPercent > 0 && totals.discountedTotal < totals.originalTotal) {
          atcComparePriceEl.textContent = formatSparsetMoney(totals.originalTotal);
          atcComparePriceEl.hidden = false;
        } else {
          atcComparePriceEl.textContent = '';
          atcComparePriceEl.hidden = true;
        }
      }
    }

    if (atcButton) {
      atcButton.disabled = count < minProducts;
    }

    updateProductCards();
    maybeRetryPreviewDiscount(count);
    maybeCelebrateNewlyReachedGoals(count);
  }

  function addProduct(variantId) {
    if (selectedVariantIds.length >= getSelectableMaxProducts()) return false;
    selectedVariantIds.push(String(variantId));
    updateUI();
    return true;
  }

  function removeProductAt(index) {
    if (index < 0 || index >= selectedVariantIds.length) return;
    selectedVariantIds.splice(index, 1);
    updateUI();
  }

  function handleCardAdd(card) {
    if (!card || card.getAttribute('data-available') !== 'true') return;
    if (selectedVariantIds.length >= getSelectableMaxProducts()) return;
    addProduct(card.getAttribute('data-variant-id'));
  }

  referralInput?.addEventListener('input', function () {
    referralCodeValue = referralInput.value.trim();
  });

  root.addEventListener('click', function (event) {
    const searchToggleBtn = event.target.closest('[data-sparset-search-toggle]');
    if (searchToggleBtn) {
      const isOpen = searchWrap?.classList.contains('is-open');
      setSearchOpen(!isOpen);
      return;
    }

    const filterBtn = event.target.closest('[data-sparset-filter]');
    if (filterBtn) {
      root.querySelectorAll('[data-sparset-filter]').forEach((button) => {
        button.setAttribute('aria-pressed', button === filterBtn ? 'true' : 'false');
      });
      applyProductFilter();
      return;
    }

    const addProductBtn = event.target.closest('[data-action="add-product"]');
    if (addProductBtn) {
      const card = addProductBtn.closest('.bk-media-sparset-builder__card');
      if (!card || addProductBtn.disabled) return;
      handleCardAdd(card);
      return;
    }

    const card = event.target.closest('.bk-media-sparset-builder__card');
    if (card && !event.target.closest('quantity-selector')) {
      handleCardAdd(card);
      return;
    }

    const removeSlotBtn = event.target.closest('[data-action="remove-slot"]');
    if (removeSlotBtn) {
      const slot = removeSlotBtn.closest('.bk-media-sparset-builder__slot');
      if (!slot || slot.hasAttribute('data-free-product-slot')) return;
      const slotIndex = parseInt(slot.getAttribute('data-slot-index'), 10);
      const selectedIndex = getSelectedIndexForSlot(slotIndex);
      if (selectedIndex < 0) return;
      removeProductAt(selectedIndex);
      return;
    }

    const toggleBtn = event.target.closest('[data-action="toggle-panel"]');
    if (toggleBtn && panel) {
      const expanded = panel.getAttribute('data-expanded') === 'true';
      panel.setAttribute('data-expanded', expanded ? 'false' : 'true');
      toggleBtn.setAttribute('aria-expanded', expanded ? 'false' : 'true');
      return;
    }

    const atcBtn = event.target.closest('[data-action="add-to-cart"]');
    if (atcBtn) {
      handleAddToCart(atcBtn);
    }
  });

  if (searchInput) {
    searchInput.addEventListener('input', applyProductFilter);
    searchInput.addEventListener('search', applyProductFilter);
    searchInput.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') {
        setSearchOpen(false);
        searchToggle?.focus();
      }
    });
  }

  function getReferralCodeFromUrl() {
    const param = (config.referralUrlParam || 'ref').trim();
    if (!param) return '';

    try {
      const value = new URLSearchParams(window.location.search).get(param);
      return value ? value.trim() : '';
    } catch (error) {
      return '';
    }
  }

  function getActiveReferralCode() {
    const fromInput = referralInput?.value?.trim();
    if (fromInput) return fromInput;
    if (referralCodeValue) return referralCodeValue;
    return (config.defaultReferralCode || '').trim();
  }

  function initReferralCode() {
    referralCodeValue = getReferralCodeFromUrl() || (config.defaultReferralCode || '').trim();

    if (referralInput && referralCodeValue) {
      referralInput.value = referralCodeValue;
    }
  }

  async function updateCartTrackingAttributes(referralCode, discountPercent, bundleMeta = null) {
    const cartBefore = await fetch(`${window.Shopify.routes.root}cart.js`).then((response) => response.json());
    const attributes = {};

    if (cartBefore.attributes) {
      Object.keys(cartBefore.attributes).forEach((key) => {
        const value = cartBefore.attributes[key];
        if (value != null && String(value).trim() !== '') {
          attributes[key] = String(value);
        }
      });
    }

    if (referralCode) {
      attributes.referral_code = referralCode;
    } else {
      delete attributes.referral_code;
    }

    if (discountPercent > 0) {
      attributes.bundle_discount_percent = String(discountPercent);
    } else {
      delete attributes.bundle_discount_percent;
    }

    if (bundleMeta?.bundleId && bundleMeta.bundleComponents) {
      attributes[`bundle_components_${bundleMeta.bundleId}`] = bundleMeta.bundleComponents;
    }

    if (bundleMeta?.bundleId && bundleMeta.totals) {
      attributes[`bundle_compare_total_${bundleMeta.bundleId}`] = String(bundleMeta.totals.priceSubtotal || 0);
      attributes[`bundle_sale_total_${bundleMeta.bundleId}`] = String(bundleMeta.totals.discountedTotal || 0);
      attributes[`bundle_compare_at_total_${bundleMeta.bundleId}`] = String(bundleMeta.totals.compareSubtotal || 0);
      attributes[`bundle_discount_percent_${bundleMeta.bundleId}`] = String(bundleMeta.discountPercent || 0);
      attributes[`bundle_show_compare_at_${bundleMeta.bundleId}`] = config.showVariantCompareAt ? 'true' : 'false';
    }

    const response = await fetch(`${window.Shopify.routes.root}cart/update.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes })
    });

    if (!response.ok) {
      throw new Error('Failed to update cart tracking attributes');
    }

    return response.json();
  }

  function generateBundleId(group) {
    const bundleGroup = group || 'starter';
    let instanceId;

    if (typeof crypto !== 'undefined' && crypto.randomUUID) {
      instanceId = crypto.randomUUID().replace(/-/g, '');
    } else {
      instanceId = `${Date.now().toString(36)}${Math.random().toString(36).slice(2, 10)}`;
    }

    return `${bundleGroup}-${instanceId}`;
  }

  function buildBundleComponentsProperty(itemQuantities) {
    return Object.keys(itemQuantities).map((id) => {
      const qty = itemQuantities[id];
      const product = Object.values(productsById).find((item) => String(item.variantId) === String(id));
      const title = encodeURIComponent(product?.title || '');
      const image = product?.image ? encodeURIComponent(product.image) : '';
      return image ? `${id}::${qty}::${title}::${image}` : `${id}::${qty}::${title}`;
    }).join('||');
  }

  function bundleLineProperties(bundleId, parentVariantId, bundleTitle, bundleTotals, bundleComponents, tracking = {}) {
    const props = {
      _BundleId: bundleId,
      _BundleIsParent: 'true',
      '_Bundle role': 'parent'
    };

    if (parentVariantId) {
      props._BundleParentVariantId = String(parentVariantId);
    }

    if (bundleTitle) {
      props._BundleTitle = bundleTitle;
    }

    if (bundleTotals?.priceSubtotal > 0) {
      props._BundleCompareTotal = String(bundleTotals.priceSubtotal);
    }

    if (bundleTotals?.compareSubtotal > 0) {
      props._BundleCompareAtTotal = String(bundleTotals.compareSubtotal);
    }

    if (bundleTotals?.discountedTotal > 0) {
      props._BundleDiscountedTotal = String(bundleTotals.discountedTotal);
    }

    props._BundleShowVariantCompareAt = config.showVariantCompareAt ? 'true' : 'false';

    props['_Bundle pricing'] = [
      bundleTotals?.priceSubtotal || 0,
      bundleTotals?.discountedTotal || 0,
      tracking.discountPercent || 0,
      bundleTotals?.compareSubtotal || 0
    ].join('|');

    if (bundleComponents) {
      props._BundleComponents = bundleComponents;
    }

    if (tracking.referralCode) {
      props._BundleReferralCode = tracking.referralCode;
    }

    if (tracking.discountPercent > 0) {
      props._BundleDiscountPercent = String(tracking.discountPercent);
    }

    return props;
  }

  async function handleAddToCart(button) {
    if (button.disabled || button.getAttribute('aria-busy') === 'true') return;
    if (selectedVariantIds.length < minProducts) return;

    const parentVariantId = config.parentVariantId ? parseInt(config.parentVariantId, 10) : null;
    if (!parentVariantId) {
      alert('Bundle parent product is missing. Add this section to a product page or set a parent product.');
      return;
    }

    button.setAttribute('aria-busy', 'true');
    button.disabled = true;

    try {
      const bundleId = generateBundleId(config.bundleGroup || 'starter');
      const bundleTotals = getSelectionTotals(selectedVariantIds.length);
      const discountPercent = getDiscountPercent(selectedVariantIds.length);
      const referralCode = getActiveReferralCode();

      const itemQuantities = {};
      selectedVariantIds.forEach((variantId) => {
        const id = parseInt(variantId, 10);
        itemQuantities[id] = (itemQuantities[id] || 0) + 1;
      });

      const bundleComponents = buildBundleComponentsProperty(itemQuantities);

      const parentLineProps = bundleLineProperties(
        bundleId,
        parentVariantId,
        config.bundleTitle || 'Mein Sparset',
        bundleTotals,
        bundleComponents,
        { referralCode, discountPercent }
      );
      const childLineProps = {
        _BundleId: bundleId,
        '_Bundle role': 'child',
        _BundleParentVariantId: String(parentVariantId)
      };

      const items = [
        { id: parentVariantId, quantity: 1, properties: parentLineProps }
      ];

      Object.keys(itemQuantities).forEach((id) => {
        const variantId = parseInt(id, 10);
        if (variantId === parentVariantId) return;

        items.push({
          id: variantId,
          quantity: itemQuantities[id],
          properties: childLineProps
        });
      });

      const nativeCartDrawer = document.querySelector('cart-drawer');
      const requestBody = { items };
      let sectionId = null;

      if (nativeCartDrawer) {
        const sectionsToBundle = ['variant-added'];
        document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections', {
          bubbles: true,
          detail: { sections: sectionsToBundle }
        }));

        sectionId = nativeCartDrawer.getAttribute('data-section-id') || 'cart-drawer';
        if (!sectionsToBundle.includes(sectionId)) {
          sectionsToBundle.push(sectionId);
        }
        requestBody.sections = sectionsToBundle.join(',');
        requestBody.sections_url = bkMediaCartSectionsUrl();
      }

      const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify(requestBody)
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.description || 'Failed to add items to cart');
      }

      const responseJson = await response.json();

      await updateCartTrackingAttributes(referralCode, discountPercent, {
        bundleId,
        bundleComponents,
        discountPercent,
        totals: {
          priceSubtotal: bundleTotals.priceSubtotal,
          discountedTotal: bundleTotals.discountedTotal,
          compareSubtotal: bundleTotals.compareSubtotal
        }
      });

      const cartContent = await (await fetch(`${window.Shopify.routes.root}cart.js`)).json();

      if (nativeCartDrawer && sectionId && (!responseJson.sections || !responseJson.sections[sectionId])) {
        const cartDrawerResponse = await fetch(bkMediaCartSectionRequestUrl(sectionId));
        const cartDrawerHtml = await cartDrawerResponse.text();
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = cartDrawerHtml;
        const newCartDrawer = tempDiv.querySelector('#cart-drawer, cart-drawer');
        if (newCartDrawer) {
          if (!responseJson.sections) responseJson.sections = {};
          responseJson.sections[sectionId] = newCartDrawer.outerHTML;
        }
      }

      if (!cartContent.sections) cartContent.sections = {};
      cartContent.sections = Object.assign(cartContent.sections, responseJson.sections || {});

      const productForm = document.querySelector('form[is="product-form"]');
      const formToUse = productForm || document.createElement('form');
      let formAdded = false;

      if (!productForm) {
        document.body.appendChild(formToUse);
        formAdded = true;
      }

      bkMediaCelebrateSparsetAdd(button);

      const nextCart = await bkMediaNormalizeCart(cartContent);

      formToUse.dispatchEvent(new CustomEvent('variant:add', {
        bubbles: true,
        cancelable: true,
        detail: {
          items: responseJson.items || [responseJson],
          cart: nextCart
        }
      }));

      await bkMediaDispatchCartChange(nextCart, 'variant:add');

      if (formAdded) {
        document.body.removeChild(formToUse);
      }

      bkMediaScheduleCelebrationOnTop();
    } catch (error) {
      console.error('Error adding sparset to cart:', error);
      alert(error.message || 'Produkte konnten nicht hinzugefügt werden.');
    } finally {
      button.removeAttribute('aria-busy');
      button.disabled = selectedVariantIds.length < minProducts;
    }
  }

  let resizeTimeout;
  const onResize = () => {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(() => {
      adjustGoalNodePositions();
      updateUI();
    }, 150);
  };

  window.addEventListener('resize', onResize);

  const fallbackPreviewPercent = getPreviewDiscountFallbackPercent();
  resolvedPreviewDiscount = {
    type: fallbackPreviewPercent > 0 ? 'percentage' : null,
    value: fallbackPreviewPercent,
    code: null,
    loaded: true
  };

  initReferralCode();

  requestAnimationFrame(() => {
    adjustGoalNodePositions();
    updateUI();
  });

  if ((config.previewDiscountCode || '').trim()) {
    resolvePreviewDiscountCode().then(() => updateUI());
  }

  root.bkMediaSetVariants = function (variantIds, options = {}) {
    const replace = options.replace !== false;
    const shouldScroll = options.scroll === true;
    const validIds = [];

    (variantIds || []).forEach((variantId) => {
      const id = String(variantId);
      const product = productsByVariantId[id];

      if (product && product.available && !validIds.includes(id)) {
        validIds.push(id);
      }
    });

    const limitedIds = validIds.slice(0, getSelectableMaxProducts());

    if (replace) {
      selectedVariantIds.length = 0;
    }

    limitedIds.forEach((id) => {
      if (!selectedVariantIds.includes(id) && selectedVariantIds.length < getSelectableMaxProducts()) {
        selectedVariantIds.push(id);
      }
    });

    suppressGoalCelebration = true;
    updateUI();

    if (selectedVariantIds.length > 0) {
      bkMediaCelebrateSparsetAdd(root);
    }

    if (panel && window.matchMedia('(max-width: 999px)').matches) {
      panel.setAttribute('data-expanded', 'true');
      const toggleBtn = root.querySelector('[data-action="toggle-panel"]');
      toggleBtn?.setAttribute('aria-expanded', 'true');
    }

    if (shouldScroll) {
      const section = root.closest('[id^="shopify-section-"]');
      const scrollTarget = section || root;
      const stickyOffset = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--sticky-area-height')) || 0;

      requestAnimationFrame(() => {
        const top = scrollTarget.getBoundingClientRect().top + window.scrollY - stickyOffset - 16;
        window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
      });
    }

    return {
      added: selectedVariantIds.length,
      skipped: Math.max(0, validIds.length - limitedIds.length)
    };
  };

  root.bkMediaAddVariantsToCart = async function (variantIds, options = {}) {
    root.bkMediaSetVariants(variantIds, {
      replace: options.replace !== false,
      scroll: options.scroll === true
    });

    const button = options.button || atcButton;
    if (!button) return { added: selectedVariantIds.length, addedToCart: false };

    await handleAddToCart(button);
    return { added: selectedVariantIds.length, addedToCart: true };
  };

  try {
    const storageKey = 'bk-media-comparison-bundle-variants';
    const sectionKey = 'bk-media-comparison-sparset-section-id';
    let variantIds = [];

    const stored = sessionStorage.getItem(storageKey);
    if (stored) {
      const parsed = JSON.parse(stored);
      if (Array.isArray(parsed)) variantIds = parsed;
    }

    if (!variantIds.length) {
      const urlParam = new URLSearchParams(window.location.search).get('variants');
      if (urlParam) {
        variantIds = urlParam.split(',').map((value) => value.trim()).filter(Boolean);
      }
    }

    if (Array.isArray(variantIds) && variantIds.length) {
      const sectionId = sessionStorage.getItem(sectionKey) || '';
      const section = sectionId ? document.getElementById(sectionId) : null;
      const targetBuilder = section?.querySelector('bk-media-sparset-builder') || root;

      if (targetBuilder === root && typeof root.bkMediaSetVariants === 'function') {
        const autoAdd = sessionStorage.getItem('bk-media-comparison-bundle-auto-add') === '1';
        sessionStorage.removeItem(storageKey);
        sessionStorage.removeItem(sectionKey);
        sessionStorage.removeItem('bk-media-comparison-bundle-auto-add');

        if (autoAdd && typeof root.bkMediaAddVariantsToCart === 'function') {
          root.bkMediaAddVariantsToCart(variantIds, { replace: true, scroll: true });
        } else {
          root.bkMediaSetVariants(variantIds, { replace: true, scroll: true });
        }

        if (window.history?.replaceState) {
          const cleanUrl = new URL(window.location.href);
          cleanUrl.searchParams.delete('variants');
          window.history.replaceState({}, '', `${cleanUrl.pathname}${cleanUrl.search}${cleanUrl.hash}`);
        }
      }
    }
  } catch (error) {
    console.error('Failed to prefill sparset builder from comparison:', error);
  }

  root._bkMediaSparsetInitialized = true;
}

function initAllBkMediaSparsetBuilders() {
  document.querySelectorAll('bk-media-sparset-builder').forEach(initBkMediaSparsetBuilder);
}

document.addEventListener('DOMContentLoaded', initAllBkMediaSparsetBuilders);
document.addEventListener('shopify:section:load', function (event) {
  setTimeout(function () {
    const builders = event.target ? event.target.querySelectorAll('bk-media-sparset-builder') : [];
    if (builders.length) {
      builders.forEach(function (root) {
        root._bkMediaSparsetInitialized = false;
        initBkMediaSparsetBuilder(root);
      });
      return;
    }
    initAllBkMediaSparsetBuilders();
  }, 100);
});

/* bk-media-sparset-builder end */

/* bk-media-bundle-cart-components start */

function bkMediaDisableCartDrawerProductLinks(scope) {
  const root = scope || document;

  root.querySelectorAll('.cart-drawer .line-item--no-product-link').forEach((lineItem) => {
    const mediaWrapper = lineItem.querySelector('.line-item__media-wrapper');
    if (!mediaWrapper) return;

    if (mediaWrapper.tagName === 'A') {
      const div = document.createElement('div');
      div.className = mediaWrapper.className;
      div.innerHTML = mediaWrapper.innerHTML;
      mediaWrapper.replaceWith(div);
      return;
    }

    mediaWrapper.querySelectorAll('a[href*="/products/"]').forEach((anchor) => {
      const replacement = document.createElement('span');
      replacement.className = anchor.className;
      replacement.innerHTML = anchor.innerHTML;
      anchor.replaceWith(replacement);
    });
  });
}

function initBkMediaBundleCartComponents() {
  document.querySelectorAll('.bk-media-line-item-components-disclosure').forEach((disclosure) => {
    disclosure.open = true;
    disclosure.setAttribute('aria-expanded', 'true');
  });

  bkMediaDisableCartDrawerProductLinks();
}

document.addEventListener('DOMContentLoaded', initBkMediaBundleCartComponents);
document.addEventListener('cart:change', () => {
  requestAnimationFrame(initBkMediaBundleCartComponents);
});
document.addEventListener('shopify:section:load', () => {
  setTimeout(initBkMediaBundleCartComponents, 100);
});

/* bk-media-bundle-cart-components end */

/* bk-media-comparison-back-link start */

function initBkMediaComparisonBackLink() {
  const params = new URLSearchParams(window.location.search);
  const returnUrl = params.get('comparison_return');

  if (!returnUrl) return;

  const wrapper = document.querySelector('[data-comparison-back]');
  const link = document.querySelector('[data-comparison-back-link]');

  if (!wrapper || !link) return;

  try {
    const decoded = decodeURIComponent(returnUrl);

    if (!decoded.startsWith('/')) return;

    link.href = decoded;
    wrapper.hidden = false;
  } catch (error) {
    console.error('Failed to parse comparison return URL:', error);
  }
}

document.addEventListener('DOMContentLoaded', initBkMediaComparisonBackLink);
document.addEventListener('shopify:section:load', initBkMediaComparisonBackLink);

/* bk-media-comparison-back-link end */

/* bk-media-free-shipping-wunschset start */

function getBkMediaCartItemProperties(item) {
  if (!item?.properties) return {};
  if (Array.isArray(item.properties)) {
    return item.properties.reduce((props, entry) => {
      const key = entry.name || entry.first || entry.key;
      const value = entry.value || entry.last;
      if (key) props[key] = value;
      return props;
    }, {});
  }
  return item.properties;
}

function getBkMediaShippingEligibleTotal(cart) {
  if (!cart?.items?.length) return 0;

  const attrs = cart.attributes || {};
  const bundleGroups = new Map();
  let total = 0;

  cart.items.forEach((item) => {
    const props = getBkMediaCartItemProperties(item);
    const bundleId = props._BundleId ? String(props._BundleId) : '';
    const bundleRole = String(props['_Bundle role'] || props['Bundle role'] || '').trim().toLowerCase();
    const isBundleParent = bundleRole === 'parent'
      || String(props._BundleIsParent || '').toLowerCase() === 'true'
      || !!props._BundleComponents
      || !!props._BundleTitle;
    const isBundleChild = bundleRole === 'child'
      || String(props._BundleIsChild || '').toLowerCase() === 'true';
    const linePrice = Number(item.final_line_price || item.line_price || 0) || 0;

    if (bundleId) {
      const group = bundleGroups.get(bundleId) || { lines: 0, declared: 0 };
      group.lines += linePrice;

      if (isBundleParent || !isBundleChild) {
        const pricingRaw = props['_Bundle pricing'] || props['Bundle pricing'] || '';
        const pricingSale = parseInt(String(pricingRaw).split('|')[1], 10) || 0;
        const propSale = parseInt(props._BundleDiscountedTotal, 10) || 0;
        const attrSale = parseInt(attrs[`bundle_sale_total_${bundleId}`], 10) || 0;
        group.declared = Math.max(group.declared, propSale, pricingSale, attrSale, Number.isNaN(attrSale) ? 0 : attrSale);
      }

      bundleGroups.set(bundleId, group);
      return;
    }

    if (item.requires_shipping || isBundleParent || isBundleChild) {
      total += linePrice;
    }
  });

  bundleGroups.forEach((group) => {
    total += group.lines > 0 ? group.lines : group.declared;
  });

  if (total <= 0 && Number(cart.total_price) > 0) {
    const hasBundle = cart.items.some((item) => {
      const props = getBkMediaCartItemProperties(item);
      return !!(props._BundleId || props._BundleIsParent || props['_Bundle role'] || props['Bundle role'] || props._BundleComponents || props._BundleTitle);
    });

    if (hasBundle) {
      total = Number(cart.total_price) || 0;
    }
  }

  const cartDiscount = (cart.cart_level_discount_applications || []).reduce((sum, discountAllocation) => {
    return sum + (discountAllocation.total_allocated_amount || 0);
  }, 0);

  return Math.max(0, total - cartDiscount);
}

function formatBkMediaFreeShippingMoney(cents) {
  const amount = Math.max(0, Math.round(Number(cents) || 0));

  if (typeof formatMoney === 'function') {
    return formatMoney(amount);
  }

  if (typeof Shopify !== 'undefined' && Shopify.formatMoney) {
    const moneyFormat = window.themeVariables?.settings?.moneyFormat;
    return moneyFormat ? Shopify.formatMoney(amount, moneyFormat) : Shopify.formatMoney(amount);
  }

  return new Intl.NumberFormat('de-DE', {
    style: 'currency',
    currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR'
  }).format(amount / 100);
}

function updateBkMediaFreeShippingMessage(bar) {
  if (!bar) return;

  const messageElement = bar.querySelector('[data-free-shipping-message]') || bar.querySelector(':scope > span');
  if (!messageElement) return;

  const threshold = parseFloat(bar.getAttribute('threshold')) || 0;
  const totalPrice = parseFloat(bar.getAttribute('total-price')) || 0;
  const reachedMessage = bar.getAttribute('reached-message') || '';
  const unreachedMessage = bar.getAttribute('unreached-message') || '';

  if (totalPrice >= threshold && threshold > 0) {
    let nextReachedMessage = reachedMessage || 'Glückwunsch! <strong>GRATIS VERSAND</strong> freigeschaltet! 🎉';
    if (!/<strong[^>]*>\s*GRATIS\s+VERSAND\s*<\/strong>/i.test(nextReachedMessage)) {
      nextReachedMessage = nextReachedMessage.replace(/\bGRATIS VERSAND\b/gi, '<strong>GRATIS VERSAND</strong>');
    }

    messageElement.innerHTML = nextReachedMessage;
    bar.setAttribute('data-free-shipping-reached', 'true');
    return;
  }

  const remaining = Math.max(0, threshold - totalPrice);
  const remainingHtml = `<span class="bold">${formatBkMediaFreeShippingMoney(remaining)}</span>`;
  const nextMessage = (unreachedMessage || 'Noch {{ amount }} für GRATIS Versand')
    .replace(/\[\s*amount\s*\]/gi, remainingHtml)
    .replace(/\{\{\s*(amount|remaining_amount)\s*\}\}/gi, remainingHtml);

  messageElement.innerHTML = nextMessage;
  bar.setAttribute('data-free-shipping-reached', 'false');
}

function updateBkMediaFreeShippingProgress(bar) {
  if (!bar) return;

  const progressBarElement = bar.querySelector('progress-bar');
  if (!progressBarElement) return;

  const threshold = parseFloat(bar.getAttribute('threshold')) || 0;
  const totalPrice = parseFloat(bar.getAttribute('total-price')) || 0;
  const progress = threshold > 0 ? Math.max(0, Math.min(1, totalPrice / threshold)) : 0;

  progressBarElement.valueMax = threshold;
  progressBarElement.valueNow = totalPrice;
  progressBarElement.style.setProperty('--progress', String(progress));
}

async function syncBkMediaFreeShippingBar(bar, cart) {
  if (!bar) return;

  if (cart) {
    bar.totalPrice = getBkMediaShippingEligibleTotal(cart);
  }

  await customElements.whenDefined('progress-bar');
  updateBkMediaFreeShippingProgress(bar);
  updateBkMediaFreeShippingMessage(bar);
}

function syncBkMediaFreeShippingBars(cart) {
  document.querySelectorAll('free-shipping-bar').forEach((bar) => {
    syncBkMediaFreeShippingBar(bar, cart);
  });
}

if (!window.__bkMediaFreeShippingWunschsetBound) {
  window.__bkMediaFreeShippingWunschsetBound = true;

  const rebindFreeShippingBarListener = (bar) => {
    if (!bar || typeof bar._onCartChanged !== 'function') return;

    if (bar._onCartChangedListener) {
      document.removeEventListener('cart:change', bar._onCartChangedListener);
    }

    bar._onCartChangedListener = bar._onCartChanged.bind(bar);
    document.addEventListener('cart:change', bar._onCartChangedListener);
  };

  document.addEventListener('cart:change', (event) => {
    const cart = event.detail?.cart;
    requestAnimationFrame(() => {
      syncBkMediaFreeShippingBars(cart);
      setTimeout(() => syncBkMediaFreeShippingBars(cart), 0);
    });
  });

  document.addEventListener('DOMContentLoaded', () => {
    syncBkMediaFreeShippingBars(null);
  });

  document.addEventListener('shopify:section:load', () => {
    setTimeout(() => {
      document.querySelectorAll('free-shipping-bar').forEach(rebindFreeShippingBarListener);
      syncBkMediaFreeShippingBars(null);
    }, 50);
  });

  const patchFreeShippingBar = () => {
    const FreeShippingBar = customElements.get('free-shipping-bar');
    if (!FreeShippingBar || FreeShippingBar.prototype.__bkMediaWunschsetPatched) return;

    const originalOnCartChanged = FreeShippingBar.prototype._onCartChanged;
    const originalUpdateMessage = FreeShippingBar.prototype._updateMessage;
    const originalAttributeChanged = FreeShippingBar.prototype.attributeChangedCallback;
    const originalConnectedCallback = FreeShippingBar.prototype.connectedCallback;

    FreeShippingBar.prototype._onCartChanged = function patchedOnCartChanged(event) {
      const cart = event?.detail?.cart;
      if (cart) {
        syncBkMediaFreeShippingBar(this, cart);
        return;
      }
      if (typeof originalOnCartChanged === 'function') {
        originalOnCartChanged.call(this, event);
      }
    };

    FreeShippingBar.prototype._updateMessage = function patchedUpdateMessage() {
      updateBkMediaFreeShippingMessage(this);
      if (!this.querySelector('[data-free-shipping-message]') && typeof originalUpdateMessage === 'function') {
        originalUpdateMessage.call(this);
      }
    };

    FreeShippingBar.prototype.attributeChangedCallback = async function patchedAttributeChanged(attribute, oldValue, newValue) {
      if (typeof originalAttributeChanged === 'function') {
        await originalAttributeChanged.call(this, attribute, oldValue, newValue);
      }
      updateBkMediaFreeShippingProgress(this);
      updateBkMediaFreeShippingMessage(this);
    };

    FreeShippingBar.prototype.connectedCallback = async function patchedConnectedCallback() {
      if (typeof originalConnectedCallback === 'function') {
        await originalConnectedCallback.call(this);
      }
      rebindFreeShippingBarListener(this);
      updateBkMediaFreeShippingProgress(this);
      updateBkMediaFreeShippingMessage(this);
    };

    FreeShippingBar.prototype.__bkMediaWunschsetPatched = true;

    document.querySelectorAll('free-shipping-bar').forEach(rebindFreeShippingBarListener);
  };

  if (customElements.get('free-shipping-bar')) {
    patchFreeShippingBar();
  } else {
    customElements.whenDefined('free-shipping-bar').then(patchFreeShippingBar);
  }
}

/* bk-media-free-shipping-wunschset end */

/* bk-media-cart-count start */

function getBkMediaVisibleCartItemCount(cart) {
  if (!cart?.items?.length) return Number(cart?.item_count) || 0;

  return cart.items.reduce((count, item) => {
    if (item?.parent_relationship) return count;

    const props = getBkMediaCartItemProperties(item);
    const bundleRole = props['_Bundle role'] || props['Bundle role'] || '';
    const isBundleChild = bundleRole === 'child'
      || props._BundleIsChild === 'true'
      || (!!props._BundleParentVariantId && bundleRole !== 'parent' && props._BundleIsParent !== 'true' && !props._BundleComponents);

    if (isBundleChild) return count;
    return count + 1;
  }, 0);
}

function getBkMediaCartDrawerSectionId(drawer = document.getElementById('cart-drawer')) {
  if (!drawer) return null;
  return drawer.getAttribute('data-section-id')
    || drawer.closest('.shopify-section')?.id?.replace('shopify-section-', '')
    || null;
}

function bkMediaCartSectionsUrl() {
  const root = window.Shopify?.routes?.root || '/';
  const search = window.location.search || '';
  if (!search || root.includes('?')) return root;
  return `${root}${search}`;
}

function bkMediaCartSectionRequestUrl(sectionId) {
  const url = new URL(bkMediaCartSectionsUrl(), window.location.origin);
  if (sectionId) url.searchParams.set('section_id', sectionId);
  return `${url.pathname}${url.search}`;
}

function bkMediaCartSectionLooksValid(html, itemCount) {
  const valid = typeof html === 'string'
    && html.length > 0
    && (html.includes('id="cart-drawer"') || html.includes("id='cart-drawer'") || html.includes('<cart-drawer'));

  if (!valid) return false;

  if (Number(itemCount) > 0 && html.includes('empty-state') && !html.includes('bk-media-cart-drawer__footer')) {
    return false;
  }

  const drawer = document.getElementById('cart-drawer');
  if (drawer?.getAttribute('data-show-savings-rows') !== 'true') return true;
  if (!html.includes('bk-media-cart-drawer__footer')) return true;

  return html.includes('data-cart-drawer-extras');
}

async function bkMediaEnsureCartSections(cart, sectionIds = []) {
  if (!cart) return cart;
  if (!cart.sections) cart.sections = {};

  for (const sectionId of sectionIds) {
    if (!sectionId || bkMediaCartSectionLooksValid(cart.sections[sectionId], cart.item_count)) continue;

    try {
      const response = await fetch(bkMediaCartSectionRequestUrl(sectionId));
      if (!response.ok) continue;
      const html = await response.text();
      if (!cart.sections[sectionId] || bkMediaCartSectionLooksValid(html, cart.item_count)) {
        cart.sections[sectionId] = html;
      }
    } catch (error) {
      // ignore section fetch errors
    }
  }

  return cart;
}

async function bkMediaNormalizeCart(cart, { ensureSections = true } = {}) {
  let nextCart = cart;

  if (!nextCart || !Number.isFinite(Number(nextCart.item_count))) {
    nextCart = await (await fetch(`${window.Shopify.routes.root}cart.js`)).json();
    if (cart?.sections) {
      nextCart.sections = Object.assign({}, nextCart.sections || {}, cart.sections);
    }
  }

  if (ensureSections) {
    const sectionId = getBkMediaCartDrawerSectionId();
    if (sectionId && !bkMediaCartSectionLooksValid(nextCart.sections?.[sectionId], nextCart.item_count)) {
      await bkMediaEnsureCartSections(nextCart, [sectionId]);
    }
  }

  return nextCart;
}

async function bkMediaDispatchCartChange(cart, baseEvent = 'cart:change') {
  const sectionId = getBkMediaCartDrawerSectionId();
  const hasValidSection = sectionId
    ? bkMediaCartSectionLooksValid(cart?.sections?.[sectionId], cart?.item_count)
    : true;
  const nextCart = hasValidSection && Number.isFinite(Number(cart?.item_count))
    ? cart
    : await bkMediaNormalizeCart(cart, { ensureSections: true });

  document.documentElement.dispatchEvent(new CustomEvent('cart:change', {
    bubbles: true,
    detail: {
      baseEvent,
      cart: nextCart
    }
  }));

  return nextCart;
}

window.bkMediaDispatchCartChange = bkMediaDispatchCartChange;

function syncBkMediaCartCountVisibility(element, count) {
  if (!element) return;

  const next = Number(count) || 0;
  element.classList.toggle('opacity-0', next <= 0);
  element.style.opacity = next <= 0 ? '0' : '1';
  element.setAttribute('aria-hidden', next <= 0 ? 'true' : 'false');
}

function syncBkMediaCartCountElements(itemCount) {
  const count = Number(itemCount);
  if (!Number.isFinite(count)) return;

  document.querySelectorAll('cart-count').forEach((element) => {
    syncBkMediaCartCountVisibility(element, count);

    try {
      element.itemCount = count;
    } catch (error) {
      element.textContent = String(count);
    }

    syncBkMediaCartCountVisibility(element, count);
  });
}

function syncBkMediaCartDrawerTabBadge(cart) {
  const badge = document.querySelector('#cart-drawer.cart-drawer--hansegruen [data-cart-drawer-tab="cart"] .bk-media-cart-drawer__tab-badge');
  if (!badge || !cart) return;
  badge.textContent = String(getBkMediaVisibleCartItemCount(cart));
}

function patchBkMediaCartCount() {
  const CartCount = customElements.get('cart-count');
  if (!CartCount || CartCount.prototype.__bkMediaCartCountPatched) return;

  const descriptor = Object.getOwnPropertyDescriptor(CartCount.prototype, 'itemCount');
  if (!descriptor?.get || !descriptor?.set) return;

  Object.defineProperty(CartCount.prototype, 'itemCount', {
    configurable: true,
    get() {
      return Number.parseInt(this.textContent, 10) || 0;
    },
    set(count) {
      const next = Number(count);
      if (!Number.isFinite(next)) return;

      const previous = Number.parseInt(this.textContent, 10) || 0;
      syncBkMediaCartCountVisibility(this, next);

      if (previous === next) return;

      descriptor.set.call(this, next);
      syncBkMediaCartCountVisibility(this, next);
    }
  });

  CartCount.prototype.__bkMediaCartCountPatched = true;
}

function ensureBkMediaCartDrawerSectionId(drawer) {
  if (!drawer) return null;

  const existing = drawer.getAttribute('data-section-id');
  if (existing) return existing;

  const sectionId = drawer.closest('.shopify-section')?.id?.replace('shopify-section-', '');
  if (sectionId) {
    drawer.setAttribute('data-section-id', sectionId);
    return sectionId;
  }

  return null;
}

async function getBkMediaCartDrawerSectionHtml(drawer, cart) {
  const sectionId = ensureBkMediaCartDrawerSectionId(drawer) || getBkMediaCartDrawerSectionId(drawer);
  const candidates = [];

  if (sectionId && typeof cart?.sections?.[sectionId] === 'string') {
    candidates.push(cart.sections[sectionId]);
  }

  if (cart?.sections) {
    for (const html of Object.values(cart.sections)) {
      if (typeof html === 'string' && !candidates.includes(html)) candidates.push(html);
    }
  }

  const itemCount = Number(cart?.item_count);
  const valid = candidates.find((html) => bkMediaCartSectionLooksValid(html, itemCount));
  if (valid) return valid;

  if (!sectionId) return candidates[0] || null;

  try {
    const response = await fetch(bkMediaCartSectionRequestUrl(sectionId));
    if (!response.ok) return candidates[0] || null;
    const html = await response.text();
    if (cart) {
      if (!cart.sections) cart.sections = {};
      if (!cart.sections[sectionId] || bkMediaCartSectionLooksValid(html, itemCount)) {
        cart.sections[sectionId] = html;
      }
    }
    if (bkMediaCartSectionLooksValid(html, itemCount)) return html;
    return candidates[0] || html;
  } catch (error) {
    return candidates[0] || null;
  }
}

function bkMediaClearCartDrawerUpdateTimer(drawer) {
  if (!drawer?.__bkMediaDrawerUpdateTimer) return;
  clearTimeout(drawer.__bkMediaDrawerUpdateTimer);
  drawer.__bkMediaDrawerUpdateTimer = null;
}

function bkMediaUnlockPageScrollIfSafe(exceptDrawer = null) {
  document.documentElement.classList.remove('bk-media-cartbot-decline-open');

  const openDialog = Array.from(document.querySelectorAll('cart-drawer[open], [role="dialog"][open]'))
    .find((el) => el !== exceptDrawer && el.hasAttribute('open'));

  if (!openDialog) {
    document.documentElement.classList.remove('lock');
  }
}

function bkMediaReleaseCartDrawerFocusTrap(drawer) {
  // Use _focusTrap so we don't lazily create a trap via the getter.
  const trap = drawer?._focusTrap;
  if (!trap) return;
  try {
    trap.deactivate({ onDeactivate: false, returnFocus: false });
  } catch (e) {}
}

function bkMediaReleaseCartDrawerUi(drawer = null) {
  bkMediaClearCartDrawerUpdateTimer(drawer);
  bkMediaReleaseCartDrawerFocusTrap(drawer);
  bkMediaUnlockPageScrollIfSafe(drawer);
}

function bkMediaSwapCartDrawerInnerHtml(drawer, currentInner, nextInnerHtml) {
  // Trap targets the drawer host/shadowRoot — do not deactivate/reactivate around
  // innerHTML swaps (reactivate can win a race after close and block the cart icon).
  currentInner.innerHTML = nextInnerHtml;

  if (typeof initBkMediaCartDrawerHansegruen === 'function') {
    initBkMediaCartDrawerHansegruen();
  }

  if (drawer.hasAttribute('open')) {
    const active = document.activeElement;
    if (!active || (active !== drawer && !drawer.contains(active))) {
      try {
        drawer.focus({ preventScroll: true });
      } catch (e) {}
    }
  }
}

function applyBkMediaCartDrawerHtml(drawer, sectionHtml, cart, baseEvent = '') {
  if (!drawer || !sectionHtml) return false;

  const doc = new DOMParser().parseFromString(sectionHtml, 'text/html');
  const updatedDrawer = doc.querySelector('#cart-drawer') || doc.querySelector('cart-drawer');
  if (!updatedDrawer) return false;

  const itemCount = Number(cart?.item_count) || 0;
  const isImmediateUpdate = baseEvent === 'variant:add'
    || baseEvent === 'discount:apply'
    || baseEvent === 'discount:remove'
    || baseEvent === 'bk-media-goodie:sync'
    || baseEvent === 'line-item:change';

  if (baseEvent === 'variant:add' || drawer.dataset.activeCartTab === 'recommendations') {
    drawer.dataset.activeCartTab = 'cart';
  }

  const finish = () => {
    if (typeof initBkMediaCartDrawerHansegruen === 'function') {
      initBkMediaCartDrawerHansegruen();
    }

    drawer.querySelectorAll('cart-discount-component').forEach((component) => {
      if (typeof component.syncBadgesFromCart === 'function') {
        component.syncBadgesFromCart(cart);
      }
    });

    syncBkMediaLineItemDiscountBadges(drawer, cart);
  };

  if (itemCount > 0) {
    const currentInner = drawer.querySelector('.cart-drawer__inner');
    const updatedInner = updatedDrawer.querySelector('.cart-drawer__inner');
    const currentFooter = drawer.querySelector('[slot="footer"], [data-cart-drawer-footer]');
    const updatedFooter = updatedDrawer.querySelector('[slot="footer"], [data-cart-drawer-footer]');

    if (!currentInner || !updatedInner) {
      bkMediaClearCartDrawerUpdateTimer(drawer);
      drawer.replaceChildren(
        ...Array.from(updatedDrawer.childNodes).map((node) => document.importNode(node, true))
      );
      finish();
      return true;
    }

    const updateInner = () => {
      drawer.__bkMediaDrawerUpdateTimer = null;
      if (!drawer.isConnected || !currentInner.isConnected) return;
      bkMediaSwapCartDrawerInnerHtml(drawer, currentInner, updatedInner.innerHTML);
      drawer.querySelectorAll('cart-discount-component').forEach((component) => {
        if (typeof component.syncBadgesFromCart === 'function') {
          component.syncBadgesFromCart(cart);
        }
      });
      syncBkMediaLineItemDiscountBadges(drawer, cart);
    };

    bkMediaClearCartDrawerUpdateTimer(drawer);

    if (isImmediateUpdate) {
      updateInner();
    } else {
      drawer.__bkMediaDrawerUpdateTimer = setTimeout(updateInner, 400);
    }

    if (currentFooter && updatedFooter) {
      currentFooter.replaceWith(document.importNode(updatedFooter, true));
    } else if (updatedFooter && !currentFooter) {
      drawer.appendChild(document.importNode(updatedFooter, true));
    }

    if (typeof setBkMediaCartDrawerTab === 'function') {
      setBkMediaCartDrawerTab(drawer, drawer.dataset.activeCartTab || 'cart');
    }

    if (!isImmediateUpdate) {
      finish();
    }

    return true;
  }

  bkMediaClearCartDrawerUpdateTimer(drawer);
  drawer.replaceChildren(
    ...Array.from(updatedDrawer.childNodes).map((node) => document.importNode(node, true))
  );
  finish();
  return true;
}

function patchBkMediaCartDrawerSectionSafety() {
  const CartDrawer = customElements.get('cart-drawer');
  if (!CartDrawer || CartDrawer.prototype.__bkMediaCartDrawerSectionPatched) return;

  const originalConnectedCallback = CartDrawer.prototype.connectedCallback;
  const originalShow = CartDrawer.prototype.show;
  const originalHide = CartDrawer.prototype.hide;

  Object.defineProperty(CartDrawer.prototype, 'shouldAppendToBody', {
    configurable: true,
    get() {
      return false;
    }
  });

  // Avoid theme lockLayerCount getting stuck after innerHTML refreshes / focus-trap races
  Object.defineProperty(CartDrawer.prototype, 'shouldLock', {
    configurable: true,
    get() {
      return false;
    }
  });

  CartDrawer.prototype.connectedCallback = function patchedCartDrawerConnectedCallback() {
    ensureBkMediaCartDrawerSectionId(this);
    if (typeof originalConnectedCallback === 'function') {
      return originalConnectedCallback.call(this);
    }
  };

  CartDrawer.prototype.show = function patchedCartDrawerShow(...args) {
    const result = typeof originalShow === 'function' ? originalShow.apply(this, args) : undefined;
    document.documentElement.classList.add('lock');
    return result;
  };

  CartDrawer.prototype.hide = function patchedCartDrawerHide(...args) {
    bkMediaClearCartDrawerUpdateTimer(this);
    const result = typeof originalHide === 'function' ? originalHide.apply(this, args) : undefined;
    const release = () => bkMediaReleaseCartDrawerUi(this);
    // Release immediately so cart icon clicks aren't swallowed by a lingering trap,
    // then again after the hide transition settles.
    release();
    if (result?.then) result.then(release).catch(release);
    else Promise.resolve().then(release);
    return result;
  };

  CartDrawer.prototype._onPrepareBundledSections = function patchedPrepareBundledSections(event) {
    const sectionId = ensureBkMediaCartDrawerSectionId(this) || getBkMediaCartDrawerSectionId(this);
    if (sectionId && Array.isArray(event?.detail?.sections) && !event.detail.sections.includes(sectionId)) {
      event.detail.sections.push(sectionId);
    }
  };

  CartDrawer.prototype._onCartRefresh = async function patchedCartDrawerOnCartRefresh() {
    const html = await getBkMediaCartDrawerSectionHtml(this, null);
    if (!html) return;

    const doc = new DOMParser().parseFromString(html, 'text/html');
    const nextDrawer = doc.querySelector('#cart-drawer') || doc.querySelector('cart-drawer');
    if (!nextDrawer) return;

    const currentInner = this.querySelector('.cart-drawer__inner');
    const updatedInner = nextDrawer.querySelector('.cart-drawer__inner');

    const currentFooter = this.querySelector('[slot="footer"], [data-cart-drawer-footer]');
    const updatedFooter = nextDrawer.querySelector('[slot="footer"], [data-cart-drawer-footer]');

    if (currentInner && updatedInner) {
      bkMediaSwapCartDrawerInnerHtml(this, currentInner, updatedInner.innerHTML);

      if (currentFooter && updatedFooter) {
        currentFooter.replaceWith(document.importNode(updatedFooter, true));
      } else if (updatedFooter && !currentFooter) {
        this.appendChild(document.importNode(updatedFooter, true));
      }

      if (typeof setBkMediaCartDrawerTab === 'function') {
        setBkMediaCartDrawerTab(this, this.dataset.activeCartTab || 'cart');
      }
      return;
    }

    this.replaceChildren(
      ...Array.from(nextDrawer.childNodes).map((node) => document.importNode(node, true))
    );

    if (typeof initBkMediaCartDrawerHansegruen === 'function') {
      initBkMediaCartDrawerHansegruen();
    }
  };

  CartDrawer.prototype._onCartChanged = async function patchedCartDrawerOnCartChanged(event) {
    const cart = event?.detail?.cart;
    if (!cart) return;

    try {
      ensureBkMediaCartDrawerSectionId(this);
      const sectionHtml = await getBkMediaCartDrawerSectionHtml(this, cart);
      const applied = applyBkMediaCartDrawerHtml(this, sectionHtml, cart, event.detail?.baseEvent || '');

      if (!applied && typeof this._onCartRefresh === 'function') {
        await this._onCartRefresh();
      }
    } catch (error) {
      console.error('Cart drawer update failed, refreshing section', error);
      try {
        await this._onCartRefresh();
      } catch (refreshError) {
        console.error('Cart drawer refresh failed', refreshError);
      }
    }
  };

  CartDrawer.prototype.__bkMediaCartDrawerSectionPatched = true;

  document.querySelectorAll('cart-drawer').forEach((drawer) => {
    ensureBkMediaCartDrawerSectionId(drawer);
    rebindBkMediaCartDrawerInstance(drawer);
  });
}

function rebindBkMediaCartDrawerInstance(drawer) {
  if (!drawer) return;

  [
    ['_onPrepareBundledSectionsListener', '_onPrepareBundledSections', 'cart:prepare-bundled-sections'],
    ['_onCartChangedListener', '_onCartChanged', 'cart:change'],
    ['_onCartRefreshListener', '_onCartRefresh', 'cart:refresh']
  ].forEach(([listenerKey, methodName, eventName]) => {
    if (typeof drawer[methodName] !== 'function') return;

    if (drawer[listenerKey]) {
      document.removeEventListener(eventName, drawer[listenerKey]);
    }

    drawer[listenerKey] = drawer[methodName].bind(drawer);
    document.addEventListener(eventName, drawer[listenerKey]);
  });
}

async function syncBkMediaCartCountsFromCart(cart) {
  const nextCart = await bkMediaNormalizeCart(cart, { ensureSections: false });
  if (!nextCart) return;

  syncBkMediaCartCountElements(nextCart.item_count);
  syncBkMediaCartDrawerTabBadge(nextCart);
}

if (!window.__bkMediaCartCountBound) {
  window.__bkMediaCartCountBound = true;

  document.addEventListener('dialog:after-hide', (event) => {
    if (event.target?.id !== 'cart-drawer') return;
    bkMediaReleaseCartDrawerUi(event.target);
  });

  const bindCartCountPatches = () => {
    patchBkMediaCartCount();
    patchBkMediaCartDrawerSectionSafety();
    document.querySelectorAll('cart-count').forEach((element) => {
      const count = Number.parseInt(element.textContent, 10) || 0;
      syncBkMediaCartCountVisibility(element, count);
    });
  };

  if (customElements.get('cart-count')) {
    bindCartCountPatches();
  } else {
    customElements.whenDefined('cart-count').then(bindCartCountPatches);
  }

  if (customElements.get('cart-drawer')) {
    patchBkMediaCartDrawerSectionSafety();
  } else {
    customElements.whenDefined('cart-drawer').then(patchBkMediaCartDrawerSectionSafety);
  }

  document.addEventListener('cart:change', (event) => {
    syncBkMediaCartCountsFromCart(event?.detail?.cart);
  });

  document.addEventListener('cart:refresh', () => {
    syncBkMediaCartCountsFromCart(null);
  });

  window.addEventListener('pageshow', (event) => {
    if (event.persisted) {
      syncBkMediaCartCountsFromCart(null);
    }
  });

  document.addEventListener('DOMContentLoaded', bindCartCountPatches);
  document.addEventListener('shopify:section:load', () => {
    setTimeout(bindCartCountPatches, 50);
  });
}

/* bk-media-cart-count end */

/* bk-media-cart-drawer-hansegruen start */

function resolveBkMediaCartDrawerTab(drawer, preferred) {
  if (!drawer) return 'cart';

  const requested = preferred || drawer.dataset.activeCartTab || 'cart';
  if (requested === 'cart') return 'cart';

  const hasTab = drawer.querySelector(`[data-cart-drawer-tab="${requested}"]`);
  const hasPanel = drawer.querySelector(`[data-cart-drawer-panel="${requested}"]`);
  if (!hasTab || !hasPanel) return 'cart';

  return requested;
}

function setBkMediaCartDrawerTab(drawer, target) {
  if (!drawer) return;

  const next = resolveBkMediaCartDrawerTab(drawer, target);
  drawer.dataset.activeCartTab = next;

  drawer.querySelectorAll('[data-cart-drawer-tab]').forEach((button) => {
    const isActive = button.dataset.cartDrawerTab === next;
    button.classList.toggle('is-active', isActive);
    button.setAttribute('aria-selected', isActive ? 'true' : 'false');
  });

  drawer.querySelectorAll('[data-cart-drawer-panel]').forEach((panel) => {
    const isActive = panel.dataset.cartDrawerPanel === next;
    panel.classList.toggle('is-active', isActive);
    panel.hidden = !isActive;
  });

  const footer = drawer.querySelector('[data-cart-drawer-footer], [slot="footer"]');
  if (footer) {
    footer.hidden = next === 'recommendations';
  }
}

function getBkMediaCartDrawerHansegruen() {
  const drawer = document.getElementById('cart-drawer');
  if (!drawer?.classList.contains('cart-drawer--hansegruen')) return null;
  return drawer;
}

function getBkMediaCartDrawerSectionsToBundle(drawer) {
  const sectionsToBundle = [];
  document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections', {
    bubbles: true,
    detail: { sections: sectionsToBundle }
  }));

  const sectionId = drawer?.getAttribute('data-section-id')
    || getBkMediaCartDrawerSectionId(drawer)
    || 'cart-drawer';
  if (!sectionsToBundle.includes(sectionId)) {
    sectionsToBundle.push(sectionId);
  }

  return sectionsToBundle;
}

function getBkMediaCartRequestSectionPayload(drawer = document.getElementById('cart-drawer')) {
  return {
    sections: getBkMediaCartDrawerSectionsToBundle(drawer),
    sections_url: bkMediaCartSectionsUrl()
  };
}

function patchBkMediaNativeLineItemQuantity() {
  const LineItemQuantity = customElements.get('line-item-quantity');
  if (!LineItemQuantity || LineItemQuantity.prototype.__bkMediaSectionsUrlPatched) return Boolean(LineItemQuantity);

  const originalChange = LineItemQuantity.prototype._changeLineItemQuantity;

  LineItemQuantity.prototype._changeLineItemQuantity = async function patchedChangeLineItemQuantity(lineKey, targetQuantity) {
    const isGift = this.closest('[data-cartbot-gift="true"]');
    if (isGift && targetQuantity > 1) targetQuantity = 1;

    if (window.themeVariables.settings.pageType === 'cart') {
      return originalChange.call(this, lineKey, targetQuantity);
    }

    const lineItem = this.closest('line-item');
    lineItem?.dispatchEvent(new CustomEvent('line-item:will-change', {
      bubbles: true,
      detail: { targetQuantity }
    }));

    const sectionPayload = getBkMediaCartRequestSectionPayload();
    const cartContent = await (await fetch(`${window.Shopify.routes.root}cart/change.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        id: lineKey,
        quantity: targetQuantity,
        sections: sectionPayload.sections,
        sections_url: sectionPayload.sections_url
      })
    })).json();

    if (!bkMediaCartSectionLooksValid(cartContent.sections?.[sectionPayload.sections[0]])) {
      await bkMediaEnsureCartSections(cartContent, sectionPayload.sections);
    }

    const lineItemAfterChange = (cartContent.items || []).filter((item) => item.key === lineKey);
    lineItem?.dispatchEvent(new CustomEvent('line-item:change', {
      bubbles: true,
      detail: {
        quantity: lineItemAfterChange.length === 0 ? 0 : lineItemAfterChange[0].quantity,
        cart: cartContent
      }
    }));

    document.documentElement.dispatchEvent(new CustomEvent('cart:change', {
      bubbles: true,
      detail: {
        baseEvent: 'line-item:change',
        cart: cartContent
      }
    }));
  };

  LineItemQuantity.prototype.__bkMediaSectionsUrlPatched = true;
  return true;
}

function initBkMediaNativeLineItemQuantityPatch() {
  if (!patchBkMediaNativeLineItemQuantity()) {
    let attempts = 0;
    const timer = setInterval(() => {
      attempts += 1;
      if (patchBkMediaNativeLineItemQuantity() || attempts > 40) clearInterval(timer);
    }, 50);
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initBkMediaNativeLineItemQuantityPatch, { once: true });
} else {
  initBkMediaNativeLineItemQuantityPatch();
}

/* bk-media-gratis-goodie start */
const BK_MEDIA_GOODIES = [
  {
    id: 'shotglas',
    handle: 'gratisshotglas',
    variantId: 54455505027340,
    productId: 11665197007116,
    declinedKey: 'bk_media_goodie_declined',
    autoEnsure: false,
    defaultText: 'Möchtest du das gratis Shotglas wirklich entfernen?'
  },
  {
    id: 'shotflesje',
    handle: 'gratis-shotflesje',
    variantId: 66043974385932,
    productId: 16590053048588,
    declinedKey: 'bk_media_shotflesje_declined',
    autoEnsure: false,
    defaultText: 'Wil je het gratis shotflesje echt verwijderen?'
  },
  {
    id: 'dosierdeckel',
    handle: 'gratis-dosierdeckel',
    variantId: 62032110616844,
    productId: 16101350539532,
    declinedKey: 'bk_media_dosierdeckel_declined',
    autoEnsure: false,
    defaultText: 'Möchtest du den GRATIS Dosierdeckel wirklich entfernen?'
  }
];
const BK_MEDIA_GOODIE_VARIANT_IDS = new Set(BK_MEDIA_GOODIES.map((goodie) => goodie.variantId));
const bkMediaNativeFetch = window.fetch.bind(window);
let bkMediaKnownGoodieLineKeys = null;
let bkMediaLastKnownCart = null;
let bkMediaGoodieEnsureTimer = null;
let bkMediaGoodieEnsureInFlight = false;
let bkMediaGoodieCapTimer = null;

function getBkMediaGoodieSettings() {
  const defaults = {
    title: 'Gratis-Produkt entfernen?',
    text: 'Möchtest du das gratis Shotglas wirklich entfernen?',
    keepLabel: 'Behalten',
    removeLabel: 'Entfernen',
    byHandle: {},
    products: {},
    showOfferRow: false
  };

  const script = document.getElementById('bk-media-goodie-settings');
  if (!script?.textContent) return defaults;

  try {
    const parsed = JSON.parse(script.textContent);
    const decline = parsed.decline || parsed;
    return {
      title: decline.title || defaults.title,
      text: decline.text || defaults.text,
      keepLabel: decline.keepLabel || defaults.keepLabel,
      removeLabel: decline.removeLabel || defaults.removeLabel,
      byHandle: parsed.byHandle || defaults.byHandle,
      products: parsed.products || defaults.products,
      showOfferRow: parsed.showOfferRow === true
    };
  } catch (e) {
    return defaults;
  }
}

function getBkMediaGoodieDeclineSettings() {
  return getBkMediaGoodieSettings();
}

function getBkMediaGoodieDeclineCopy(goodie) {
  const settings = getBkMediaGoodieDeclineSettings();
  const handleCopy = goodie ? settings.byHandle?.[goodie.handle] : null;
  return {
    title: handleCopy?.title || settings.title,
    text: handleCopy?.text || goodie?.defaultText || settings.text,
    keepLabel: handleCopy?.keepLabel || settings.keepLabel,
    removeLabel: handleCopy?.removeLabel || settings.removeLabel
  };
}

function getBkMediaGoodieRuntime(goodie) {
  if (!goodie) return null;
  const fromSettings = getBkMediaGoodieSettings().products?.[goodie.id] || {};
  return {
    ...goodie,
    variantId: Number(fromSettings.variantId) || goodie.variantId,
    productId: Number(fromSettings.productId) || goodie.productId,
    title: fromSettings.title || goodie.title || '',
    image: fromSettings.image || '',
    addLabel: fromSettings.addLabel || 'Hinzufügen',
    badge: fromSettings.badge || 'GRATIS'
  };
}

function resolveBkMediaGoodie(hint = {}) {
  const variantId = Number(hint.variantId || hint.variant_id || hint.id);
  const productId = Number(hint.productId || hint.product_id);
  const handle = String(hint.handle || '').toLowerCase();
  return BK_MEDIA_GOODIES.find((goodie) =>
    (variantId && goodie.variantId === variantId)
    || (productId && goodie.productId === productId)
    || (handle && goodie.handle === handle)
  ) || null;
}

function isBkMediaGoodieDeclined(goodie) {
  if (!goodie) return false;
  try {
    return sessionStorage.getItem(goodie.declinedKey) === '1';
  } catch (e) {
    return false;
  }
}

function hasBkMediaDeclinedGoodie() {
  return BK_MEDIA_GOODIES.some((goodie) => isBkMediaGoodieDeclined(goodie));
}

function markBkMediaGoodieDeclined(goodie) {
  if (!goodie) return;
  try {
    sessionStorage.setItem(goodie.declinedKey, '1');
  } catch (e) {}
}

function clearBkMediaGoodieDeclined(goodie) {
  const list = goodie ? [goodie] : BK_MEDIA_GOODIES;
  list.forEach((item) => {
    try {
      sessionStorage.removeItem(item.declinedKey);
    } catch (e) {}
  });
}

function isBkMediaKnownGoodieItem(item) {
  if (!item) return false;
  return Boolean(resolveBkMediaGoodie({
    variantId: item.variant_id || item.id,
    productId: item.product_id,
    handle: item.handle
  }));
}

function isBkMediaCartbotGiftItem(item) {
  if (!item) return false;
  if (isBkMediaKnownGoodieItem(item)) return true;
  const props = getBkMediaCartItemProperties(item);
  return Boolean(props._bk_media_goodie) || Boolean(props._added_by_cartbot);
}

function getBkMediaPaidItemCount(cart) {
  return (cart?.items || []).reduce((sum, item) => {
    if (isBkMediaCartbotGiftItem(item)) return sum;
    return sum + (Number(item.quantity) || 0);
  }, 0);
}

function findBkMediaGoodieLines(cart) {
  return (cart?.items || []).filter((item) => isBkMediaCartbotGiftItem(item));
}

function findBkMediaDeclinedGoodieLines(cart) {
  return (cart?.items || []).filter((item) => {
    const goodie = resolveBkMediaGoodie({
      variantId: item.variant_id || item.id,
      productId: item.product_id,
      handle: item.handle
    });
    return goodie && isBkMediaGoodieDeclined(goodie);
  });
}

function findBkMediaGoodieLine(cart) {
  return findBkMediaGoodieLines(cart)[0] || null;
}

function snapshotBkMediaGoodieLineKeys(cart) {
  if (cart?.items) bkMediaLastKnownCart = cart;
  bkMediaKnownGoodieLineKeys = new Set(
    findBkMediaGoodieLines(cart).map((item) => item.key).filter(Boolean)
  );
}

function cartHasBkMediaGoodie(cart, goodie) {
  if (!goodie) return false;
  return (cart?.items || []).some((item) => {
    const resolved = resolveBkMediaGoodie({
      variantId: item.variant_id || item.id,
      productId: item.product_id,
      handle: item.handle
    });
    return resolved && resolved.id === goodie.id;
  });
}

function findBkMediaNewlyAddedDeclinedGoodieLines(cart) {
  const lines = findBkMediaDeclinedGoodieLines(cart);
  if (bkMediaKnownGoodieLineKeys === null) {
    snapshotBkMediaGoodieLineKeys(cart);
    return [];
  }

  return lines.filter((item) => item?.key && !bkMediaKnownGoodieLineKeys.has(item.key));
}

const BK_MEDIA_GOODIE_REMOVED_ATTR = 'goodie_removed';

function getBkMediaDeliberatelyRemovedGoodieIds(cart) {
  if ((Number(cart?.item_count) || 0) === 0) return [];

  return BK_MEDIA_GOODIES.filter((goodie) => {
    return isBkMediaGoodieDeclined(goodie) && !cartHasBkMediaGoodie(cart, goodie);
  }).map((goodie) => goodie.id);
}

function bkMediaCopyCartAttributes(cart) {
  const attributes = {};
  Object.entries(cart?.attributes || {}).forEach(([key, value]) => {
    if (value != null && String(value).trim() !== '') {
      attributes[key] = String(value);
    }
  });
  return attributes;
}

function bkMediaWriteGoodieRemovedFormFields(value) {
  document.querySelectorAll('form').forEach((form) => {
    if (!form.querySelector('[name="checkout"]')) return;

    let input = form.querySelector(`[name="attributes[${BK_MEDIA_GOODIE_REMOVED_ATTR}]"]`);
    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = `attributes[${BK_MEDIA_GOODIE_REMOVED_ATTR}]`;
      input.setAttribute('data-goodie-removed-attr', 'true');
      form.prepend(input);
    }
    input.value = value;
  });
}

async function bkMediaSyncGoodieRemovedAttribute(cartHint = null) {
  if (window.__bkMediaGoodieAttrSyncing) return cartHint;

  try {
    const cart = cartHint?.items
      ? cartHint
      : await (await bkMediaGoodieFetch(`${window.Shopify.routes.root}cart.js`)).json();
    const removedIds = getBkMediaDeliberatelyRemovedGoodieIds(cart);
    const nextValue = removedIds.join(',');
    const currentValue = String(cart.attributes?.[BK_MEDIA_GOODIE_REMOVED_ATTR] || '').trim();

    bkMediaWriteGoodieRemovedFormFields(nextValue);

    if (currentValue === nextValue) return cart;

    const attributes = bkMediaCopyCartAttributes(cart);
    if (nextValue) attributes[BK_MEDIA_GOODIE_REMOVED_ATTR] = nextValue;
    else delete attributes[BK_MEDIA_GOODIE_REMOVED_ATTR];

    window.__bkMediaGoodieAttrSyncing = true;
    const response = await bkMediaGoodieFetch(`${window.Shopify.routes.root}cart/update.js?bk-media-goodie=1`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes })
    });
    if (!response.ok) return cart;

    const nextCart = await response.json();
    if (cart.sections) nextCart.sections = cart.sections;
    snapshotBkMediaGoodieLineKeys(nextCart);
    return nextCart;
  } catch (e) {
    console.error('Failed to sync goodie-removed cart attribute:', e);
    return cartHint;
  } finally {
    window.__bkMediaGoodieAttrSyncing = false;
  }
}

function bkMediaEventAddsPaidProduct(event) {
  const items = event.detail?.items;
  if (Array.isArray(items) && items.length) {
    return items.some((item) => !isBkMediaCartbotGiftItem(item) && !isBkMediaKnownGoodieItem(item));
  }
  const variant = event.detail?.variant;
  if (variant) return !isBkMediaKnownGoodieItem(variant);
  return false;
}

function bkMediaFetchBodyAddsPaidProduct(body) {
  return bkMediaCollectVariantIdsFromBody(body).some((id) => id && !BK_MEDIA_GOODIE_VARIANT_IDS.has(id));
}

function bkMediaClearDeclinedAfterPaidAdd(cart) {
  if (!bkMediaLastKnownCart?.items) return;
  if (getBkMediaPaidItemCount(cart) <= getBkMediaPaidItemCount(bkMediaLastKnownCart)) return;
  clearBkMediaGoodieDeclined();
}

async function bkMediaGoodieFetch(url, options = {}) {
  return bkMediaNativeFetch(url, {
    credentials: 'same-origin',
    cache: 'no-store',
    ...options
  });
}

function parseBkMediaFetchBody(body) {
  if (!body) return null;
  if (typeof body === 'string') {
    try {
      return JSON.parse(body);
    } catch (e) {
      try {
        return Object.fromEntries(new URLSearchParams(body).entries());
      } catch (err) {
        return null;
      }
    }
  }
  if (body instanceof FormData) {
    return Object.fromEntries(body.entries());
  }
  if (typeof body === 'object') return body;
  return null;
}

function bkMediaCollectVariantIdsFromBody(body) {
  const data = parseBkMediaFetchBody(body);
  if (!data) return [];
  const ids = [];
  if (data.id) ids.push(Number(data.id));
  if (Array.isArray(data.items)) {
    data.items.forEach((item) => {
      if (item?.id) ids.push(Number(item.id));
    });
  }
  Object.keys(data).forEach((key) => {
    if (key === 'id' || /items\[\d+\]\[id\]/.test(key)) ids.push(Number(data[key]));
  });
  return ids.filter((id) => Number.isFinite(id) && id > 0);
}

function bkMediaShouldDropGoodieAdd(id) {
  const goodie = resolveBkMediaGoodie({ variantId: id });
  if (!goodie) return false;
  if (isBkMediaGoodieDeclined(goodie)) return true;
  return cartHasBkMediaGoodie(bkMediaLastKnownCart, goodie);
}

function bkMediaRewriteCartAddBody(body) {
  const data = parseBkMediaFetchBody(body);
  if (!data) return { drop: false, body: null };

  if (bkMediaFetchBodyAddsPaidProduct(body)) clearBkMediaGoodieDeclined();

  let changed = false;
  if (Array.isArray(data.items)) {
    const nextItems = [];
    data.items.forEach((item) => {
      const id = Number(item?.id);
      if (BK_MEDIA_GOODIE_VARIANT_IDS.has(id) && bkMediaShouldDropGoodieAdd(id)) {
        changed = true;
        return;
      }
      if (BK_MEDIA_GOODIE_VARIANT_IDS.has(id) && Number(item.quantity) !== 1) {
        nextItems.push({ ...item, quantity: 1 });
        changed = true;
        return;
      }
      nextItems.push(item);
    });
    if (!nextItems.length && data.items.length) return { drop: true, body: null };
    data.items = nextItems;
  } else if (data.id && BK_MEDIA_GOODIE_VARIANT_IDS.has(Number(data.id))) {
    if (bkMediaShouldDropGoodieAdd(Number(data.id))) return { drop: true, body: null };
    if (Number(data.quantity) > 1) {
      data.quantity = 1;
      changed = true;
    }
  }

  if (!changed) return { drop: false, body: null };
  return { drop: false, body: JSON.stringify(data) };
}

function bkMediaIsKnownGoodieCartId(id) {
  if (!id) return false;
  if (BK_MEDIA_GOODIE_VARIANT_IDS.has(Number(id))) return true;
  return (bkMediaLastKnownCart?.items || []).some((item) => item.key === id && isBkMediaCartbotGiftItem(item));
}

function bkMediaClampGoodieChangeBody(body) {
  const data = parseBkMediaFetchBody(body);
  if (!data) return null;

  let changed = false;
  if (data.quantity != null && data.id && bkMediaIsKnownGoodieCartId(data.id) && Number(data.quantity) > 1) {
    data.quantity = 1;
    changed = true;
  }

  if (data.updates && typeof data.updates === 'object') {
    Object.keys(data.updates).forEach((key) => {
      if (Number(data.updates[key]) > 1 && bkMediaIsKnownGoodieCartId(key)) {
        data.updates[key] = 1;
        changed = true;
      }
    });
  }

  if (!changed) return null;
  return JSON.stringify(data);
}

function bkMediaRewriteCartMutationBody(url, body) {
  if (!url || String(url).includes('bk-media-goodie=1')) return { drop: false, body: null };
  if (String(url).includes('/cart/add')) return bkMediaRewriteCartAddBody(body);
  if (String(url).includes('/cart/change') || String(url).includes('/cart/update')) {
    const rewritten = bkMediaClampGoodieChangeBody(body);
    return { drop: false, body: rewritten };
  }
  return { drop: false, body: null };
}

function bkMediaFakeCartAddResponse() {
  return new Response(JSON.stringify({ status: 200, items: [] }), {
    status: 200,
    headers: { 'Content-Type': 'application/json' }
  });
}

function ensureBkMediaGoodieFetchGuard() {
  if (!window.fetch?.__bkMediaGoodieWrapped) {
    const previousFetch = window.fetch.bind(window);
    const wrapped = function bkMediaGoodieAwareFetch(...args) {
      try {
        const request = args[0];
        const url = typeof request === 'string' ? request : request?.url || '';
        const options = args[1] || {};
        const body = options.body !== undefined ? options.body : request?.body;
        const isCartMutation = typeof url === 'string'
          && (url.includes('/cart/add') || url.includes('/cart/change') || url.includes('/cart/update'));
        const rewritten = bkMediaRewriteCartMutationBody(url, body);

        if (rewritten.drop) return Promise.resolve(bkMediaFakeCartAddResponse());

        if (rewritten.body && args[1] && args[1].body !== undefined) {
          args = [args[0], { ...args[1], body: rewritten.body }];
        }

        const result = previousFetch(...args);
        if (isCartMutation && !String(url).includes('bk-media-goodie=1')) {
          return result.then((response) => {
            scheduleBkMediaGoodieReconcile(200);
            return response;
          });
        }
        return result;
      } catch (e) {}

      return previousFetch(...args);
    };

    wrapped.__bkMediaGoodieWrapped = true;
    window.fetch = wrapped;
  }

  if (!XMLHttpRequest.prototype.__bkMediaGoodieWrapped) {
    const originalOpen = XMLHttpRequest.prototype.open;
    const originalSend = XMLHttpRequest.prototype.send;

    XMLHttpRequest.prototype.open = function bkMediaGoodieAwareOpen(method, url) {
      this.__bkMediaGoodieUrl = String(url || '');
      return originalOpen.apply(this, arguments);
    };

    XMLHttpRequest.prototype.send = function bkMediaGoodieAwareSend(body) {
      const url = this.__bkMediaGoodieUrl || '';
      const rewritten = bkMediaRewriteCartMutationBody(url, body);
      if (rewritten.drop) {
        try {
          Object.defineProperty(this, 'status', { configurable: true, value: 200 });
          Object.defineProperty(this, 'responseText', { configurable: true, value: '{"status":200,"items":[]}' });
        } catch (e) {}
        queueMicrotask(() => {
          this.dispatchEvent(new Event('load'));
          this.dispatchEvent(new Event('loadend'));
        });
        return;
      }

      const result = originalSend.call(this, rewritten.body || body);
      if (url.includes('/cart/add') || url.includes('/cart/change') || url.includes('/cart/update')) {
        this.addEventListener('load', () => scheduleBkMediaGoodieReconcile(200), { once: true });
      }
      return result;
    };

    XMLHttpRequest.prototype.__bkMediaGoodieWrapped = true;
  }
}

function ensureBkMediaGoodieDeclineModal() {
  let modal = document.getElementById('bk-media-cartbot-decline-modal');
  if (!modal) {
    modal = document.createElement('div');
    modal.id = 'bk-media-cartbot-decline-modal';
    modal.className = 'bk-media-cartbot-decline-modal';
    modal.hidden = true;
    modal.innerHTML = `
      <div class="bk-media-cartbot-decline-modal__backdrop" data-cartbot-decline-cancel></div>
      <div class="bk-media-cartbot-decline-modal__dialog" role="dialog" aria-modal="true" aria-labelledby="bk-media-cartbot-decline-title">
        <h3 id="bk-media-cartbot-decline-title" class="h5 bk-media-cartbot-decline-modal__title"></h3>
        <p class="text-base bk-media-cartbot-decline-modal__text"></p>
        <div class="bk-media-cartbot-decline-modal__actions">
          <button type="button" class="button button--secondary" data-cartbot-decline-cancel></button>
          <button type="button" class="button" data-cartbot-decline-confirm></button>
        </div>
      </div>
    `;
    document.body.appendChild(modal);
  }

  return modal;
}

function showBkMediaGoodieDeclineModal(goodie) {
  const modal = ensureBkMediaGoodieDeclineModal();
  const copy = getBkMediaGoodieDeclineCopy(goodie);
  const titleEl = modal.querySelector('#bk-media-cartbot-decline-title');
  const textEl = modal.querySelector('.bk-media-cartbot-decline-modal__text');
  const keepEl = modal.querySelector('[data-cartbot-decline-cancel].button');
  const removeEl = modal.querySelector('[data-cartbot-decline-confirm]');

  if (titleEl) titleEl.textContent = copy.title;
  if (textEl) textEl.textContent = copy.text;
  if (keepEl) keepEl.textContent = copy.keepLabel;
  if (removeEl) removeEl.textContent = copy.removeLabel;

  return new Promise((resolve) => {
    const cleanup = (result) => {
      modal.hidden = true;
      document.documentElement.classList.remove('bk-media-cartbot-decline-open');
      modal.removeEventListener('click', onClick);
      document.removeEventListener('keydown', onKeydown);
      resolve(result);
    };

    const onClick = (event) => {
      if (event.target.closest('[data-cartbot-decline-confirm]')) cleanup(true);
      else if (event.target.closest('[data-cartbot-decline-cancel]')) cleanup(false);
    };

    const onKeydown = (event) => {
      if (event.key === 'Escape') cleanup(false);
    };

    modal.addEventListener('click', onClick);
    document.addEventListener('keydown', onKeydown);
    modal.hidden = false;
    document.documentElement.classList.add('bk-media-cartbot-decline-open');
    modal.querySelector('[data-cartbot-decline-confirm]')?.focus();
  });
}

async function confirmBkMediaCartbotGiftRemoval(hint) {
  const goodie = resolveBkMediaGoodie(hint);
  const confirmed = await showBkMediaGoodieDeclineModal(goodie);
  if (!confirmed) return false;
  markBkMediaGoodieDeclined(goodie);
  bkMediaSyncGoodieRemovedAttribute(bkMediaLastKnownCart);
  return true;
}

async function bkMediaRefreshCartAfterGoodieMutation(cart) {
  const syncedCart = await bkMediaSyncGoodieRemovedAttribute(cart);
  const nextCart = await bkMediaNormalizeCart(syncedCart || cart, { ensureSections: true });
  snapshotBkMediaGoodieLineKeys(nextCart);
  syncBkMediaGoodieOfferRows(nextCart);
  await bkMediaDispatchCartChange(nextCart, 'bk-media-goodie:sync');
  return nextCart;
}

async function bkMediaRemoveDeclinedGoodieIfPresent(cartHint = null, { onlyNewLines = false } = {}) {
  if (!hasBkMediaDeclinedGoodie() || window.__bkMediaCartDrawerRemoving) return;

  try {
    const cart = cartHint?.items
      ? cartHint
      : await (await bkMediaGoodieFetch(`${window.Shopify.routes.root}cart.js`)).json();
    const goodieLines = onlyNewLines
      ? findBkMediaNewlyAddedDeclinedGoodieLines(cart)
      : findBkMediaDeclinedGoodieLines(cart);
    if (!goodieLines.length) {
      snapshotBkMediaGoodieLineKeys(cart);
      syncBkMediaGoodieOfferRows(cart);
      return;
    }

    const drawer = getBkMediaCartDrawerHansegruen();
    const sections = getBkMediaCartDrawerSectionsToBundle(drawer);
    let nextCart = cart;

    for (const line of goodieLines) {
      const body = {
        id: line.key,
        quantity: 0,
        sections_url: bkMediaCartSectionsUrl()
      };
      if (sections.length) body.sections = sections;
      const response = await bkMediaGoodieFetch(`${window.Shopify.routes.root}cart/change.js?bk-media-goodie=1`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body)
      });
      if (response.ok) nextCart = await response.json();
    }

    await bkMediaRefreshCartAfterGoodieMutation(nextCart);
  } catch (e) {
    console.error('Failed to keep declined goodie removed:', e);
  }
}

function bkMediaGoodieGroupKey(line) {
  const goodie = resolveBkMediaGoodie({
    variantId: line.variant_id || line.id,
    productId: line.product_id,
    handle: line.handle
  });
  return goodie?.id || String(line.variant_id || line.id);
}

function bkMediaCollectGoodieCapUpdates(cart) {
  const updates = {};
  const seen = new Set();

  findBkMediaGoodieLines(cart).forEach((line) => {
    if (!line?.key) return;
    const groupKey = bkMediaGoodieGroupKey(line);
    if (seen.has(groupKey)) {
      updates[line.key] = 0;
      return;
    }
    seen.add(groupKey);
    if ((Number(line.quantity) || 0) > 1) updates[line.key] = 1;
  });

  return updates;
}

async function bkMediaDedupKnownGoodieLines(cart) {
  const updates = bkMediaCollectGoodieCapUpdates(cart);
  if (!Object.keys(updates).length) return cart;

  const drawer = getBkMediaCartDrawerHansegruen();
  const sections = getBkMediaCartDrawerSectionsToBundle(drawer);
  const body = {
    updates,
    sections_url: bkMediaCartSectionsUrl()
  };
  if (sections.length) body.sections = sections;

  const response = await bkMediaGoodieFetch(`${window.Shopify.routes.root}cart/update.js?bk-media-goodie=1`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body)
  });
  if (!response.ok) return cart;
  return response.json();
}

async function bkMediaReconcileGoodies(cartHint = null) {
  if (window.__bkMediaGoodieReconcilePromise) return window.__bkMediaGoodieReconcilePromise;
  if (window.__bkMediaGoodieDeduping || window.__bkMediaCartDrawerRemoving) return cartHint;

  window.__bkMediaGoodieReconciling = true;
  window.__bkMediaGoodieReconcilePromise = (async () => {
    try {
      let cart = cartHint?.items
        ? cartHint
        : await (await bkMediaGoodieFetch(`${window.Shopify.routes.root}cart.js`)).json();

      bkMediaClearDeclinedAfterPaidAdd(cart);
      snapshotBkMediaGoodieLineKeys(cart);

      if ((Number(cart.item_count) || 0) === 0) {
        clearBkMediaGoodieDeclined();
        syncBkMediaGoodieOfferRows(cart);
        return bkMediaSyncGoodieRemovedAttribute(cart);
      }

      const capUpdates = bkMediaCollectGoodieCapUpdates(cart);
      if (Object.keys(capUpdates).length) {
        cart = await bkMediaDedupKnownGoodieLines(cart);
      }

      if (hasBkMediaDeclinedGoodie() && findBkMediaDeclinedGoodieLines(cart).length) {
        await bkMediaRemoveDeclinedGoodieIfPresent(cart, { onlyNewLines: false });
        return bkMediaLastKnownCart || cart;
      }

      if (Object.keys(capUpdates).length) {
        return bkMediaRefreshCartAfterGoodieMutation(cart);
      }

      syncBkMediaGoodieOfferRows(cart);
      return bkMediaSyncGoodieRemovedAttribute(cart);
    } catch (e) {
      console.error('Failed to reconcile free goodies:', e);
      return cartHint;
    } finally {
      window.__bkMediaGoodieReconciling = false;
      window.__bkMediaGoodieReconcilePromise = null;
    }
  })();

  return window.__bkMediaGoodieReconcilePromise;
}

function scheduleBkMediaGoodieCap(delay = 200) {
  scheduleBkMediaGoodieReconcile(delay);
}

function scheduleBkMediaGoodieReconcile(delay = 200) {
  if (bkMediaGoodieCapTimer) clearTimeout(bkMediaGoodieCapTimer);
  bkMediaGoodieCapTimer = setTimeout(() => {
    bkMediaReconcileGoodies();
  }, delay);
}

async function bkMediaAddGoodieToCart(goodie, { clearDeclined = false } = {}) {
  const runtime = getBkMediaGoodieRuntime(goodie);
  if (!runtime?.variantId) return null;
  if (clearDeclined) clearBkMediaGoodieDeclined(runtime);

  const drawer = getBkMediaCartDrawerHansegruen();
  const sections = getBkMediaCartDrawerSectionsToBundle(drawer);
  const body = {
    items: [{
      id: runtime.variantId,
      quantity: 1,
      properties: { _bk_media_goodie: runtime.id }
    }],
    sections_url: bkMediaCartSectionsUrl()
  };
  if (sections.length) body.sections = sections;

  const response = await bkMediaGoodieFetch(`${window.Shopify.routes.root}cart/add.js?bk-media-goodie=1`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body)
  });

  if (!response.ok) return null;

  const nextCart = await (await bkMediaGoodieFetch(`${window.Shopify.routes.root}cart.js`)).json();
  return bkMediaRefreshCartAfterGoodieMutation(nextCart);
}

function createBkMediaGoodieOfferRow(goodie) {
  const runtime = getBkMediaGoodieRuntime(goodie);
  if (!runtime) return null;

  const row = document.createElement('div');
  row.className = 'bk-media-goodie-offer';
  row.setAttribute('data-goodie-offer', runtime.id);
  row.setAttribute('data-goodie-handle', runtime.handle);
  row.setAttribute('data-variant-id', String(runtime.variantId));

  const safeTitle = String(runtime.title || '').replace(/[&<>"']/g, (char) => ({
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;'
  }[char]));
  const titleSpace = safeTitle.indexOf(' ');
  const titleHtml = titleSpace > 0
    ? `<span class="bk-media-goodie-offer__gratis">${safeTitle.slice(0, titleSpace)}</span> ${safeTitle.slice(titleSpace + 1)}`
    : safeTitle;

  const imageHtml = runtime.image
    ? `<div class="bk-media-goodie-offer__media"><img class="bk-media-goodie-offer__image" src="${runtime.image}" alt="${safeTitle.replace(/"/g, '&quot;')}" width="40" height="40" loading="lazy"></div>`
    : '';

  row.innerHTML = `
    ${imageHtml}
    <div class="bk-media-goodie-offer__info">
      <p class="bk-media-goodie-offer__title text-xs bold">${titleHtml}</p>
    </div>
    <button type="button" class="button button--sm bk-media-goodie-offer__add" data-goodie-offer-add data-goodie-id="${runtime.id}">
      ${runtime.addLabel}
    </button>
  `;

  return row;
}

function syncBkMediaGoodieOfferRows(cart) {
  if (getBkMediaGoodieSettings().showOfferRow !== true) {
    document.querySelectorAll('[data-goodie-offer]').forEach((row) => row.remove());
    return;
  }

  const drawer = getBkMediaCartDrawerHansegruen();
  if (!drawer) return;

  const host = drawer.querySelector('.bk-media-cart-drawer__scroll')
    || drawer.querySelector('.bk-media-cart-drawer__line-items')?.parentElement;
  if (!host) return;

  const hasPaid = getBkMediaPaidItemCount(cart) > 0;
  const shotglas = BK_MEDIA_GOODIES.find((item) => item.id === 'shotglas');
  const shouldShowShotglas = Boolean(hasPaid && shotglas && !cartHasBkMediaGoodie(cart, shotglas));
  let row = drawer.querySelector('[data-goodie-offer="shotglas"]');

  if (shouldShowShotglas) {
    if (!row) {
      row = createBkMediaGoodieOfferRow(shotglas);
      if (row) {
        const lineItems = drawer.querySelector('.bk-media-cart-drawer__line-items');
        if (lineItems) lineItems.insertAdjacentElement('afterend', row);
        else host.appendChild(row);
      }
    }
    if (row) row.hidden = false;
    return;
  }

  if (row) row.remove();
}

async function bkMediaEnsureAutoGoodies() {
  if (bkMediaGoodieEnsureInFlight || window.__bkMediaCartDrawerRemoving) return;

  const autoGoodies = BK_MEDIA_GOODIES.filter((goodie) => goodie.autoEnsure);
  if (!autoGoodies.length) return;

  bkMediaGoodieEnsureInFlight = true;

  try {
    let cart = await (await bkMediaGoodieFetch(`${window.Shopify.routes.root}cart.js`)).json();
    cart = await bkMediaDedupKnownGoodieLines(cart);
    snapshotBkMediaGoodieLineKeys(cart);
    syncBkMediaGoodieOfferRows(cart);

    if ((Number(cart.item_count) || 0) === 0) {
      clearBkMediaGoodieDeclined();
      return;
    }

    for (const goodie of autoGoodies) {
      if (isBkMediaGoodieDeclined(goodie) || cartHasBkMediaGoodie(cart, goodie)) continue;
      await bkMediaAddGoodieToCart(goodie);
      return;
    }
  } catch (e) {
    console.error('Failed to ensure free goodie:', e);
  } finally {
    bkMediaGoodieEnsureInFlight = false;
  }
}

function scheduleBkMediaGoodieEnsure(delay = 800) {
  if (bkMediaGoodieEnsureTimer) clearTimeout(bkMediaGoodieEnsureTimer);
  bkMediaGoodieEnsureTimer = setTimeout(() => {
    bkMediaEnsureAutoGoodies();
  }, delay);
}

async function bkMediaAddGoodieFromOffer(goodieId, button) {
  const goodie = BK_MEDIA_GOODIES.find((item) => item.id === goodieId);
  if (!goodie || window.__bkMediaGoodieAdding) return;

  window.__bkMediaGoodieAdding = true;
  if (button) button.setAttribute('aria-busy', 'true');

  try {
    const cart = await bkMediaAddGoodieToCart(goodie, { clearDeclined: true });
    if (!cart) throw new Error('Goodie add failed');
  } catch (e) {
    console.error('Failed to add free goodie:', e);
    if (button) button.removeAttribute('aria-busy');
  } finally {
    window.__bkMediaGoodieAdding = false;
  }
}

ensureBkMediaGoodieFetchGuard();
setTimeout(() => {
  ensureBkMediaGoodieFetchGuard();
}, 2000);

document.addEventListener('variant:add', (event) => {
  if (bkMediaEventAddsPaidProduct(event)) clearBkMediaGoodieDeclined();
  if (event.detail?.cart) snapshotBkMediaGoodieLineKeys(event.detail.cart);
  scheduleBkMediaGoodieReconcile(150);
});

document.addEventListener('cart:change', (event) => {
  if (window.__bkMediaGoodieAttrSyncing || window.__bkMediaGoodieDeduping || window.__bkMediaGoodieReconciling) return;

  if (event.detail?.baseEvent === 'bk-media-goodie:sync') {
    if (event.detail?.cart) snapshotBkMediaGoodieLineKeys(event.detail.cart);
    syncBkMediaGoodieOfferRows(event.detail?.cart);
    return;
  }

  const cart = event.detail?.cart;
  if (cart) {
    bkMediaClearDeclinedAfterPaidAdd(cart);
    snapshotBkMediaGoodieLineKeys(cart);
  }
  scheduleBkMediaGoodieReconcile(150);
});

document.addEventListener('DOMContentLoaded', () => {
  bkMediaReconcileGoodies();
});

window.addEventListener('pageshow', () => {
  scheduleBkMediaGoodieReconcile(50);
});

document.addEventListener('shopify:section:load', () => {
  scheduleBkMediaGoodieReconcile(100);
});

document.addEventListener('submit', async (event) => {
  const form = event.target;
  if (!(form instanceof HTMLFormElement) || !form.querySelector('[name="checkout"]')) return;
  if (form.getAttribute('data-bk-media-goodie-ready') === '1') return;

  event.preventDefault();
  event.stopPropagation();
  try {
    await bkMediaReconcileGoodies();
  } catch (e) {}
  form.setAttribute('data-bk-media-goodie-ready', '1');
  if (!form.querySelector('input[name="checkout"][data-bk-media-goodie-checkout]')) {
    const input = document.createElement('input');
    input.type = 'hidden';
    input.name = 'checkout';
    input.setAttribute('data-bk-media-goodie-checkout', 'true');
    form.appendChild(input);
  }
  form.submit();
}, true);

if (document.readyState !== 'loading') {
  bkMediaReconcileGoodies();
}

if (!window.__bkMediaGoodieOfferBound) {
  window.__bkMediaGoodieOfferBound = true;
  document.addEventListener('click', (event) => {
    const offerAdd = event.target.closest('[data-goodie-offer-add]');
    if (offerAdd) {
      event.preventDefault();
      event.stopPropagation();
      bkMediaAddGoodieFromOffer(offerAdd.getAttribute('data-goodie-id'), offerAdd);
      return;
    }

    const removeLink = event.target.closest('a[href*="/cart/change"]');
    if (!removeLink) return;
    const gift = removeLink.closest('[data-cartbot-gift="true"]');
    if (!gift || removeLink.closest('.bk-media-cart-drawer-card, [data-cart-drawer-remove]')) return;

    event.preventDefault();
    event.stopPropagation();
    const lineKey = gift.getAttribute('data-line-key');
    if (!lineKey) return;

    confirmBkMediaCartbotGiftRemoval({
      variantId: gift.getAttribute('data-variant-id'),
      productId: gift.getAttribute('data-product-id'),
      handle: gift.getAttribute('data-goodie-handle')
    }).then((confirmed) => {
      if (!confirmed) return;
      return bkMediaGoodieFetch(`${window.Shopify.routes.root}cart/change.js?bk-media-goodie=1`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: lineKey, quantity: 0 })
      }).then((response) => response.ok ? response.json() : null);
    }).then((cart) => {
      if (cart) return bkMediaRefreshCartAfterGoodieMutation(cart);
    }).catch(() => {});
  });
}
/* bk-media-gratis-goodie end */

async function bkMediaRemoveCartDrawerLine(lineKey, lineItemEl, { skipGiftConfirm = false } = {}) {
  if (!lineKey || window.__bkMediaCartDrawerRemoving) return;

  const drawer = getBkMediaCartDrawerHansegruen();
  if (!drawer) return;

  const card = lineItemEl?.closest('.bk-media-cart-drawer-card')
    || drawer.querySelector(`.bk-media-cart-drawer-card[data-line-key="${CSS.escape(lineKey)}"]`);
  const isGift = card?.getAttribute('data-cartbot-gift') === 'true';
  const isBundleParent = card?.getAttribute('data-bundle-parent') === 'true';
  const bundleLineKeys = (card?.getAttribute('data-bundle-line-keys') || '')
    .split(',')
    .map((key) => key.trim())
    .filter(Boolean);

  if (!skipGiftConfirm && isGift) {
    const confirmed = await confirmBkMediaCartbotGiftRemoval({
      variantId: card?.getAttribute('data-variant-id'),
      productId: card?.getAttribute('data-product-id'),
      handle: card?.getAttribute('data-goodie-handle')
    });
    if (!confirmed) return;
    return bkMediaRemoveCartDrawerLine(lineKey, lineItemEl, { skipGiftConfirm: true });
  }

  window.__bkMediaCartDrawerRemoving = true;
  lineItemEl?.dispatchEvent(new CustomEvent('line-item:will-change', {
    bubbles: true,
    detail: { targetQuantity: 0 }
  }));

  try {
    const sectionPayload = getBkMediaCartRequestSectionPayload(drawer);
    let cartContent;

    if (isBundleParent && bundleLineKeys.length > 1) {
      const updates = {};
      bundleLineKeys.forEach((key) => {
        updates[key] = 0;
      });
      updates[lineKey] = 0;

      const response = await fetch(`${window.Shopify.routes.root}cart/update.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          updates,
          sections: sectionPayload.sections,
          sections_url: sectionPayload.sections_url
        })
      });

      if (!response.ok) throw new Error('Failed to remove bundle from cart');
      cartContent = await response.json();
    } else {
      const removeUrl = isGift
        ? `${window.Shopify.routes.root}cart/change.js?bk-media-goodie=1`
        : `${window.Shopify.routes.root}cart/change.js`;
      const response = await fetch(removeUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          id: lineKey,
          quantity: 0,
          sections: sectionPayload.sections,
          sections_url: sectionPayload.sections_url
        })
      });

      if (!response.ok) throw new Error('Failed to remove item from cart');
      cartContent = await response.json();
    }

    const sectionId = sectionPayload.sections[0];
    if (!bkMediaCartSectionLooksValid(cartContent.sections?.[sectionId])) {
      await bkMediaEnsureCartSections(cartContent, sectionPayload.sections);
    }

    if (isGift) {
      cartContent = await bkMediaSyncGoodieRemovedAttribute(cartContent) || cartContent;
    }

    lineItemEl?.dispatchEvent(new CustomEvent('line-item:change', {
      bubbles: true,
      detail: {
        quantity: 0,
        cart: cartContent
      }
    }));

    document.documentElement.dispatchEvent(new CustomEvent('cart:change', {
      bubbles: true,
      detail: {
        baseEvent: 'line-item:change',
        cart: cartContent
      }
    }));

    if (cartContent.item_count === 0 && typeof drawer.hide === 'function') {
      drawer.hide();
    }
  } catch (error) {
    console.error('Failed to remove cart drawer line:', error);
    lineItemEl?.dispatchEvent(new CustomEvent('line-item:change', {
      bubbles: true,
      detail: { quantity: 1, cart: null }
    }));
  } finally {
    window.__bkMediaCartDrawerRemoving = false;
  }
}

function initBkMediaCartDrawerHansegruen() {
  const drawer = getBkMediaCartDrawerHansegruen();
  if (!drawer) return;

  setBkMediaCartDrawerTab(drawer, drawer.dataset.activeCartTab || 'cart');
}

function switchBkMediaCartDrawerToCartAfterRecommendationAdd(event) {
  const drawer = getBkMediaCartDrawerHansegruen();
  if (!drawer) return;

  const fromRecommendations = event?.target?.closest?.('[data-cart-drawer-panel="recommendations"], .bk-media-cart-drawer__recommendation');
  if (!fromRecommendations && drawer.dataset.activeCartTab !== 'recommendations') return;

  drawer.dataset.activeCartTab = 'cart';
  setBkMediaCartDrawerTab(drawer, 'cart');
}

if (!window.__bkMediaCartDrawerBound) {
  window.__bkMediaCartDrawerBound = true;

  document.addEventListener('click', (event) => {
    const drawer = event.target.closest('#cart-drawer.cart-drawer--hansegruen');
    if (!drawer) return;

    const cartPageLink = event.target.closest('a[href]');
    if (cartPageLink) {
      try {
        const url = new URL(cartPageLink.href, window.location.origin);
        const path = url.pathname.replace(/\/$/, '') || '/';
        const cartPath = `${window.Shopify.routes.root}cart`.replace(/\/$/, '');
        if (path === cartPath || path.endsWith('/cart')) {
          event.preventDefault();
          if (typeof drawer.show === 'function') {
            drawer.show();
          }
          return;
        }
      } catch (e) {
        // ignore invalid urls
      }
    }

    const tab = event.target.closest('[data-cart-drawer-tab]');
    if (tab) {
      event.preventDefault();
      setBkMediaCartDrawerTab(drawer, tab.dataset.cartDrawerTab);
      return;
    }

    const qtyButton = event.target.closest('[data-qty-step]');
    if (qtyButton) {
      event.preventDefault();
      const wrapper = qtyButton.closest('line-item-quantity');
      const input = wrapper?.querySelector('[data-line-key]');
      if (!input) return;

      const step = parseInt(qtyButton.dataset.qtyStep, 10);
      const max = input.max ? parseInt(input.max, 10) : Infinity;
      const current = parseInt(input.value, 10) || 0;
      const next = Math.max(0, Math.min(max, current + step));

      if (next === current) return;

      const card = qtyButton.closest('.bk-media-cart-drawer-card');
      const isGift = card?.getAttribute('data-cartbot-gift') === 'true'
        || qtyButton.closest('[data-cartbot-gift="true"]');

      if (isGift && step > 0 && current >= 1) return;

      if (next === 0 && isGift) {
        const lineItemEl = card?.querySelector('line-item');
        const lineKey = input.getAttribute('data-line-key') || card?.getAttribute('data-line-key');
        if (lineKey) {
          bkMediaRemoveCartDrawerLine(lineKey, lineItemEl);
        }
        return;
      }

      input.value = String(next);
      input.dispatchEvent(new Event('change', { bubbles: true }));
      return;
    }

    const removeControl = event.target.closest('[data-cart-drawer-remove], .bk-media-cart-drawer-card__remove, a[href*="/cart/change"]');
    if (removeControl) {
      event.preventDefault();
      event.stopPropagation();

      const card = removeControl.closest('.bk-media-cart-drawer-card');
      const lineItemEl = card?.querySelector('line-item');
      let lineKey = removeControl.getAttribute('data-line-key') || card?.getAttribute('data-line-key');

      if (!lineKey && removeControl.href) {
        try {
          lineKey = new URL(removeControl.href, window.location.origin).searchParams.get('id');
        } catch (e) {
          lineKey = null;
        }
      }

      if (!lineKey) {
        const input = lineItemEl?.querySelector('[data-line-key]');
        lineKey = input?.getAttribute('data-line-key');
      }

      if (lineKey) {
        bkMediaRemoveCartDrawerLine(lineKey, lineItemEl);
      }
    }
  });
}

document.addEventListener('DOMContentLoaded', initBkMediaCartDrawerHansegruen);
document.addEventListener('shopify:section:load', () => {
  setTimeout(initBkMediaCartDrawerHansegruen, 100);
});
document.addEventListener('variant:add', (event) => {
  switchBkMediaCartDrawerToCartAfterRecommendationAdd(event);
});
document.addEventListener('cart:change', (event) => {
  requestAnimationFrame(() => {
    if (event.detail?.baseEvent === 'variant:add') {
      const drawer = getBkMediaCartDrawerHansegruen();
      if (drawer) drawer.dataset.activeCartTab = 'cart';
    }

    initBkMediaCartDrawerHansegruen();

    const drawer = getBkMediaCartDrawerHansegruen();
    if (drawer && event.detail?.cart?.item_count === 0 && typeof drawer.hide === 'function') {
      drawer.hide();
    }
  });
});
document.addEventListener('dialog:after-show', (event) => {
  if (event.target?.id === 'cart-drawer') {
    initBkMediaCartDrawerHansegruen();
  }
});

/* bk-media-cart-drawer-hansegruen end */

/* bk-media-product-form-sections-url start */
(function () {
  function patchBkMediaProductFormSectionsUrl() {
    var ProductForm = customElements.get('product-form');
    if (!ProductForm || ProductForm.prototype.__bkMediaSectionsUrlPatched) return Boolean(ProductForm);

    var originalSubmit = ProductForm.prototype._onSubmit;

    ProductForm.prototype._onSubmit = async function patchedProductFormSubmit(event) {
      event.preventDefault();

      if (!this.checkValidity()) {
        this.reportValidity();
        return;
      }

      var submitButtons = Array.from(this.elements).filter(function (button) {
        return button.type === 'submit';
      });
      submitButtons.forEach(function (submitButton) {
        submitButton.setAttribute('disabled', 'disabled');
        submitButton.setAttribute('aria-busy', 'true');
      });

      var sectionsToBundle = ['variant-added'];
      document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections', {
        bubbles: true,
        detail: { sections: sectionsToBundle }
      }));

      var formData = new FormData(this);
      formData.set('sections', sectionsToBundle.join(','));
      formData.set('sections_url', bkMediaCartSectionsUrl());

      try {
        var response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
          body: formData,
          method: 'POST',
          headers: {
            'X-Requested-With': 'XMLHttpRequest'
          }
        });

        submitButtons.forEach(function (submitButton) {
          submitButton.removeAttribute('disabled');
          submitButton.removeAttribute('aria-busy');
        });

        var responseJson = await response.json();

        if (response.ok) {
          if (window.themeVariables.settings.cartType === 'page' || window.themeVariables.settings.pageType === 'cart') {
            window.location.href = window.Shopify.routes.root + 'cart';
            return;
          }

          var cartContent = await (await fetch(window.Shopify.routes.root + 'cart.js')).json();
          cartContent.sections = Object.assign({}, cartContent.sections || {}, responseJson.sections || {});

          var sectionId = getBkMediaCartDrawerSectionId();
          if (sectionId && !bkMediaCartSectionLooksValid(cartContent.sections[sectionId])) {
            await bkMediaEnsureCartSections(cartContent, [sectionId]);
          }

          this.dispatchEvent(new CustomEvent('variant:add', {
            bubbles: true,
            detail: {
              items: responseJson.hasOwnProperty('items') ? responseJson.items : [responseJson],
              cart: cartContent
            }
          }));

          document.documentElement.dispatchEvent(new CustomEvent('cart:change', {
            bubbles: true,
            detail: {
              baseEvent: 'variant:add',
              cart: cartContent
            }
          }));
        } else {
          this.dispatchEvent(new CustomEvent('cart:error', {
            bubbles: true,
            detail: {
              error: responseJson.description
            }
          }));
          document.dispatchEvent(new CustomEvent('cart:refresh'));
        }
      } catch (error) {
        submitButtons.forEach(function (submitButton) {
          submitButton.removeAttribute('disabled');
          submitButton.removeAttribute('aria-busy');
        });
        console.error('Add to cart failed:', error);
      }
    };

    document.querySelectorAll('form[is="product-form"]').forEach(function (form) {
      form.removeEventListener('submit', originalSubmit);
      form.addEventListener('submit', ProductForm.prototype._onSubmit);
    });

    ProductForm.prototype.__bkMediaSectionsUrlPatched = true;
    return true;
  }

  function initBkMediaProductFormSectionsUrl() {
    if (!patchBkMediaProductFormSectionsUrl()) {
      var attempts = 0;
      var timer = setInterval(function () {
        attempts += 1;
        if (patchBkMediaProductFormSectionsUrl() || attempts > 40) clearInterval(timer);
      }, 50);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initBkMediaProductFormSectionsUrl, { once: true });
  } else {
    initBkMediaProductFormSectionsUrl();
  }

  document.addEventListener('shopify:section:load', function () {
    setTimeout(initBkMediaProductFormSectionsUrl, 0);
  });
})();
/* bk-media-product-form-sections-url end */

/* bk-media-gift-card-gallery start */
(function () {
  var patched = false;
  var warmedGalleries = new WeakSet();

  function parseVariantMediaMap(gallery) {
    var script = gallery.querySelector('[data-bk-gift-card-variant-media]');
    if (!script) return {};
    try {
      return JSON.parse(script.textContent);
    } catch (error) {
      return {};
    }
  }

  function collectFeaturedMediaIds(variantMediaMap) {
    var ids = new Set();
    Object.keys(variantMediaMap).forEach(function (variantId) {
      var mediaId = variantMediaMap[variantId];
      if (mediaId != null) ids.add(String(mediaId));
    });
    return ids;
  }

  function warmGiftCardImages(gallery) {
    if (!gallery || warmedGalleries.has(gallery)) return;
    warmedGalleries.add(gallery);

    var run = function () {
      gallery.querySelectorAll('.product-gallery__media[data-media-type="image"] img').forEach(function (img) {
        if (!img.getAttribute('src') && !img.getAttribute('srcset')) return;
        img.loading = 'eager';
        if (typeof img.decode === 'function') {
          img.decode().catch(function () {});
        }
        if (!img.complete) {
          var warmer = new Image();
          warmer.decoding = 'async';
          if (img.currentSrc) warmer.src = img.currentSrc;
          else if (img.src) warmer.src = img.src;
        }
      });
    };

    if ('requestIdleCallback' in window) {
      window.requestIdleCallback(run, { timeout: 1200 });
    } else {
      setTimeout(run, 200);
    }
  }

  function prepareSlideImage(gallery, mediaId) {
    if (!mediaId) return null;
    var slide = gallery.querySelector('.product-gallery__media[data-media-id="' + mediaId + '"]');
    if (!slide) return null;
    var img = slide.querySelector('img');
    if (img) {
      img.loading = 'eager';
      img.fetchPriority = 'high';
      if (typeof img.decode === 'function') {
        img.decode().catch(function () {});
      }
    }
    return slide;
  }

  function getGiftCardFilteredIndexes(gallery, product, variant) {
    var variantMediaMap = parseVariantMediaMap(gallery);
    var featuredIds = collectFeaturedMediaIds(variantMediaMap);
    var currentFeaturedId = variant && variant.featured_media ? String(variant.featured_media.id) : null;
    var filteredIndexes = [];

    (product.media || []).forEach(function (media, index) {
      var mediaId = String(media.id);
      if (featuredIds.has(mediaId) && mediaId !== currentFeaturedId) {
        filteredIndexes.push(index);
      }
    });

    return filteredIndexes;
  }

  function patchProductGallery() {
    var ProductGallery = customElements.get('product-gallery');
    if (!ProductGallery || patched) return !!ProductGallery;
    patched = true;

    var originalGetFiltered = ProductGallery.prototype._getFilteredMediaIndexes;
    var originalOnVariantChanged = ProductGallery.prototype._onVariantChanged;

    ProductGallery.prototype._getFilteredMediaIndexes = function (product, variant) {
      var filtered = originalGetFiltered.call(this, product, variant) || [];
      if (!this.hasAttribute('data-bk-gift-card-gallery')) return filtered;

      var giftCardFiltered = getGiftCardFilteredIndexes(this, product, variant);
      giftCardFiltered.forEach(function (index) {
        if (filtered.indexOf(index) === -1) filtered.push(index);
      });
      return filtered;
    };

    ProductGallery.prototype._onVariantChanged = function (event) {
      if (this.hasAttribute('data-bk-gift-card-gallery') && event.detail && event.detail.variant) {
        prepareSlideImage(this, event.detail.variant.featured_media && event.detail.variant.featured_media.id);
      }
      originalOnVariantChanged.call(this, event);
    };

    return true;
  }

  function bindOptionHoverPreload(gallery) {
    if (!gallery || gallery.dataset.bkGiftCardHoverBound === 'true') return;
    gallery.dataset.bkGiftCardHoverBound = 'true';

    var formId = gallery.getAttribute('form');
    if (!formId) return;
    var picker = document.querySelector('variant-picker[form="' + formId + '"]');
    if (!picker) return;

    picker.addEventListener(
      'pointerover',
      function () {
        warmGiftCardImages(gallery);
      },
      { passive: true, once: true }
    );
  }

  function initGiftCardGalleries() {
    if (!patchProductGallery()) {
      var attempts = 0;
      var timer = setInterval(function () {
        attempts += 1;
        if (patchProductGallery() || attempts > 40) clearInterval(timer);
      }, 50);
    }

    document.querySelectorAll('product-gallery[data-bk-gift-card-gallery]').forEach(function (gallery) {
      warmGiftCardImages(gallery);
      bindOptionHoverPreload(gallery);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initGiftCardGalleries, { once: true });
  } else {
    initGiftCardGalleries();
  }

  document.addEventListener('shopify:section:load', function () {
    setTimeout(initGiftCardGalleries, 0);
  });
})();
/* bk-media-gift-card-gallery end */

/* bk-media-cart-line-discount-badges start */

function bkMediaEscapeHtml(value) {
  return String(value ?? '')
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;');
}

function bkMediaGetCartLineBundleId(lineItem) {
  const props = lineItem?.properties || {};
  return props._BundleId || props['Bundle Id'] || '';
}

function bkMediaPushDiscountTitle(titles, seen, title) {
  const trimmed = (title || '').trim();
  if (!trimmed) return;
  const key = trimmed.toUpperCase();
  if (seen.has(key)) return;
  seen.add(key);
  titles.push(trimmed);
}

function bkMediaGetLineDiscountTitlesFromItem(lineItem) {
  const titles = [];
  const seen = new Set();

  (lineItem?.line_level_discount_allocations || []).forEach((allocation) => {
    bkMediaPushDiscountTitle(titles, seen, allocation?.discount_application?.title || allocation?.title);
  });

  (lineItem?.discounts || []).forEach((discount) => {
    bkMediaPushDiscountTitle(titles, seen, discount?.title);
  });

  return titles;
}

function bkMediaGetDiscountTitlesForDrawerCard(card, cart) {
  const lineKey = card?.dataset?.lineKey;
  const cartLine = (cart?.items || []).find((item) => item.key === lineKey);
  if (!cartLine) return [];

  const titles = [];
  const seen = new Set();
  const pushFromLine = (line) => {
    bkMediaGetLineDiscountTitlesFromItem(line).forEach((title) => {
      bkMediaPushDiscountTitle(titles, seen, title);
    });
  };

  pushFromLine(cartLine);

  const bundleId = card.dataset.bundleId || bkMediaGetCartLineBundleId(cartLine);
  if (card.dataset.bundleParent === 'true' && bundleId) {
    (cart.items || []).forEach((line) => {
      if (bkMediaGetCartLineBundleId(line) === bundleId) {
        pushFromLine(line);
      }
    });
  }

  if (titles.length === 0) {
    let lineDiscounted = cartLine.original_line_price > cartLine.final_line_price;

    if (!lineDiscounted && card.dataset.bundleParent === 'true' && bundleId) {
      lineDiscounted = (cart.items || []).some((line) => (
        bkMediaGetCartLineBundleId(line) === bundleId
        && line.original_line_price > line.final_line_price
      ));
    }

    if (lineDiscounted) {
      (cart.cart_level_discount_applications || []).forEach((application) => {
        bkMediaPushDiscountTitle(titles, seen, application?.title);
      });
    }
  }

  return titles;
}

function bkMediaRenderLineDiscountBadge(title) {
  return `
    <span class="badge discount-badge">
      <svg role="presentation" fill="none" focusable="false" stroke-width="1.5" width="14" height="13" class="icon icon-discount" viewBox="0 0 14 13">
        <path d="M7.25 11.383a1.74 1.74 0 0 0 2.195.105c.478-.35.957-.722 1.39-1.155.433-.433.804-.912 1.154-1.39.486-.662.45-1.588-.104-2.195a65.945 65.945 0 0 0-4.97-4.896 1.588 1.588 0 0 0-.75-.377c-1.017-.197-3.552-.613-4.177.012-.625.624-.208 3.16-.011 4.176.055.28.186.537.376.75a65.976 65.976 0 0 0 4.896 4.97Z" fill="none" stroke="currentColor"></path>
        <path d="M5.729 5.227a1.036 1.036 0 1 0-1.466-1.466 1.036 1.036 0 0 0 1.466 1.466Z" fill="currentColor"></path>
      </svg>
      <span>${bkMediaEscapeHtml(title)}</span>
    </span>
  `;
}

function syncBkMediaLineItemDiscountBadges(drawer, cart) {
  if (!drawer || drawer.getAttribute('data-show-line-discount-badges') !== 'true') return;
  if (!cart?.items?.length) return;

  drawer.querySelectorAll('.bk-media-cart-drawer-card[data-line-key]').forEach((card) => {
    const titles = bkMediaGetDiscountTitlesForDrawerCard(card, cart);
    const pricing = card.querySelector('.bk-media-cart-drawer-card__pricing');
    if (!pricing) return;

    let container = pricing.querySelector('.bk-media-cart-drawer-card__line-discounts');

    if (!titles.length) {
      container?.remove();
      return;
    }

    const html = titles.map((title) => bkMediaRenderLineDiscountBadge(title)).join('');

    if (!container) {
      container = document.createElement('div');
      container.className = 'bk-media-cart-drawer-card__line-discounts';
      pricing.appendChild(container);
    }

    container.innerHTML = html;
  });
}

async function syncBkMediaLineItemDiscountBadgesFromCart(drawer, cart) {
  if (!drawer || drawer.getAttribute('data-show-line-discount-badges') !== 'true') return;

  let nextCart = cart;
  if (!nextCart?.items) {
    try {
      nextCart = await (await fetch(`${window.Shopify.routes.root}cart.js`)).json();
    } catch (error) {
      return;
    }
  }

  syncBkMediaLineItemDiscountBadges(drawer, nextCart);
}

window.syncBkMediaLineItemDiscountBadges = syncBkMediaLineItemDiscountBadges;
window.syncBkMediaLineItemDiscountBadgesFromCart = syncBkMediaLineItemDiscountBadgesFromCart;

/* bk-media-cart-line-discount-badges end */

/* bk-media-cart-discount start */

class CartDiscount extends HTMLElement {
  connectedCallback() {
    if (this._bound) return;
    this._bound = true;
    this.isLoading = false;
    this.isRemoving = false;

    this.form = this.querySelector('.cart-discount__form');
    this.input = this.querySelector('.cart-discount__input');
    this.submitButton = this.querySelector('.cart-discount__button');
    this.errorContainer = this.querySelector('.cart-discount__error');
    this.errorText = this.querySelector('.cart-discount__error-text');
    this.codesContainer = this.querySelector('.cart-discount__codes');

    this.form?.addEventListener('submit', (event) => {
      event.preventDefault();
      event.stopPropagation();
      this.handleSubmit(event);
    });

    this.submitButton?.addEventListener('click', (event) => {
      event.preventDefault();
      this.handleSubmit(event);
    });

    this.input?.addEventListener('keydown', (event) => {
      if (event.key !== 'Enter') return;
      event.preventDefault();
      this.handleSubmit(event);
    });

    this.addEventListener('click', (event) => {
      const removeButton = event.target.closest('.discount-remove-btn');
      if (!removeButton || !this.contains(removeButton)) return;
      event.preventDefault();
      event.stopPropagation();
      this.handleRemoveDiscount(removeButton);
    });

    this._onCartChange = (event) => {
      this.syncBadgesFromCart(event?.detail?.cart);
    };
    document.addEventListener('cart:change', this._onCartChange);

    this.syncBadgesFromCart(null);
  }

  disconnectedCallback() {
    if (this._onCartChange) {
      document.removeEventListener('cart:change', this._onCartChange);
    }
  }

  getDiscountStrings() {
    return {
      invalid: this.dataset.msgInvalid || 'Der Rabattcode ist ungültig.',
      notCombinable: this.dataset.msgNotCombinable || 'Dieser Rabattcode kann nicht kombiniert werden.',
      checkoutOnly: this.dataset.msgCheckoutOnly || 'Dieser Rabattcode muss beim Bezahlen eingegeben werden.',
      generic: this.dataset.msgGeneric || 'Der Rabattcode konnte nicht angewendet werden.'
    };
  }

  getDiscountErrorMessage(apiMessage, code) {
    const strings = this.getDiscountStrings();
    const normalized = (apiMessage || '').toLowerCase().trim();

    if (normalized.includes('checkout')) return strings.checkoutOnly;

    if (
      normalized.includes('not valid') ||
      normalized.includes('invalid') ||
      normalized.includes('ungültig') ||
      normalized.includes('does not exist') ||
      normalized.includes('could not be found')
    ) {
      return strings.invalid.replace(/\{\{\s*code\s*\}\}/g, code);
    }

    if (
      normalized.includes('combine') ||
      normalized.includes('combin') ||
      normalized.includes('already applied') ||
      normalized.includes('cannot be used')
    ) {
      return strings.notCombinable;
    }

    return apiMessage ? strings.invalid.replace(/\{\{\s*code\s*\}\}/g, code) : strings.generic;
  }

  showDiscountError(message) {
    if (this.errorText) this.errorText.textContent = message;
    this.errorContainer?.classList.remove('cart-discount__error--hidden');
    this.input?.classList.add('cart-discount__input--error');
    this.input?.classList.remove('cart-discount__input--success');
  }

  hideDiscountError() {
    this.errorContainer?.classList.add('cart-discount__error--hidden');
    if (this.errorText) this.errorText.textContent = '';
    this.input?.classList.remove('cart-discount__input--error');
  }

  setLoading(loading) {
    this.isLoading = loading;
    if (!this.submitButton) return;

    this.submitButton.disabled = loading;
    if (loading) {
      this.submitButton.setAttribute('aria-busy', 'true');
    } else {
      this.submitButton.removeAttribute('aria-busy');
    }
  }

  escapeHtml(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  showDiscountAppliedAnnouncement(code) {
    document.querySelectorAll('.bk-media-discount-toast').forEach((toast) => toast.remove());

    const template = this.dataset.msgApplied || 'Höchster Rabatt: Code "{code}" wurde angewendet.';
    const message = template.replace(/\{code\}/gi, `<strong>${this.escapeHtml(code)}</strong>`);

    const toast = document.createElement('div');
    toast.className = 'bk-media-discount-toast';
    toast.setAttribute('role', 'status');
    toast.setAttribute('aria-live', 'polite');
    toast.innerHTML = `<span class="bk-media-discount-toast__text">${message}</span>`;
    document.body.appendChild(toast);

    requestAnimationFrame(() => {
      toast.classList.add('is-visible');
    });

    window.clearTimeout(this._toastTimeout);
    this._toastTimeout = window.setTimeout(() => {
      toast.classList.remove('is-visible');
      window.setTimeout(() => toast.remove(), 350);
    }, 3500);
  }

  getAppliedCodesFromCart(cart) {
    const codes = [];
    const seen = new Set();

    const pushCode = (code) => {
      const trimmed = (code || '').trim();
      if (!trimmed) return;
      const key = trimmed.toUpperCase();
      if (seen.has(key)) return;
      seen.add(key);
      codes.push(trimmed);
    };

    (cart?.discount_codes || []).forEach((entry) => {
      if (entry?.applicable === false) return;
      pushCode(entry?.code);
    });

    (cart?.cart_level_discount_applications || []).forEach((application) => {
      if (application?.type === 'discount_code') {
        pushCode(application.title);
      }
    });

    (cart?.items || []).forEach((item) => {
      (item.line_level_discount_allocations || []).forEach((allocation) => {
        const application = allocation?.discount_application;
        if (application?.type === 'discount_code') {
          pushCode(application.title);
        }
      });

      (item.discounts || []).forEach((discount) => {
        pushCode(discount?.title);
      });
    });

    return codes;
  }

  renderDiscountBadge(code) {
    return `
      <div class="badge discount-badge" data-discount-code="${this.escapeHtml(code)}">
        <svg role="presentation" fill="none" focusable="false" stroke-width="1.5" width="14" height="13" class="icon icon-discount" viewBox="0 0 14 13">
          <path d="M7.25 11.383a1.74 1.74 0 0 0 2.195.105c.478-.35.957-.722 1.39-1.155.433-.433.804-.912 1.154-1.39.486-.662.45-1.588-.104-2.195a65.945 65.945 0 0 0-4.97-4.896 1.588 1.588 0 0 0-.75-.377c-1.017-.197-3.552-.613-4.177.012-.625.624-.208 3.16-.011 4.176.055.28.186.537.376.75a65.976 65.976 0 0 0 4.896 4.97Z" fill="none" stroke="currentColor"></path>
          <path d="M5.729 5.227a1.036 1.036 0 1 0-1.466-1.466 1.036 1.036 0 0 0 1.466 1.466Z" fill="currentColor"></path>
        </svg>
        <span>${this.escapeHtml(code)}</span>
        <button type="button" class="discount-remove-btn" aria-label="Rabatt entfernen" title="Rabatt entfernen">
          <span class="discount-remove-icon" aria-hidden="true">×</span>
        </button>
      </div>
    `;
  }

  syncBadges(codes) {
    if (!this.codesContainer) {
      this.codesContainer = this.querySelector('.cart-discount__codes');
    }
    if (!this.codesContainer) return;

    const nextCodes = Array.isArray(codes) ? codes.filter(Boolean) : [];
    this.codesContainer.innerHTML = nextCodes.map((code) => this.renderDiscountBadge(code)).join('');
    this.codesContainer.hidden = nextCodes.length === 0;
  }

  async syncBadgesFromCart(cart) {
    try {
      let nextCart = cart;
      if (!nextCart || (!nextCart.discount_codes && !nextCart.cart_level_discount_applications)) {
        nextCart = await (await fetch(`${window.Shopify.routes.root}cart.js`)).json();
      }
      this.syncBadges(this.getAppliedCodesFromCart(nextCart));
      const drawer = document.getElementById('cart-drawer');
      syncBkMediaLineItemDiscountBadges(drawer, nextCart);
    } catch (error) {
      console.error('Failed to sync discount badges:', error);
    }
  }

  async handleRemoveDiscount(button) {
    if (this.isRemoving || this.isLoading) return;

    const badge = button.closest('.discount-badge');
    const discountCode = badge?.dataset.discountCode;
    if (!discountCode) return;

    this.isRemoving = true;
    button.disabled = true;
    button.style.opacity = '0.6';

    try {
      const sectionsToBundle = this.getSectionsToBundle();
      const currentCart = await (await fetch(`${window.Shopify.routes.root}cart.js`)).json();
      const remainingCodes = (currentCart.discount_codes || [])
        .map((entry) => entry.code)
        .filter((code) => code && code.toUpperCase() !== discountCode.toUpperCase());

      const response = await fetch(`${window.Shopify.routes.root}cart/update.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          discount: remainingCodes.join(','),
          sections: sectionsToBundle
        })
      });

      if (!response.ok) {
        throw new Error(`HTTP ${response.status}: Failed to remove discount`);
      }

      let cartData = await response.json();
      cartData = await this.ensureSections(cartData, sectionsToBundle);

      this.syncBadges(this.getAppliedCodesFromCart(cartData));
      await this.dispatchCartChange(cartData, 'discount:remove');
    } catch (error) {
      console.error('Failed to remove discount:', error);
      button.disabled = false;
      button.style.opacity = '1';
      await this.syncBadgesFromCart(null);
    } finally {
      this.isRemoving = false;
    }
  }

  getSectionsToBundle() {
    const sectionsToBundle = [];
    document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections', {
      bubbles: true,
      detail: { sections: sectionsToBundle }
    }));

    if (sectionsToBundle.length === 0) {
      const cartDrawer = document.getElementById('cart-drawer');
      const sectionId = cartDrawer?.closest('.shopify-section')?.id?.replace('shopify-section-', '')
        || this.dataset.sectionId
        || 'cart-drawer';
      sectionsToBundle.push(sectionId);
    }

    return sectionsToBundle;
  }

  isDiscountCodeApplied(cartData, discountCode) {
    const normalizedCode = discountCode.toUpperCase();
    const codeEntry = (cartData.discount_codes || []).find(
      (entry) => (entry.code || '').toUpperCase() === normalizedCode
    );

    if (codeEntry) return codeEntry.applicable === true;

    return (cartData.cart_level_discount_applications || []).some(
      (application) => application.type === 'discount_code' && (application.title || '').toUpperCase() === normalizedCode
    );
  }

  async dispatchCartChange(cartData, baseEvent) {
    if (typeof window.bkMediaDispatchCartChange === 'function') {
      await window.bkMediaDispatchCartChange(cartData, baseEvent);
      return;
    }

    document.documentElement.dispatchEvent(new CustomEvent('cart:change', {
      bubbles: true,
      detail: {
        baseEvent,
        cart: cartData
      }
    }));
  }

  async ensureSections(cartData, sectionsToBundle) {
    if (!cartData.sections) cartData.sections = {};

    for (const sectionId of sectionsToBundle) {
      if (cartData.sections[sectionId] && bkMediaCartSectionLooksValid(cartData.sections[sectionId], cartData.item_count)) continue;

      const response = await fetch(bkMediaCartSectionRequestUrl(sectionId));
      if (!response.ok) continue;
      const html = await response.text();
      if (!cartData.sections[sectionId] || bkMediaCartSectionLooksValid(html, cartData.item_count)) {
        cartData.sections[sectionId] = html;
      }
    }

    return cartData;
  }

  async handleSubmit(event) {
    event.preventDefault();
    if (!this.input || this.isLoading) return;

    const discountCode = this.input.value.trim();
    if (!discountCode) return;

    this.setLoading(true);
    this.hideDiscountError();
    this.input.classList.remove('cart-discount__input--success');

    try {
      const sectionsToBundle = this.getSectionsToBundle();
      const currentCart = await (await fetch(`${window.Shopify.routes.root}cart.js`)).json();
      const existingCodes = (currentCart.discount_codes || [])
        .map((entry) => entry.code)
        .filter(Boolean);

      const alreadyPresent = existingCodes.some(
        (code) => code.toUpperCase() === discountCode.toUpperCase()
      );

      const discountPayload = alreadyPresent
        ? existingCodes.join(',')
        : [...existingCodes, discountCode].join(',');

      const response = await fetch(`${window.Shopify.routes.root}cart/update.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          discount: discountPayload,
          sections: sectionsToBundle
        })
      });

      let cartData = await response.json();

      if (!response.ok) {
        this.showDiscountError(this.getDiscountErrorMessage(cartData.description || cartData.message, discountCode));
        return;
      }

      if (!this.isDiscountCodeApplied(cartData, discountCode)) {
        const codeEntry = (cartData.discount_codes || []).find(
          (entry) => (entry.code || '').toUpperCase() === discountCode.toUpperCase()
        );

        if (codeEntry && codeEntry.applicable === false) {
          this.showDiscountError(this.getDiscountStrings().notCombinable);
        } else {
          this.showDiscountError(this.getDiscountErrorMessage(null, discountCode));
        }
        return;
      }

      cartData = await this.ensureSections(cartData, sectionsToBundle);
      this.input.value = '';
      this.input.classList.add('cart-discount__input--success');
      this.syncBadges(this.getAppliedCodesFromCart(cartData));
      this.showDiscountAppliedAnnouncement(discountCode);
      await this.dispatchCartChange(cartData, 'discount:apply');
    } catch (error) {
      console.error('Failed to apply discount:', error);
      this.showDiscountError(this.getDiscountErrorMessage(null, discountCode));
    } finally {
      this.setLoading(false);
    }
  }
}

if (!window.customElements.get('cart-discount-component')) {
  window.customElements.define('cart-discount-component', CartDiscount);
}

if (!window.customElements.get('bk-media-price-savings')) {
  class BkMediaPriceSavings extends HTMLElement {
    constructor() {
      super();
      this._onVariantChanged = this._onVariantChanged.bind(this);
    }

    connectedCallback() {
      const formId = this.getAttribute('form');
      if (!formId) return;
      document.forms[formId]?.addEventListener('variant:change', this._onVariantChanged);
    }

    disconnectedCallback() {
      const formId = this.getAttribute('form');
      if (!formId) return;
      document.forms[formId]?.removeEventListener('variant:change', this._onVariantChanged);
    }

    _onVariantChanged(event) {
      const variant = event.detail.variant;
      if (!variant) return;
      const compare = variant.compare_at_price;
      const price = variant.price;
      if (compare > price) {
        this.hidden = false;
        this.textContent = '-' + Math.round((compare - price) * 100 / compare) + '%';
      } else {
        this.hidden = true;
      }
    }
  }

  window.customElements.define('bk-media-price-savings', BkMediaPriceSavings);
}

if (!window.__bkMediaCartDiscountSubmitBound) {
  window.__bkMediaCartDiscountSubmitBound = true;
  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !form.classList.contains('cart-discount__form')) return;
    event.preventDefault();
    event.stopPropagation();
  }, true);
}

/* bk-media-cart-discount end */